var TagalysCustomisations = window.TagalysCustomisations || {};


/* =========================================================
   THREADBARE SEARCH GENDER SCOPE

   Tagalys confirmed the scope IDs for this integration are:
   - women
   - men

   SearchSuggestions expects:
   params.sections.products.scope

   SearchResults expects:
   params.scope
   ========================================================= */

TagalysCustomisations.searchGenderStorageKey =
  "threadbare_search_gender_v2";

TagalysCustomisations.searchResetStorageKey =
  "threadbare_search_reset_after_submit";

TagalysCustomisations.normaliseSearchGender =
  function (gender) {
    gender = String(gender || "")
      .trim()
      .toLowerCase();

    if (
      gender === "men" ||
      gender === "mens" ||
      gender === "male"
    ) {
      return "men";
    }

    if (
      gender === "women" ||
      gender === "womens" ||
      gender === "female"
    ) {
      return "women";
    }

    return "all";
  };

TagalysCustomisations.getStoredSearchGender =
  function () {
    var gender = "";

    try {
      gender = window.sessionStorage
        ? sessionStorage.getItem(
            TagalysCustomisations
              .searchGenderStorageKey
          )
        : "";
    } catch (error) {
      gender = "";
    }

    return TagalysCustomisations
      .normaliseSearchGender(
        gender || "all"
      );
  };

TagalysCustomisations.clearSearchInputs =
  function () {
    document
      .querySelectorAll(
        "predictive-search[data-context] [data-search-input]"
      )
      .forEach(function (input) {
        input.value = "";
      });
  };

/* Keep restored/bfcache form values from bringing back the last submitted
 * predictive query on the search results page. */
window.addEventListener("pageshow", function () {
  var params = new URLSearchParams(window.location.search);
  var isSearchResultsPage =
    window.location.pathname.indexOf("/search") !== -1 &&
    (params.has("q") || params.has("query"));

  if (isSearchResultsPage) {
    TagalysCustomisations.clearSearchInputs();

    window.requestAnimationFrame(function () {
      TagalysCustomisations.clearSearchInputs();
    });
  }
});

TagalysCustomisations.markSearchResetAfterSubmit =
  function () {
    try {
      if (window.sessionStorage) {
        sessionStorage.setItem(
          TagalysCustomisations
            .searchResetStorageKey,
          "1"
        );
      }
    } catch (error) {
      // Ignore storage errors.
    }
  };

TagalysCustomisations.consumeSearchResetAfterSubmit =
  function () {
    var shouldReset = false;

    try {
      if (window.sessionStorage) {
        shouldReset =
          sessionStorage.getItem(
            TagalysCustomisations
              .searchResetStorageKey
          ) === "1";

        if (shouldReset) {
          sessionStorage.removeItem(
            TagalysCustomisations
              .searchResetStorageKey
          );
        }
      }
    } catch (error) {
      shouldReset = false;
    }

    return shouldReset;
  };

TagalysCustomisations.setStoredSearchGender =
  function (gender) {
    gender = TagalysCustomisations
      .normaliseSearchGender(gender);

    try {
      if (window.sessionStorage) {
        sessionStorage.setItem(
          TagalysCustomisations
            .searchGenderStorageKey,
          gender
        );
      }
    } catch (error) {
      // Storage can be unavailable in some browsers.
    }

    TagalysCustomisations.selectedGender =
      gender;

    return gender;
  };

TagalysCustomisations.selectedGender =
  TagalysCustomisations
    .getStoredSearchGender();

TagalysCustomisations.getGenderScopeValues =
  function (gender) {
    gender = TagalysCustomisations
      .normaliseSearchGender(gender);

    /*
     * "all" means no gender scope at all.
     * Tagalys confirmed the actual scope IDs are lowercase "men" / "women".
     */
    if (gender === "all") {
      return [];
    }

    return [gender];
  };

TagalysCustomisations.getShopifyGenderFilterValue =
  function (gender) {
    gender = TagalysCustomisations
      .normaliseSearchGender(gender);

    if (gender === "men") {
      return "filter.p.m.custom.gender-Men";
    }

    if (gender === "women") {
      return "filter.p.m.custom.gender-Women";
    }

    return "";
  };

TagalysCustomisations.syncShopifyGenderFilterInURL =
  function (gender) {
    var genderFilter =
      TagalysCustomisations
        .getShopifyGenderFilterValue(
          gender
        );

    try {
      var url = new URL(
        window.location.href
      );

      /*
       * ShopifySearchResults represents storefront filters as repeatable
       * `filter` query-string values. Preserve every non-gender filter while
       * replacing only Threadbare's custom gender metafield filter.
       *
       * Examples observed on this storefront:
       *   filter=filter.p.m.custom.gender-Men
       *   filter=filter.p.m.custom.gender-Women
       */
      var existingFilters =
        url.searchParams.getAll(
          "filter"
        );

      url.searchParams.delete(
        "filter"
      );

      existingFilters.forEach(
        function (filterValue) {
          if (
            !/^filter\.p\.m\.custom\.gender-(Men|Women)$/i.test(
              String(filterValue)
            )
          ) {
            url.searchParams.append(
              "filter",
              filterValue
            );
          }
        }
      );

      if (genderFilter) {
        url.searchParams.append(
          "filter",
          genderFilter
        );
      }

      window.history.replaceState(
        window.history.state,
        "",
        url.toString()
      );
    } catch (error) {
      console.warn(
        "[Tagalys] Unable to sync Shopify gender filter URL.",
        error
      );
    }
  };

TagalysCustomisations.getSelectedGenderValue =
  function (wrapper) {
    var root =
      wrapper && wrapper.querySelector
        ? wrapper
        : document;

    var checked = root.querySelector(
      'input[name="selectGender"]:checked'
    );

    if (checked) {
      return TagalysCustomisations
        .normaliseSearchGender(
          checked.value
        );
    }

    return TagalysCustomisations
      .getStoredSearchGender();
  };

TagalysCustomisations.updateTrendingCollectionsForGender =
  function (wrapper, gender) {
    if (!wrapper || !wrapper.querySelector) {
      return;
    }

    var section =
      wrapper.querySelector(
        "[data-tagalys-trending-collections]"
      );

    if (!section) {
      return;
    }

    gender =
      TagalysCustomisations
        .normaliseSearchGender(gender);

    var groups =
      section.querySelectorAll(
        "[data-tagalys-trending-group]"
      );

    var activeGroup = null;

    groups.forEach(function (group) {
      var isActive =
        group.getAttribute(
          "data-tagalys-trending-group"
        ) === gender;

      group.hidden = !isActive;

      if (isActive) {
        activeGroup = group;
      }
    });

    section.hidden =
      !activeGroup ||
      !activeGroup.querySelector(
        ".tagalys-search-trending__card"
      );
  };


TagalysCustomisations.syncSearchGenderInputs =
  function (gender) {
    gender = TagalysCustomisations
      .normaliseSearchGender(gender);

    document
      .querySelectorAll(
        'input[name="selectGender"]'
      )
      .forEach(function (input) {
        input.checked =
          TagalysCustomisations
            .normaliseSearchGender(
              input.value
            ) === gender;
      });
  };

TagalysCustomisations.closePredictiveSearch =
  function (wrapper) {
    if (!wrapper) return;

    /*
     * Do not hide/clear predictive results here. The outer header drawer owns
     * the close animation; changing result visibility before that animation
     * finishes causes the product grid / View more flash.
     */
    document.body.classList.remove(
      "predictive-overflow-hidden"
    );

    document.dispatchEvent(
      new CustomEvent(
        "predictive-search:close-all"
      )
    );
  };

TagalysCustomisations.getMarketRoot = function () {
  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : window.theme &&
        window.theme.routes &&
        window.theme.routes.home
        ? window.theme.routes.home
        : "/";

  root = String(root || "/");

  if (root.charAt(0) !== "/") {
    root = "/" + root;
  }

  if (root.charAt(root.length - 1) !== "/") {
    root += "/";
  }

  return root;
};

TagalysCustomisations.productPageUrl = function (product) {
  if (!product) {
    return TagalysCustomisations.getMarketRoot() + "products";
  }

  if (typeof product === "string") {
    var stringValue = String(product).trim();

    if (stringValue.indexOf("/products/") !== -1) {
      var productPath = stringValue
        .split("/products/")[1]
        .split(/[?#]/)[0];

      if (productPath) {
        return TagalysCustomisations.getMarketProductUrl(
          decodeURIComponent(productPath)
        );
      }
    }

    return TagalysCustomisations.getMarketProductUrl(stringValue);
  }

  if (product.handle) {
    return TagalysCustomisations.getMarketProductUrl(product.handle);
  }

  var fallbackUrl = product.url || product.link || "";

  if (fallbackUrl && fallbackUrl.indexOf("/products/") !== -1) {
    var fallbackHandle = fallbackUrl
      .split("/products/")[1]
      .split(/[?#]/)[0];

    if (fallbackHandle) {
      return TagalysCustomisations.getMarketProductUrl(
        decodeURIComponent(fallbackHandle)
      );
    }
  }

  return fallbackUrl ||
    TagalysCustomisations.getMarketRoot() + "products";
};

TagalysCustomisations.getProductCardSettings = function () {
  var config =
    window.TagalysShopifyConfig || {};

  var cardConfig =
    config.productCard || {};

  var themeSettings =
    window.theme &&
    window.theme.settings
      ? window.theme.settings
      : {};

  return {
    typeProductStyle:
      cardConfig.typeProductStyle ||
      "body",

    productHoverImage:
      cardConfig.productHoverImage !== false,

    productImageSize:
      cardConfig.productImageSize ||
      themeSettings.productImageSize ||
      "portrait",

    productImageCover:
      cardConfig.productImageCover !== false &&
      themeSettings.productImageCover !== false,

    vendorEnable:
      cardConfig.vendorEnable === true,

    productSaveAmount:
      cardConfig.productSaveAmount === true,

    productSaveType:
      cardConfig.productSaveType ||
      themeSettings.saveType ||
      "percent",

    showSaleBadge:
      cardConfig.showSaleBadge !== false,

    badgeSaleLabel:
      cardConfig.badgeSaleLabel ||
      "SALE",

    showProductBadge:
      cardConfig.showProductBadge !== false,

    enableReviews:
      cardConfig.enableReviews === true,

    quickShopEnable:
      cardConfig.quickShopEnable === true ||
      themeSettings.quickView === true,

    enableProductSlider:
      cardConfig.enableProductSlider === true,

    enableCustomSwatches:
      cardConfig.enableCustomSwatches === true,

    swatchStyle:
      cardConfig.swatchStyle ||
      "round",

    swatchLimit:
      Number(
        cardConfig.swatchLimit || 4
      ),

    perRow:
      cardConfig.perRow || 4
  };
};

TagalysCustomisations.getGridClasses = function (perRow) {
  perRow = perRow || 4;

  switch (perRow) {
    case 2:
      return "grid__item grid-product medium-up--one-half";
    case 3:
      return "grid__item grid-product small--one-half medium-up--one-third";
    case 5:
      return "grid__item grid-product small--one-half medium-up--one-fifth";
    case 6:
      return "grid__item grid-product small--one-half medium-up--one-sixth";
    default:
      return "grid__item grid-product small--one-half medium-up--one-quarter";
  }
};

TagalysCustomisations.getProductImageUrl = function (image, width) {
  if (!image) return null;

  width = width || 540;
  var src = image.src || image.url || image;

  if (!src) return null;
  if (src.indexOf("width=") !== -1) return src;

  return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
};

TagalysCustomisations.renderProductTags = function (html, product, isOnSale, settings) {
  if (!settings.showProductBadge) return null;

  var tags = Array.isArray(product.tags) ? product.tags : [];
  var tagSet = {};

  tags.forEach(function (tag) {
    tagSet[String(tag).toLowerCase()] = true;
  });

  var badgeSettings =
    TagalysCustomisations
      .getBadgeSettings();

  function initialHasTag(configuredTag, fallbackTag) {
    var tag = String(
      configuredTag || fallbackTag || ""
    ).trim().toLowerCase();

    return !!(tag && tagSet[tag]);
  }

  var badges = [];

  if (isOnSale && product.available !== false && settings.showSaleBadge) {
    badges.push(html`
      <div class="sale-tag product-tag-bottom">${settings.badgeSaleLabel}</div>
    `);
  }

  var initialLegacyComingSoon =
    initialHasTag(null, "coming-soon") &&
    product.available === false;

  var initialCustomComingSoon =
    badgeSettings.enableCustomComingSoon &&
    initialHasTag(
      badgeSettings.customComingSoonTag,
      "sep-campaign-26"
    ) &&
    (
      badgeSettings.customComingSoonExcludeInStock !== true ||
      product.available === false
    );

  if (
    badgeSettings.showComingSoonBadge !== false &&
    (
      initialLegacyComingSoon ||
      initialCustomComingSoon
    )
  ) {
    badges.push(html`
      <div class="coming-soon product-tag-bottom">${badgeSettings.comingSoonLabel || "Coming Soon"}</div>
    `);
  }

  if (
    initialHasTag(badgeSettings.newTag, "new") &&
    !isOnSale &&
    badgeSettings.showNewBadge !== false
  ) {
    badges.push(html`
      <div class="new-tag product-tag-bottom">${badgeSettings.newLabel || "NEW"}</div>
    `);
  }

  if (
    initialHasTag(
      badgeSettings.sellingFastTag,
      "selling-fast"
    ) &&
    badgeSettings.showSellingFastBadge !== false
  ) {
    badges.push(html`
      <div class="selling-fast product-tag-bottom">${badgeSettings.sellingFastLabel || "Selling Fast"}</div>
    `);
  }

  if (
    initialHasTag(
      badgeSettings.exclusiveTag,
      "tb-exclusive"
    ) &&
    badgeSettings.showExclusiveBadge !== false
  ) {
    badges.push(html`
      <div class="tb-exclusive product-tag-bottom">${badgeSettings.exclusiveLabel || "Threadbare Exclusive"}</div>
    `);
  }

  if (!badges.length) return null;

  return html`
    <div class="product-tags-bottom">${badges}</div>
  `;
};

TagalysCustomisations.getImageAlt =
  function (image, product) {

    return (
      image &&
      (
        image.alt ||
        image.altText
      )
    ) ||
    product.title ||
    "";

  };


TagalysCustomisations.renderProductGallery =
  function (
    html,
    product,
    productLink,
    cardSettings
  ) {

    var images =
      Array.isArray(product.images)
        ? product.images.filter(Boolean)
        : [];


    /*
     * Use native Threadbare gallery when enabled.
     */
    if (
      cardSettings.enableProductSlider &&
      images.length > 1
    ) {

      return html`
        <div class="product-gallery-item">

          <product-grid-gallery
            class="grid-product__gallery-wrapper"
          >

            <button
              type="button"
              class="grid-product__arrow grid-product__arrow--prev"
              aria-label="Previous image"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-chevron-left"
                viewBox="0 0 284.49 498.98"
              >
                <path
                  d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"
                />
              </svg>
            </button>


            <a
              href=${productLink}
              title=${product.title + " Image Gallery"}
              class="grid-product__gallery"
            >

              ${images.map(function (image) {

                var imageUrl =
                  TagalysCustomisations
                    .getProductImageUrl(
                      image,
                      720
                    );

                var alt =
                  TagalysCustomisations
                    .getImageAlt(
                      image,
                      product
                    );

                return html`
                  <div
                    class="grid-product__image-mask grid-product__gallery-item"
                  >

                    <div
                      class=${"grid__image-ratio grid__image-ratio--" +
                      cardSettings.productImageSize}
                    >

                      <img
                        src=${imageUrl}
                        alt=${alt}
                        loading="lazy"
                        class=${"grid-product__image image-element" +
                        (
                          cardSettings.productImageCover
                            ? ""
                            : " grid__image-contain"
                        )}
                      />

                    </div>

                  </div>
                `;

              })}

            </a>


            <button
              type="button"
              class="grid-product__arrow grid-product__arrow--next"
              aria-label="Next image"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-chevron-right"
                viewBox="0 0 284.49 498.98"
              >
                <path
                  d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"
                />
              </svg>
            </button>


            <div class="grid-product__progress-bar">
              <div class="grid-product__progress-indicator"></div>
            </div>

          </product-grid-gallery>

        </div>
      `;
    }


    /*
     * Normal image fallback.
     */
    var primaryImage =
      TagalysCustomisations
        .getProductImageUrl(
          product.featured_image ||
          images[0],
          720
        );

    var secondaryImage =
      cardSettings.productHoverImage &&
      images[1]
        ? TagalysCustomisations
            .getProductImageUrl(
              images[1],
              720
            )
        : null;


    return html`
      <div class="grid-product__image-mask">

        <div
          class=${"grid__image-ratio grid__image-ratio--" +
          cardSettings.productImageSize}
        >

          ${primaryImage
            ? html`
                <img
                  src=${primaryImage}
                  alt=${product.title}
                  loading="lazy"
                  class=${"grid-product__image image-element" +
                  (
                    cardSettings.productImageCover
                      ? ""
                      : " grid__image-contain"
                  )}
                />
              `
            : null}

        </div>


        ${secondaryImage
          ? html`
              <div
                class="grid-product__secondary-image small--hide"
              >
                <img
                  src=${secondaryImage}
                  alt=${product.title}
                  loading="lazy"
                  class="image-element"
                />
              </div>
            `
          : null}

      </div>
    `;
  };
TagalysCustomisations.renderProductCard =
  function (html, args, forcedPerRow) {

    var props =
      args.props;

    var product =
      props.product;

    var helpers =
      props.helpers;

    var cardSettings =
      TagalysCustomisations
        .getProductCardSettings();

    if (
      forcedPerRow &&
      Number(forcedPerRow) > 0
    ) {
      cardSettings.perRow =
        Number(forcedPerRow);
    }


    /*
     * Always build the initial card URL through our market-aware resolver.
     * Do not use helpers.getTemplateOptions("product").productPageUrl() here:
     * the SDK can return its own base /products/... URL on the first render.
     * Swatch replacements already use this same resolver, so this keeps both
     * rendering paths consistent (e.g. /en-ie/products/...).
     */
    var productLink =
      TagalysCustomisations
        .productPageUrl(
          product
        );


    var isOnSale =
      helpers.isProductOnSale(
        product.compare_at_price,
        product.price
      );


    var compareAtPrice =
      Number(
        product.compare_at_price
      );


    var currentPrice =
      Number(
        product.price
      );


    var savedAmount =
      null;


    if (
      isOnSale &&
      cardSettings.productSaveAmount &&
      Number.isFinite(compareAtPrice) &&
      Number.isFinite(currentPrice) &&
      compareAtPrice > currentPrice
    ) {

      if (
        cardSettings.productSaveType ===
        "dollar"
      ) {

        savedAmount =
          helpers.formatCurrency(
            compareAtPrice -
            currentPrice
          );

      } else {

        savedAmount =
          Math.round(
            (
              (
                compareAtPrice -
                currentPrice
              ) /
              compareAtPrice
            ) *
            100
          ) + "%";

      }

    }


    var gridClasses =
      TagalysCustomisations
        .getGridClasses(
          cardSettings.perRow
        );


    if (
      cardSettings.quickShopEnable
    ) {
      gridClasses +=
        " grid-product__has-quick-shop";
    }


    if (
      product.available === false
    ) {
      gridClasses +=
        " grid-product--sold-out";
    }


    if (
      isOnSale &&
      product.available !== false
    ) {
      gridClasses +=
        " grid-product--sale";
    }


    return html`

      <div
        class=${gridClasses}

        data-product-handle=${product.handle || ""}
        data-product-id=${product.id}

        data-tagalys-product-card
      >

        <div class="grid-product__content">


          <div
            class="grid__item-image-wrapper"
            data-tagalys-card-images
          >

            <div data-tagalys-card-gallery>
              ${TagalysCustomisations
                .renderProductGallery(
                  html,
                  product,
                  productLink,
                  cardSettings
                )}
            </div>

            <div data-tagalys-card-badges>
              ${TagalysCustomisations
                .renderProductTags(
                  html,
                  product,
                  isOnSale,
                  cardSettings
                )}
            </div>

          </div>


          <a
            href=${productLink}
            title=${product.title}

            data-product-url=${productLink}

            class=${"grid-product__link product-link" +
            (
              cardSettings.enableProductSlider
                ? " remove-link-overlay"
                : ""
            )}
          ></a>


          <div class="grid-product__meta">


            <div class="grid-product__header">

              <a
                href=${productLink}
                title=${product.title}
                class="grid-product__meta-link"
                style="color: inherit; text-decoration: none;"
              >

                <h2
                  class=${"grid-product__title grid-product__title--" +
                  cardSettings.typeProductStyle}

                  data-tagalys-card-title
                >
                  ${product.title}
                </h2>

              </a>

              <div
                class="grid-product__actions-row"
                data-tagalys-quick-add
              ></div>

            </div>


            ${cardSettings.vendorEnable &&
            product.vendor
              ? html`
                  <div
                    class="grid-product__vendor"
                    data-tagalys-card-vendor
                  >
                    ${product.vendor}
                  </div>
                `
              : null}


            <div class="grid-product__price-actions">

              <div
                class="grid-product__price"
                data-tagalys-card-price
              >

                ${isOnSale
                  ? html`

                      <span class="visually-hidden">
                        Regular price
                      </span>

                      <span class="grid-product__price--original">
                        ${helpers.formatCurrency(
                          product.compare_at_price
                        )}
                      </span>

                      <span class="visually-hidden">
                        Sale price
                      </span>

                    `
                  : null}


                <span
                  class=${isOnSale
                    ? "grid-product__price--sale"
                    : ""}
                >
                  ${helpers.formatCurrency(
                    product.price
                  )}
                </span>


                ${savedAmount
                  ? html`
                      <span
                        class="grid-product__price--savings"
                      >
                        Save ${savedAmount}
                      </span>
                    `
                  : null}

              </div>

            </div>


          </div>

        </div>

        ${cardSettings.enableCustomSwatches &&
        product.handle
          ? html`

              <div
                class="tagalys-product-swatches"
                data-tagalys-swatches-slot
                data-product-handle=${product.handle}
              ></div>

            `
          : null}

      </div>
    `;
  };

TagalysCustomisations.getProductTemplate = function (forcedPerRow) {
  return {
    render: function (html, args) {
      return TagalysCustomisations
        .renderProductCard(
          html,
          args,
          forcedPerRow
        );
    },
  };
};

TagalysCustomisations.getPredictiveProductTemplate = function () {
  return TagalysCustomisations
    .getProductTemplate(6);
};
TagalysCustomisations.cardProductCache =
  TagalysCustomisations.cardProductCache ||
  {};


TagalysCustomisations.escapeHTML =
  function (value) {

    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  };


TagalysCustomisations.setTagalysConfiguration = function () {
  var config = window.TagalysShopifyConfig || {};

  var activeCurrency =
    window.Shopify &&
    window.Shopify.currency &&
    window.Shopify.currency.active
      ? String(window.Shopify.currency.active)
      : "";

  var currencyCode =
    activeCurrency ||
    config.currencyCode ||
    "GBP";

  var currencySymbol =
    currencyCode === "EUR"
      ? "€"
      : (
          currencyCode === "GBP"
            ? "£"
            : (
                config.currencySymbol ||
                currencyCode + " "
              )
        );

  var configuration = {
    api: {
      serverUrl: "https://api-r4.tagalys.com",
    },
    locale: config.locale || "en-GB",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: currencyCode,
      label: currencySymbol,
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    productPageUrl: TagalysCustomisations.productPageUrl,
    analyticsStorageConsentProvided: function () {
      return true;
    },
    track: true,
  };

  Tagalys.setConfiguration(configuration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var config = window.TagalysShopifyConfig || {};
  var countryCode =
    config.countryCode || (window.Shopify && window.Shopify.country ? window.Shopify.country : "GB");

  var platformConfiguration = {
    platform: "Shopify",
    countryCode: countryCode,
    baseCountryCode: config.baseCountryCode || "GB",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    productPageUrl: TagalysCustomisations.productPageUrl,
    storefrontAPI: {
      accessToken: config.storefrontAccessToken || "",
      myShopifyDomain: config.myShopifyDomain || "threadbaremenswear.myshopify.com",
    },
    metafields: {
      products: [],
    },
  };

  Tagalys.setPlatformConfiguration(platformConfiguration);
};
// ======================================================
// THREADBARE TAGALYS CARD ENHANCEMENTS
//
// - Loads linked-colour metafields from Shopify Storefront API.
// - Renders swatches with the same classes/sizing as the native theme.
// - Swatch clicks update the existing Tagalys card in place.
// - The selected linked product is fetched only when needed.
// - The product gallery uses the native <product-grid-gallery> markup.
// ======================================================

TagalysCustomisations.swatchDataCache =
  TagalysCustomisations.swatchDataCache || {};

TagalysCustomisations.cardProductCache =
  TagalysCustomisations.cardProductCache || {};

TagalysCustomisations.cardProductPromises =
  TagalysCustomisations.cardProductPromises || {};


TagalysCustomisations.getStorefrontAPIConfig =
  function () {
    var config =
      window.TagalysShopifyConfig || {};

    return {
      token:
        config.storefrontAccessToken || "",

      domain:
        config.myShopifyDomain ||
        "threadbaremenswear.myshopify.com",

      country:
        config.countryCode || "GB"
    };
  };


TagalysCustomisations.getMarketProductUrl =
  function (handle) {
    return (
      TagalysCustomisations.getMarketRoot() +
      "products/" +
      encodeURIComponent(handle)
    );
  };


TagalysCustomisations.getSwatchColour =
  function (product) {
    if (!product) {
      return "#fff";
    }

    var hex =
      product.hexCode &&
      product.hexCode.value
        ? String(
            product.hexCode.value
          ).trim()
        : "";

    if (hex) {
      if (
        hex.charAt(0) !== "#"
      ) {
        hex =
          "#" + hex;
      }

      return hex;
    }

    var colour =
      product.colour &&
      product.colour.value
        ? String(
            product.colour.value
          ).trim()
        : "";

    return (
      colour
        ? colour.toLowerCase()
        : "#fff"
    );
  };


TagalysCustomisations.normaliseSwatchProduct =
  function (product) {
    if (!product) {
      return null;
    }

    return {
      handle:
        product.handle || "",

      title:
        product.title || "",

      available:
        product.availableForSale !== false,

      colours:
        product.colours || null,

      hexCode:
        product.hexCode || null,

      colour:
        product.colour || null
    };
  };


TagalysCustomisations.fetchSwatchDataBatch =
  function (handles) {
    var api =
      TagalysCustomisations
        .getStorefrontAPIConfig();

    if (
      !api.token ||
      !handles.length
    ) {
      return Promise.resolve({});
    }

    var productQueries =
      handles
        .map(function (
          handle,
          index
        ) {
          return `
            product${index}: product(
              handle: ${JSON.stringify(handle)}
            ) {
              ...SwatchSourceProduct
            }
          `;
        })
        .join("\n");

    var query = `
      query TagalysColourLinks(
        $country: CountryCode!
      )
      @inContext(
        country: $country
      ) {
        ${productQueries}
      }

      fragment SwatchFields on Product {
        handle
        title
        availableForSale

        colours: metafield(
          namespace: "custom"
          key: "colours"
        ) {
          value
        }

        hexCode: metafield(
          namespace: "custom"
          key: "hex_code"
        ) {
          value
        }

        colour: metafield(
          namespace: "custom"
          key: "colour"
        ) {
          value
        }
      }

      fragment SwatchSourceProduct on Product {
        ...SwatchFields

        colourLinking: metafield(
          namespace: "custom"
          key: "colour_linking"
        ) {
          references(first: 24) {
            nodes {
              ... on Product {
                ...SwatchFields
              }
            }
          }
        }
      }
    `;

    return fetch(
      "https://" +
        api.domain +
        "/api/2026-07/graphql.json",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",

          "X-Shopify-Storefront-Access-Token":
            api.token
        },

        body:
          JSON.stringify({
            query:
              query,

            variables: {
              country:
                api.country
            }
          })
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Storefront API request failed: " +
            response.status
          );
        }

        return response.json();
      })
      .then(function (response) {
        if (
          response.errors &&
          response.errors.length
        ) {
          console.error(
            "[Tagalys Swatches] GraphQL errors:",
            response.errors
          );
        }

        var data =
          response.data || {};

        var output = {};

        handles.forEach(function (
          handle,
          index
        ) {
          var raw =
            data[
              "product" + index
            ] || null;

          if (!raw) {
            output[handle] =
              null;

            return;
          }

          var source =
            TagalysCustomisations
              .normaliseSwatchProduct(
                raw
              );

          var references =
            raw.colourLinking &&
            raw.colourLinking.references &&
            Array.isArray(
              raw.colourLinking
                .references
                .nodes
            )
              ? raw.colourLinking
                  .references
                  .nodes
              : [];

          source.linkedProducts =
            references
              .map(function (
                item
              ) {
                return TagalysCustomisations
                  .normaliseSwatchProduct(
                    item
                  );
              })
              .filter(function (
                item
              ) {
                return (
                  item &&
                  item.handle &&
                  item.available !== false
                );
              });

          output[handle] =
            source;

          TagalysCustomisations
            .swatchDataCache[
              handle
            ] =
            source;
        });

        return output;
      });
  };


TagalysCustomisations.renderTagalysSwatches =
  function (
    slot,
    productData
  ) {
    if (
      !slot ||
      !productData
    ) {
      return;
    }

    var cardSettings =
      TagalysCustomisations
        .getProductCardSettings();

    var currentHandle =
      slot.getAttribute(
        "data-product-handle"
      ) ||
      productData.handle;

    var linkedProducts =
      Array.isArray(
        productData.linkedProducts
      )
        ? productData
            .linkedProducts
            .filter(function (
              product
            ) {
              return (
                product &&
                product.handle &&
                product.available !== false
              );
            })
        : [];

    /*
     * Match the Liquid card:
     * only show custom linked swatches when
     * there is more than one available product.
     */
    if (
      linkedProducts.length <= 1
    ) {
      slot.innerHTML = "";

      slot.setAttribute(
        "data-swatches-loaded",
        "true"
      );

      return;
    }

    var activeSwatch =
      null;

    var otherSwatches =
      [];

    linkedProducts.forEach(
      function (product) {
        if (
          product.handle ===
          currentHandle
        ) {
          activeSwatch =
            product;
        } else {
          otherSwatches.push(
            product
          );
        }
      }
    );

    if (!activeSwatch) {
      activeSwatch =
        TagalysCustomisations
          .normaliseSwatchProduct(
            productData
          );
    }

    var swatchLimit =
      cardSettings.swatchLimit ||
      4;

    otherSwatches =
      otherSwatches.slice(
        0,
        swatchLimit
      );

    /*
     * Native Threadbare puts the active
     * colour after the limited alternatives.
     */
    var swatches =
      otherSwatches.slice();

    if (activeSwatch) {
      swatches.push(
        activeSwatch
      );
    }

    var total =
      swatches.length;

    var markup =
      swatches
        .map(function (
          product,
          index
        ) {
          var isActive =
            product.handle ===
            currentHandle;

          var colourName =
            product.colours &&
            product.colours.value
              ? product.colours.value
              : product.handle;

          var background =
            TagalysCustomisations
              .getSwatchColour(
                product
              );

          return (
            '<li' +
              ' title="' +
                TagalysCustomisations.escapeHTML(
                  colourName
                ) +
              '"' +
              ' class="' +
                'c-product-item__swatches__swatch ' +
                (
                  isActive
                    ? 'active-swatch '
                    : ''
                ) +
                'swatch-style-' +
                TagalysCustomisations.escapeHTML(
                  cardSettings.swatchStyle
                ) +
              '"' +
              ' data-colour="' +
                TagalysCustomisations.escapeHTML(
                  colourName
                ) +
              '"' +
              ' data-index="' +
                (index + 1) +
              '"' +
              ' data-forloop-length="' +
                total +
              '"' +
              ' data-handle="' +
                TagalysCustomisations.escapeHTML(
                  product.handle
                ) +
              '"' +
              ' style="background-color:' +
                TagalysCustomisations.escapeHTML(
                  background
                ) +
              ';"' +
            '>' +

              '<button' +
                ' type="button"' +
                ' class="tagalys-product-swatch-button"' +
                ' data-tagalys-swatch-handle="' +
                  TagalysCustomisations.escapeHTML(
                    product.handle
                  ) +
                '"' +
                ' title="' +
                  TagalysCustomisations.escapeHTML(
                    colourName
                  ) +
                '"' +
                ' aria-label="' +
                  TagalysCustomisations.escapeHTML(
                    colourName
                  ) +
                '"' +
              '></button>' +

            '</li>'
          );
        })
        .join("");

    slot.innerHTML =
      '<ul class="c-product-item__swatches">' +
        markup +
      '</ul>';

    slot.setAttribute(
      "data-swatches-loaded",
      "true"
    );
  };


TagalysCustomisations.loadTagalysCardSwatches =
  function () {
    var slots =
      document.querySelectorAll(
        '[data-tagalys-swatches-slot]' +
        ':not([data-swatches-loaded])' +
        ':not([data-swatches-loading])'
      );

    if (!slots.length) {
      return;
    }

    var handles = [];

    Array.prototype
      .forEach.call(
        slots,
        function (slot) {
          var handle =
            slot.getAttribute(
              "data-product-handle"
            );

          if (!handle) {
            return;
          }

          var cached =
            TagalysCustomisations
              .swatchDataCache[
                handle
              ];

          if (cached) {
            TagalysCustomisations
              .renderTagalysSwatches(
                slot,
                cached
              );

            return;
          }

          slot.setAttribute(
            "data-swatches-loading",
            "true"
          );

          if (
            handles.indexOf(
              handle
            ) === -1
          ) {
            handles.push(
              handle
            );
          }
        }
      );

    if (!handles.length) {
      return;
    }

    var batchSize =
      24;

    var requests =
      [];

    for (
      var i = 0;
      i < handles.length;
      i += batchSize
    ) {
      requests.push(
        TagalysCustomisations
          .fetchSwatchDataBatch(
            handles.slice(
              i,
              i + batchSize
            )
          )
      );
    }

    Promise.all(
      requests
    )
      .then(function (
        responses
      ) {
        var products = {};

        responses.forEach(
          function (response) {
            Object.keys(
              response
            ).forEach(
              function (handle) {
                products[handle] =
                  response[handle];
              }
            );
          }
        );

        Array.prototype
          .forEach.call(
            slots,
            function (slot) {
              var handle =
                slot.getAttribute(
                  "data-product-handle"
                );

              slot.removeAttribute(
                "data-swatches-loading"
              );

              var productData =
                products[handle] ||
                TagalysCustomisations
                  .swatchDataCache[
                    handle
                  ];

              if (!productData) {
                slot.setAttribute(
                  "data-swatches-loaded",
                  "true"
                );

                return;
              }

              TagalysCustomisations
                .renderTagalysSwatches(
                  slot,
                  productData
                );
            }
          );
      })
      .catch(function (error) {
        console.error(
          "[Tagalys Swatches] Failed:",
          error
        );

        Array.prototype
          .forEach.call(
            slots,
            function (slot) {
              slot.removeAttribute(
                "data-swatches-loading"
              );
            }
          );
      });
  };


TagalysCustomisations.normaliseStorefrontProduct =
  function (product) {
    if (!product) {
      return null;
    }

    var images =
      product.images &&
      Array.isArray(
        product.images.nodes
      )
        ? product.images.nodes
            .map(function (
              image
            ) {
              return {
                src:
                  image.url,

                url:
                  image.url,

                alt:
                  image.altText ||
                  product.title ||
                  "",

                altText:
                  image.altText ||
                  product.title ||
                  "",

                width:
                  image.width || null,

                height:
                  image.height || null
              };
            })
        : [];

    var priceRange =
      product.priceRange || {};

    var compareRange =
      product.compareAtPriceRange || {};

    var minPrice =
      priceRange.minVariantPrice
        ? Number(
            priceRange
              .minVariantPrice
              .amount
          )
        : 0;

    var maxPrice =
      priceRange.maxVariantPrice
        ? Number(
            priceRange
              .maxVariantPrice
              .amount
          )
        : minPrice;

    var comparePrice =
      compareRange.minVariantPrice
        ? Number(
            compareRange
              .minVariantPrice
              .amount
          )
        : 0;

    var id =
      String(
        product.id || ""
      )
        .split("/")
        .pop();

    var variants =
      product.variants &&
      Array.isArray(
        product.variants.nodes
      )
        ? product.variants.nodes
            .map(function (variant) {
              return {
                id:
                  String(variant.id || "")
                    .split("/")
                    .pop(),

                title:
                  variant.title || "",

                available:
                  variant.availableForSale !== false,

                sku:
                  variant.sku || "",

                selectedOptions:
                  Array.isArray(
                    variant.selectedOptions
                  )
                    ? variant.selectedOptions
                    : []
              };
            })
        : [];

    var selectedVariantId =
      product.selectedOrFirstAvailableVariant &&
      product.selectedOrFirstAvailableVariant.id
        ? String(
            product.selectedOrFirstAvailableVariant.id
          )
            .split("/")
            .pop()
        : (
            variants.find(function (variant) {
              return variant.available;
            }) || variants[0] || {}
          ).id || "";

    var collectionHandles =
      product.collections &&
      Array.isArray(
        product.collections.nodes
      )
        ? product.collections.nodes
            .map(function (collection) {
              return collection && collection.handle
                ? collection.handle
                : "";
            })
            .filter(Boolean)
        : [];

    var preOrder =
      !!(
        product.preOrder &&
        String(product.preOrder.value)
          .toLowerCase() === "true"
      );

    return {
      id:
        id,

      handle:
        product.handle || "",

      title:
        product.title || "",

      vendor:
        product.vendor || "",

      available:
        product.availableForSale !== false,

      tags:
        Array.isArray(
          product.tags
        )
          ? product.tags
          : [],

      publishedAt:
        product.publishedAt || "",

      preOrder:
        preOrder,

      newTagEndDate:
        product.newTagEndDate &&
        product.newTagEndDate.value
          ? product.newTagEndDate.value
          : "",

      collectionHandles:
        collectionHandles,

      variants:
        variants,

      selectedVariantId:
        selectedVariantId,

      images:
        images,

      featured_image:
        images[0] || null,

      price:
        minPrice,

      price_max:
        maxPrice,

      price_varies:
        maxPrice > minPrice,

      compare_at_price:
        comparePrice,

      colours:
        product.colours || null,

      hexCode:
        product.hexCode || null,

      colour:
        product.colour || null,

      url:
        TagalysCustomisations
          .getMarketProductUrl(
            product.handle
          ),

      _isFullProduct:
        true
    };
  };

TagalysCustomisations.fetchStorefrontProduct =
  function (handle) {
    if (!handle) {
      return Promise.resolve(
        null
      );
    }

    var cached =
      TagalysCustomisations
        .cardProductCache[
          handle
        ];

    if (
      cached &&
      cached._isFullProduct
    ) {
      return Promise.resolve(
        cached
      );
    }

    if (
      TagalysCustomisations
        .cardProductPromises[
          handle
        ]
    ) {
      return TagalysCustomisations
        .cardProductPromises[
          handle
        ];
    }

    var api =
      TagalysCustomisations
        .getStorefrontAPIConfig();

    if (!api.token) {
      return Promise.reject(
        new Error(
          "Shopify Storefront API token is missing."
        )
      );
    }

    var query = `
      query TagalysCardProduct(
        $handle: String!
        $country: CountryCode!
      )
      @inContext(
        country: $country
      ) {
        product(
          handle: $handle
        ) {
          ...TagalysCardProductFields
        }
      }

      fragment TagalysCardProductFields on Product {
        id
        handle
        title
        vendor
        availableForSale
        tags
        publishedAt

        images(first: 12) {
          nodes {
            url
            altText
            width
            height
          }
        }

        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }

          maxVariantPrice {
            amount
            currencyCode
          }
        }

        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }

          maxVariantPrice {
            amount
            currencyCode
          }
        }

        selectedOrFirstAvailableVariant {
          id
        }

        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            sku

            selectedOptions {
              name
              value
            }
          }
        }

        collections(first: 50) {
          nodes {
            handle
          }
        }

        preOrder: metafield(
          namespace: "custom"
          key: "pre_order"
        ) {
          value
        }

        newTagEndDate: metafield(
          namespace: "custom"
          key: "new_tag_end_date"
        ) {
          value
        }

        colours: metafield(
          namespace: "custom"
          key: "colours"
        ) {
          value
        }

        hexCode: metafield(
          namespace: "custom"
          key: "hex_code"
        ) {
          value
        }

        colour: metafield(
          namespace: "custom"
          key: "colour"
        ) {
          value
        }
      }
    `;

    var request =
      fetch(
        "https://" +
          api.domain +
          "/api/2026-07/graphql.json",
        {
          method:
            "POST",

          headers: {
            "Content-Type":
              "application/json",

            "X-Shopify-Storefront-Access-Token":
              api.token
          },

          body:
            JSON.stringify({
              query:
                query,

              variables: {
                handle:
                  handle,

                country:
                  api.country
              }
            })
        }
      )
        .then(function (
          response
        ) {
          if (!response.ok) {
            throw new Error(
              "Storefront API request failed: " +
              response.status
            );
          }

          return response.json();
        })
        .then(function (
          response
        ) {
          if (
            response.errors &&
            response.errors.length
          ) {
            throw new Error(
              response.errors
                .map(function (
                  error
                ) {
                  return error.message;
                })
                .join("; ")
            );
          }

          var product =
            response.data &&
            response.data.product
              ? TagalysCustomisations
                  .normaliseStorefrontProduct(
                    response.data.product
                  )
              : null;

          if (product) {
            TagalysCustomisations
              .cardProductCache[
                handle
              ] =
              product;
          }

          delete TagalysCustomisations
            .cardProductPromises[
              handle
            ];

          return product;
        })
        .catch(function (
          error
        ) {
          delete TagalysCustomisations
            .cardProductPromises[
              handle
            ];

          throw error;
        });

    TagalysCustomisations
      .cardProductPromises[
        handle
      ] =
      request;

    return request;
  };

TagalysCustomisations.formatCardMoney =
  function (value) {
    var config =
      window.TagalysShopifyConfig || {};

    var symbol =
      config.currencySymbol ||
      (
        config.currencyCode ===
        "EUR"
          ? "€"
          : "£"
      );

    var amount =
      Number(value || 0);

    return (
      symbol +
      amount.toFixed(2)
    );
  };


TagalysCustomisations.buildGalleryHTML =
  function (product) {
    var settings =
      TagalysCustomisations
        .getProductCardSettings();

    var images =
      Array.isArray(
        product.images
      )
        ? product.images
            .filter(Boolean)
        : [];

    var productLink =
      TagalysCustomisations
        .productPageUrl(
          product
        );

    if (!images.length) {
      return "";
    }

    if (
      !settings.enableProductSlider ||
      images.length < 2
    ) {
      var firstImage =
        images[0];

      var firstImageUrl =
        TagalysCustomisations
          .getProductImageUrl(
            firstImage,
            720
          );

      var secondaryImage =
        settings.productHoverImage &&
        images[1]
          ? images[1]
          : null;

      var secondaryHTML =
        "";

      if (secondaryImage) {
        secondaryHTML =
          '<div class="grid-product__secondary-image small--hide">' +
            '<img' +
              ' src="' +
                TagalysCustomisations.escapeHTML(
                  TagalysCustomisations
                    .getProductImageUrl(
                      secondaryImage,
                      720
                    )
                ) +
              '"' +
              ' alt="' +
                TagalysCustomisations.escapeHTML(
                  secondaryImage.alt ||
                  product.title
                ) +
              '"' +
              ' loading="lazy"' +
              ' class="image-element"' +
            '>' +
          '</div>';
      }

      return (
        '<div class="grid-product__image-mask">' +

          '<div class="' +
            'grid__image-ratio ' +
            'grid__image-ratio--' +
            TagalysCustomisations.escapeHTML(
              settings.productImageSize
            ) +
          '">' +

            '<img' +
              ' src="' +
                TagalysCustomisations.escapeHTML(
                  firstImageUrl
                ) +
              '"' +
              ' alt="' +
                TagalysCustomisations.escapeHTML(
                  firstImage.alt ||
                  product.title
                ) +
              '"' +
              ' loading="lazy"' +
              ' class="' +
                'grid-product__image image-element' +
                (
                  settings.productImageCover
                    ? ''
                    : ' grid__image-contain'
                ) +
              '"' +
            '>' +

          '</div>' +

          secondaryHTML +

        '</div>'
      );
    }

    var galleryItems =
      images
        .map(function (
          image
        ) {
          var imageUrl =
            TagalysCustomisations
              .getProductImageUrl(
                image,
                720
              );

          return (
            '<div class="grid-product__image-mask grid-product__gallery-item">' +

              '<div class="' +
                'grid__image-ratio ' +
                'grid__image-ratio--' +
                TagalysCustomisations.escapeHTML(
                  settings.productImageSize
                ) +
              '">' +

                '<img' +
                  ' src="' +
                    TagalysCustomisations.escapeHTML(
                      imageUrl
                    ) +
                  '"' +
                  ' alt="' +
                    TagalysCustomisations.escapeHTML(
                      image.alt ||
                      product.title
                    ) +
                  '"' +
                  ' loading="lazy"' +
                  ' class="' +
                    'grid-product__image image-element' +
                    (
                      settings.productImageCover
                        ? ''
                        : ' grid__image-contain'
                    ) +
                  '"' +
                '>' +

              '</div>' +

            '</div>'
          );
        })
        .join("");

    return (
      '<div class="product-gallery-item">' +

        '<product-grid-gallery class="grid-product__gallery-wrapper">' +

          '<button' +
            ' type="button"' +
            ' class="grid-product__arrow grid-product__arrow--prev"' +
            ' aria-label="Previous image"' +
          '>' +

            '<svg' +
              ' aria-hidden="true"' +
              ' focusable="false"' +
              ' role="presentation"' +
              ' class="icon icon-chevron-left"' +
              ' viewBox="0 0 284.49 498.98"' +
            '>' +
              '<path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path>' +
            '</svg>' +

          '</button>' +

          '<a' +
            ' href="' +
              TagalysCustomisations.escapeHTML(
                productLink
              ) +
            '"' +
            ' title="' +
              TagalysCustomisations.escapeHTML(
                product.title +
                " Image Gallery"
              ) +
            '"' +
            ' class="grid-product__gallery"' +
          '>' +

            galleryItems +

          '</a>' +

          '<button' +
            ' type="button"' +
            ' class="grid-product__arrow grid-product__arrow--next"' +
            ' aria-label="Next image"' +
          '>' +

            '<svg' +
              ' aria-hidden="true"' +
              ' focusable="false"' +
              ' role="presentation"' +
              ' class="icon icon-chevron-right"' +
              ' viewBox="0 0 284.49 498.98"' +
            '>' +
              '<path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path>' +
            '</svg>' +

          '</button>' +

          '<div class="grid-product__progress-bar">' +
            '<div class="grid-product__progress-indicator"></div>' +
          '</div>' +

        '</product-grid-gallery>' +

      '</div>'
    );
  };


TagalysCustomisations.getBadgeSettings =
  function () {
    var config =
      window.TagalysShopifyConfig || {};

    var badges =
      config.badges || {};

    return badges;
  };


TagalysCustomisations.getQuickAddSettings =
  function () {
    var config =
      window.TagalysShopifyConfig || {};

    return config.quickAdd || {};
  };


TagalysCustomisations.getTagSet =
  function (product) {
    var tagSet = {};

    var tags =
      product &&
      Array.isArray(product.tags)
        ? product.tags
        : [];

    tags.forEach(function (tag) {
      tagSet[String(tag)] = true;
      tagSet[String(tag).toLowerCase()] = true;
    });

    return tagSet;
  };


TagalysCustomisations.isNewBadgeActive =
  function (product) {
    if (!product) {
      return false;
    }

    if (
      Number(product.compare_at_price || 0) > 0
    ) {
      return false;
    }

    var now = Date.now();

    if (product.newTagEndDate) {
      var endDate =
        Date.parse(
          product.newTagEndDate
        );

      return (
        Number.isFinite(endDate) &&
        now < endDate
      );
    }

    if (!product.publishedAt) {
      return true;
    }

    var published =
      Date.parse(
        product.publishedAt
      );

    if (!Number.isFinite(published)) {
      return true;
    }

    var sixtyDays =
      60 * 24 * 60 * 60 * 1000;

    return (
      now - published < sixtyDays
    );
  };


TagalysCustomisations.buildBadgeIconHTML =
  function (
    iconUrl,
    alt,
    settings
  ) {
    if (
      !settings.showProductBadgeIcon ||
      !iconUrl
    ) {
      return "";
    }

    return (
      '<img' +
        ' src="' +
          TagalysCustomisations.escapeHTML(
            iconUrl
          ) +
        '"' +
        ' alt="' +
          TagalysCustomisations.escapeHTML(
            alt || ""
          ) +
        '"' +
        ' class="badge-icon"' +
        ' aria-hidden="true"' +
      '>'
    );
  };


TagalysCustomisations.buildBadgesHTML =
  function (product) {
    var cardSettings =
      TagalysCustomisations
        .getProductCardSettings();

    var settings =
      TagalysCustomisations
        .getBadgeSettings();

    if (
      cardSettings.showProductBadge === false ||
      settings.showProductBadge === false
    ) {
      return "";
    }

    var tagSet =
      TagalysCustomisations
        .getTagSet(
          product
        );

    var compare =
      Number(
        product.compare_at_price || 0
      );

    var price =
      Number(
        product.price || 0
      );

    var isOnSale =
      compare > price;

    function hasTag(configuredTag, fallbackTag) {
      var tag = String(
        configuredTag || fallbackTag || ""
      ).trim();

      if (!tag) {
        return false;
      }

      return !!(
        tagSet[tag] ||
        tagSet[tag.toLowerCase()]
      );
    }

    var badges = [];

    function addBadge(
      className,
      label,
      iconUrl,
      iconAlt
    ) {
      var iconHTML =
        TagalysCustomisations
          .buildBadgeIconHTML(
            iconUrl,
            iconAlt,
            settings
          );

      badges.push(
        '<div class="product-tag-bottom ' +
          TagalysCustomisations.escapeHTML(
            className
          ) +
        '">' +
          iconHTML +
          TagalysCustomisations.escapeHTML(
            label || ""
          ) +
        '</div>'
      );
    }

    if (
      hasTag(settings.slowPromo2Tag, "knitwear") &&
      settings.showSlowPromo2
    ) {
      addBadge(
        "product-tag-ww-slow-promo-2",
        settings.slowPromo2Label ||
          "20% Off with Code: 20OFF",
        settings.slowPromo2Icon,
        "20% Off with Code: 20OFF Icon"
      );
    }

    if (
      hasTag(settings.wwPromo3Tag, "ww-promo-3") &&
      settings.showWwPromo3
    ) {
      addBadge(
        "product-tag-ww-promo-3",
        settings.wwPromo3Label ||
          "20% Off with Code: DRESS20",
        settings.wwPromo3Icon,
        "Selected Dresses - 20% Off Icon"
      );
    }

    if (
      hasTag(settings.tag2For40, "2-for-£40") &&
      settings.show2For40
    ) {
      addBadge(
        "product-tag-2for40",
        settings.label2For40 || "2 for £40",
        settings.icon2For40,
        "2 for £40 Icon"
      );
    }

    if (
      hasTag(settings.tag2For35, "2_for_£35") &&
      settings.show2For35
    ) {
      addBadge(
        "product-tag-2for35",
        settings.label2For35 || "2 for £35",
        settings.icon2For35,
        "2 for £35 Icon"
      );
    }

    if (
      hasTag(settings.tag2For25, "2_for_£25") &&
      settings.show2For25
    ) {
      addBadge(
        "product-tag-2for25",
        settings.label2For25 || "2 for £25",
        settings.icon2For25,
        "2 for £25 Icon"
      );
    }

    if (
      isOnSale &&
      settings.showSaleBadge !== false
    ) {
      addBadge(
        "sale-tag",
        settings.saleLabel ||
          cardSettings.badgeSaleLabel ||
          "SALE"
      );
    }

    if (
      product.preOrder === true &&
      product.available !== false &&
      settings.showPreorderBadge
    ) {
      addBadge(
        "preorder-tag",
        settings.preorderLabel ||
          "PRE-ORDER"
      );
    }

    var hasLegacyComingSoonTag =
      hasTag(null, "coming-soon");

    var hasCustomComingSoonTag =
      settings.enableCustomComingSoon &&
      hasTag(
        settings.customComingSoonTag,
        "sep-campaign-26"
      );

    var customComingSoonActive =
      hasCustomComingSoonTag &&
      (
        settings.customComingSoonExcludeInStock !== true ||
        product.available === false
      );

    if (
      settings.showComingSoonBadge &&
      (
        customComingSoonActive ||
        (
          hasLegacyComingSoonTag &&
          product.available === false
        )
      )
    ) {
      addBadge(
        "coming-soon",
        settings.comingSoonLabel ||
          "Coming Soon"
      );
    }

    var tagBadges = [
      ["showerproofTag", "showerproof", "showShowerproofBadge", "product-tag-showerproof", "showerproofLabel", "Showerproof", "showerproofIcon", "Showerproof Icon"],
      ["petiteTag", "petite", "showPetiteBadge", "product-tag-petite", "petiteLabel", "Petite", "petiteIcon", "Petite Icon"],
      ["coordTag", "true-coord", "showCoordBadge", "product-tag-coord", "coordLabel", "Matching Set", "coordIcon", "Matching set Icon"],
      ["mixMatchTag", "co-ord", "showMixMatchBadge", "product-tag-mix-match", "mixMatchLabel", "Mix & Match", "mixMatchIcon", "Mix & Match Icon"],
      ["hisAndHersTag", "his-and-hers", "showHisAndHersBadge", "product-tag-his-and-hers", "hisAndHersLabel", "His & Hers", "hisAndHersIcon", "His & Hers Icon"],
      ["reversibleTag", "reversible", "showReversibleBadge", "product-tag-reversible", "reversibleLabel", "Reversible", "reversibleIcon", "Reversible Icon"],
      ["stretchTag", "stretch", "showStretchBadge", "product-tag-stretch", "stretchLabel", "Stretch", "stretchIcon", "Stretch Icon"],
      ["recycledTag", "recycled", "showRecycledBadge", "product-tag-recycled", "recycledLabel", "Recycled", "recycledIcon", "Recycled Icon"]
    ];

    tagBadges.forEach(function (badge) {
      if (
        hasTag(settings[badge[0]], badge[1]) &&
        settings[badge[2]]
      ) {
        addBadge(
          badge[3],
          settings[badge[4]] || badge[5],
          settings[badge[6]],
          badge[7]
        );
      }
    });

    if (
      hasTag(settings.backInStockTag, "back-in-stock") &&
      settings.showBackInStockBadge
    ) {
      addBadge(
        "back-in-stock-badge",
        settings.backInStockLabel ||
          "Back In Stock"
      );
    }

    if (
      hasTag(settings.lorraineTag, "as-seen-on-lorraine") &&
      settings.showLorraineBadge
    ) {
      addBadge(
        "as-seen-on-lorraine",
        settings.lorraineLabel ||
          "As Seen On Lorraine"
      );
    }

    if (
      hasTag(settings.stylistTag, "stylists-choice") &&
      settings.showStylistBadge
    ) {
      addBadge(
        "stylists-choice",
        settings.stylistLabel ||
          "Stylist's Choice"
      );
    }

    if (
      hasTag(settings.mostWantedTag, "most-wanted") &&
      settings.showMostWantedBadge
    ) {
      addBadge(
        "most-wanted",
        settings.mostWantedLabel ||
          "Most Wanted"
      );
    }

    if (
      hasTag(settings.trendingTag, "trending") &&
      settings.showTrendingBadge
    ) {
      addBadge(
        "trending",
        settings.trendingLabel ||
          "Trending"
      );
    }

    if (
      hasTag(settings.sellingFastTag, "selling-fast") &&
      settings.showSellingFastBadge
    ) {
      addBadge(
        "selling-fast",
        settings.sellingFastLabel ||
          "Selling Fast"
      );
    }

    if (
      hasTag(settings.exclusiveTag, "tb-exclusive") &&
      settings.showExclusiveBadge
    ) {
      addBadge(
        "tb-exclusive",
        settings.exclusiveLabel ||
          "Threadbare Exclusive"
      );
    }

    if (
      hasTag(settings.newTag, "new") &&
      !isOnSale &&
      settings.showNewBadge &&
      TagalysCustomisations
        .isNewBadgeActive(
          product
        )
    ) {
      addBadge(
        "new-tag",
        settings.newLabel || "NEW"
      );
    }

    if (
      hasTag(settings.familyTag, "family") &&
      settings.showFamilyBadge
    ) {
      addBadge(
        "matching-family-tag",
        settings.familyLabel ||
          "MATCHING FAMILY"
      );
    }

    if (!badges.length) {
      return "";
    }

    return (
      '<div class="product-tags-bottom">' +
        badges.join("") +
      '</div>'
    );
  };


TagalysCustomisations.isProtectedQuickAddProduct =
  function (product) {
    var settings =
      TagalysCustomisations
        .getQuickAddSettings();

    var protectedHandles =
      Array.isArray(
        settings.protectedCollectionHandles
      )
        ? settings.protectedCollectionHandles
        : [];

    var productHandles =
      product &&
      Array.isArray(
        product.collectionHandles
      )
        ? product.collectionHandles
        : [];

    return productHandles.some(function (handle) {
      return protectedHandles.indexOf(handle) !== -1;
    });
  };


TagalysCustomisations.getQuickAddVariantLabel =
  function (variant) {
    var selectedOptions =
      variant &&
      Array.isArray(
        variant.selectedOptions
      )
        ? variant.selectedOptions
        : [];

    if (selectedOptions.length > 1) {
      return selectedOptions[1].value ||
        variant.title || "";
    }

    return variant && variant.title
      ? variant.title
      : "";
  };


TagalysCustomisations.buildQuickAddHTML =
  function (product) {
    var settings =
      TagalysCustomisations
        .getQuickAddSettings();

    if (
      settings.enabled === false ||
      !product ||
      product.available === false ||
      product.preOrder === true ||
      TagalysCustomisations
        .isProtectedQuickAddProduct(
          product
        )
    ) {
      return "";
    }

    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    if (!variants.length) {
      return "";
    }

    var selectedVariantId =
      product.selectedVariantId ||
      (
        variants.find(function (variant) {
          return variant.available;
        }) || variants[0]
      ).id;

    var productUrl =
      TagalysCustomisations
        .productPageUrl(
          product
        );

    var variantButtons =
      variants
        .map(function (variant) {
          var classes =
            "quick-add-variant";

          if (
            String(variant.id) ===
            String(selectedVariantId)
          ) {
            classes += " active";
          }

          if (!variant.available) {
            classes += " disabled";
          }

          return (
            '<button' +
              ' type="button"' +
              ' class="' + classes + '"' +
              ' data-variant-id="' +
                TagalysCustomisations.escapeHTML(
                  variant.id
                ) +
              '"' +
              (
                variant.available
                  ? ""
                  : " disabled"
              ) +
            '>' +
              TagalysCustomisations.escapeHTML(
                TagalysCustomisations
                  .getQuickAddVariantLabel(
                    variant
                  )
              ) +
            '</button>'
          );
        })
        .join("");

    var variantOptions =
      variants
        .map(function (variant) {
          return (
            '<option' +
              ' value="' +
                TagalysCustomisations.escapeHTML(
                  variant.id
                ) +
              '"' +
              (
                String(variant.id) ===
                String(selectedVariantId)
                  ? " selected"
                  : ""
              ) +
              (
                variant.available
                  ? ""
                  : " disabled"
              ) +
            '>' +
              TagalysCustomisations.escapeHTML(
                variant.title || ""
              ) +
            '</option>'
          );
        })
        .join("");

    var variantsClass =
      "add-to-bag-panel__variants" +
      (
        variants.length === 1
          ? " hide"
          : ""
      );

    var addToBagLabel =
      settings.addToBagLabel ||
      "Add to bag";

    var addToBagCartLabel =
      settings.addToBagCartLabel ||
      addToBagLabel;

    return (
      '<quick-buy>' +

        '<a' +
          ' href="' +
            TagalysCustomisations.escapeHTML(
              productUrl
            ) +
          '"' +
          ' class="add-to-bag-panel__panel-button"' +
          ' title="Open quick add for ' +
            TagalysCustomisations.escapeHTML(
              product.title
            ) +
          '"' +
        '>' +
              
          '<svg class="quick-add-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27" fill="none">' +
            '<path d="M0.756836 5.75691L4.50684 0.756912H19.5068L23.2568 5.75691M0.756836 5.75691V23.2569C0.756836 23.92 1.02023 24.5558 1.48907 25.0247C1.95791 25.4935 2.59379 25.7569 3.25684 25.7569H20.7568C21.4199 25.7569 22.0558 25.4935 22.5246 25.0247C22.9934 24.5558 23.2568 23.92 23.2568 23.2569V5.75691M0.756836 5.75691H23.2568M17.0068 10.7569C17.0068 12.083 16.4801 13.3548 15.5424 14.2924C14.6047 15.2301 13.3329 15.7569 12.0068 15.7569C10.6808 15.7569 9.40898 15.2301 8.4713 14.2924C7.53362 13.3548 7.00684 12.083 7.00684 10.7569" stroke="currentColor" stroke-width="1.51382" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span class="hide">' +
            TagalysCustomisations.escapeHTML(
              addToBagCartLabel
            ) +
          '</span>' +
        '</a>' +

        '<div class="add-to-bag-panel product-card__add-to-bag hide">' +
          '<form class="add-to-bag-panel__content">' +
            '<button class="icon add-to-bag-panel__close-button" type="button" tabindex="0" aria-label="Close">' +
              '<svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 64 64">' +
                '<path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path>' +
              '</svg>' +
            '</button>' +

            '<div class="' + variantsClass + '">' +
              '<div class="h4">Size</div>' +
              '<div class="quick-add-variants">' +
                variantButtons +
              '</div>' +
              '<select' +
                ' id="product-select-' +
                  TagalysCustomisations.escapeHTML(
                    product.id
                  ) +
                '"' +
                ' name="id"' +
                ' class="ajax-multi_select visually-hidden"' +
              '>' +
                variantOptions +
              '</select>' +
            '</div>' +

            '<button type="button" class="add-to-bag-button btn btn--base ajax-submit">' +
              TagalysCustomisations.escapeHTML(
                addToBagLabel
              ) +
            '</button>' +
          '</form>' +
        '</div>' +
      '</quick-buy>'
    );
  };


TagalysCustomisations.applyFullCardDetails =
  function (card, product) {
    if (!card || !product) {
      return;
    }

    var badges =
      card.querySelector(
        "[data-tagalys-card-badges]"
      );

    if (badges) {
      badges.innerHTML =
        TagalysCustomisations
          .buildBadgesHTML(
            product
          );
    }

    var quickAdd =
      card.querySelector(
        "[data-tagalys-quick-add]"
      );

    if (quickAdd) {
      if (
        card.closest(
          "predictive-search"
        )
      ) {
        quickAdd.innerHTML = "";
      } else {
        quickAdd.innerHTML =
          TagalysCustomisations
            .buildQuickAddHTML(
              product
            );
      }
    }

    card.setAttribute(
      "data-tagalys-details-loaded",
      "true"
    );

    card.removeAttribute(
      "data-tagalys-details-loading"
    );
  };


TagalysCustomisations.fetchCardDetailsBatch =
  function (handles) {
    var api =
      TagalysCustomisations
        .getStorefrontAPIConfig();

    if (
      !api.token ||
      !handles.length
    ) {
      return Promise.resolve({});
    }

    var productQueries =
      handles
        .map(function (handle, index) {
          return `
            product${index}: product(
              handle: ${JSON.stringify(handle)}
            ) {
              ...TagalysCardDetailsFields
            }
          `;
        })
        .join("\n");

    var query = `
      query TagalysCardDetails(
        $country: CountryCode!
      )
      @inContext(
        country: $country
      ) {
        ${productQueries}
      }

      fragment TagalysCardDetailsFields on Product {
        id
        handle
        title
        vendor
        availableForSale
        tags
        publishedAt

        images(first: 12) {
          nodes {
            url
            altText
            width
            height
          }
        }

        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }

        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }

        selectedOrFirstAvailableVariant {
          id
        }

        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            sku
            selectedOptions {
              name
              value
            }
          }
        }

        collections(first: 50) {
          nodes {
            handle
          }
        }

        preOrder: metafield(
          namespace: "custom"
          key: "pre_order"
        ) {
          value
        }

        newTagEndDate: metafield(
          namespace: "custom"
          key: "new_tag_end_date"
        ) {
          value
        }

        colours: metafield(
          namespace: "custom"
          key: "colours"
        ) {
          value
        }

        hexCode: metafield(
          namespace: "custom"
          key: "hex_code"
        ) {
          value
        }

        colour: metafield(
          namespace: "custom"
          key: "colour"
        ) {
          value
        }
      }
    `;

    return fetch(
      "https://" +
        api.domain +
        "/api/2026-07/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
          "X-Shopify-Storefront-Access-Token":
            api.token
        },
        body: JSON.stringify({
          query: query,
          variables: {
            country: api.country
          }
        })
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Storefront API request failed: " +
            response.status
          );
        }

        return response.json();
      })
      .then(function (response) {
        if (
          response.errors &&
          response.errors.length
        ) {
          throw new Error(
            response.errors
              .map(function (error) {
                return error.message;
              })
              .join("; ")
          );
        }

        var output = {};
        var data = response.data || {};

        handles.forEach(function (handle, index) {
          var raw =
            data["product" + index] || null;

          if (!raw) {
            output[handle] = null;
            return;
          }

          var product =
            TagalysCustomisations
              .normaliseStorefrontProduct(
                raw
              );

          output[handle] = product;

          if (product) {
            TagalysCustomisations
              .cardProductCache[
                handle
              ] = product;
          }
        });

        return output;
      });
  };


TagalysCustomisations.loadTagalysCardDetails =
  function () {
    var cards =
      document.querySelectorAll(
        '[data-tagalys-product-card]:not([data-tagalys-details-loaded]):not([data-tagalys-details-loading])'
      );

    if (!cards.length) {
      return;
    }

    var handles = [];

    Array.prototype.forEach.call(
      cards,
      function (card) {
        var handle =
          card.getAttribute(
            "data-product-handle"
          );

        if (!handle) {
          return;
        }

        card.setAttribute(
          "data-tagalys-details-loading",
          "true"
        );

        var cached =
          TagalysCustomisations
            .cardProductCache[
              handle
            ];

        if (
          cached &&
          cached._isFullProduct
        ) {
          TagalysCustomisations
            .applyFullCardDetails(
              card,
              cached
            );
          return;
        }

        if (
          handles.indexOf(handle) === -1
        ) {
          handles.push(handle);
        }
      }
    );

    if (!handles.length) {
      return;
    }

    var batchSize = 12;
    var requests = [];

    for (
      var i = 0;
      i < handles.length;
      i += batchSize
    ) {
      requests.push(
        TagalysCustomisations
          .fetchCardDetailsBatch(
            handles.slice(
              i,
              i + batchSize
            )
          )
      );
    }

    Promise.all(requests)
      .then(function (results) {
        var products = {};

        results.forEach(function (result) {
          Object.keys(result)
            .forEach(function (handle) {
              products[handle] =
                result[handle];
            });
        });

        Array.prototype.forEach.call(
          cards,
          function (card) {
            if (
              card.getAttribute(
                "data-tagalys-details-loaded"
              ) === "true"
            ) {
              return;
            }

            var handle =
              card.getAttribute(
                "data-product-handle"
              );

            var product =
              products[handle] ||
              TagalysCustomisations
                .cardProductCache[
                  handle
                ];

            if (product) {
              TagalysCustomisations
                .applyFullCardDetails(
                  card,
                  product
                );
            } else {
              card.removeAttribute(
                "data-tagalys-details-loading"
              );
            }
          }
        );
      })
      .catch(function (error) {
        console.error(
          "[Tagalys Cards] Could not load badge/quick-add details:",
          error
        );

        Array.prototype.forEach.call(
          cards,
          function (card) {
            card.removeAttribute(
              "data-tagalys-details-loading"
            );
          }
        );
      });
  };

TagalysCustomisations.buildPriceHTML =
  function (product) {
    var settings =
      TagalysCustomisations
        .getProductCardSettings();

    var price =
      Number(
        product.price || 0
      );

    var compare =
      Number(
        product.compare_at_price || 0
      );

    var onSale =
      compare > price;

    var priceText =
      TagalysCustomisations
        .formatCardMoney(
          price
        );

    var output =
      "";

    if (onSale) {
      output +=
        '<span class="visually-hidden">Regular price</span>' +

        '<span class="grid-product__price--original">' +
          TagalysCustomisations
            .formatCardMoney(
              compare
            ) +
        '</span>' +

        '<span class="visually-hidden">Sale price</span>';
    }

    if (
      product.price_varies
    ) {
      output +=
        '<span' +
          (
            onSale
              ? ' class="grid-product__price--sale"'
              : ''
          ) +
        '>' +
          'From ' +
          priceText +
        '</span>';
    } else {
      output +=
        '<span' +
          (
            onSale
              ? ' class="grid-product__price--sale"'
              : ''
          ) +
        '>' +
          priceText +
        '</span>';
    }

    if (
      onSale &&
      settings.productSaveAmount
    ) {
      var saving;

      if (
        settings.productSaveType ===
        "dollar"
      ) {
        saving =
          TagalysCustomisations
            .formatCardMoney(
              compare -
              price
            );
      } else {
        saving =
          Math.round(
            (
              (
                compare -
                price
              ) /
              compare
            ) *
            100
          ) + "%";
      }

      output +=
        '<span class="grid-product__price--savings">' +
          'Save ' +
          TagalysCustomisations.escapeHTML(
            saving
          ) +
        '</span>';
    }

    return output;
  };


TagalysCustomisations.replaceTagalysCardProduct =
  function (
    card,
    product
  ) {
    if (
      !card ||
      !product
    ) {
      return;
    }

    var productLink =
      TagalysCustomisations
        .productPageUrl(
          product
        );

    card.setAttribute(
      "data-product-handle",
      product.handle
    );

    card.setAttribute(
      "data-product-id",
      product.id || ""
    );

    var gallery =
      card.querySelector(
        "[data-tagalys-card-gallery]"
      );

    if (gallery) {
      gallery.innerHTML =
        TagalysCustomisations
          .buildGalleryHTML(
            product
          );
    }

    var badges =
      card.querySelector(
        "[data-tagalys-card-badges]"
      );

    if (badges) {
      badges.innerHTML =
        TagalysCustomisations
          .buildBadgesHTML(
            product
          );
    }

    var quickAdd =
      card.querySelector(
        "[data-tagalys-quick-add]"
      );

    if (quickAdd) {
      if (
        card.closest(
          "predictive-search"
        )
      ) {
        quickAdd.innerHTML = "";
      } else {
        quickAdd.innerHTML =
          TagalysCustomisations
            .buildQuickAddHTML(
              product
            );
      }
    }

    card.setAttribute(
      "data-tagalys-details-loaded",
      "true"
    );

    card.removeAttribute(
      "data-tagalys-details-loading"
    );

    var links =
      card.querySelectorAll(
        ".product-link, " +
        ".grid-product__meta-link, " +
        ".grid-product__gallery"
      );

    Array.prototype
      .forEach.call(
        links,
        function (link) {
          link.href =
            productLink;

          link.title =
            product.title;

          if (
            link.hasAttribute(
              "data-product-url"
            )
          ) {
            link.setAttribute(
              "data-product-url",
              productLink
            );
          }
        }
      );

    var title =
      card.querySelector(
        "[data-tagalys-card-title]"
      );

    if (title) {
      title.textContent =
        product.title;
    }

    var vendor =
      card.querySelector(
        "[data-tagalys-card-vendor]"
      );

    if (vendor) {
      vendor.textContent =
        product.vendor || "";
    }

    var priceContainer =
      card.querySelector(
        "[data-tagalys-card-price]"
      );

    if (priceContainer) {
      priceContainer.innerHTML =
        TagalysCustomisations
          .buildPriceHTML(
            product
          );
    }

    var price =
      Number(
        product.price || 0
      );

    var compare =
      Number(
        product.compare_at_price || 0
      );

    var onSale =
      compare > price;

    card.classList.toggle(
      "grid-product--sale",
      onSale &&
      product.available !== false
    );

    card.classList.toggle(
      "grid-product--sold-out",
      product.available === false
    );

    var swatchSlot =
      card.querySelector(
        "[data-tagalys-swatches-slot]"
      );

    if (swatchSlot) {
      swatchSlot.setAttribute(
        "data-product-handle",
        product.handle
      );
    }

    var swatchButtons =
      card.querySelectorAll(
        "[data-tagalys-swatch-handle]"
      );

    Array.prototype
      .forEach.call(
        swatchButtons,
        function (button) {
          var swatch =
            button.closest(
              ".c-product-item__swatches__swatch"
            );

          if (!swatch) {
            return;
          }

          swatch.classList.toggle(
            "active-swatch",
            button.getAttribute(
              "data-tagalys-swatch-handle"
            ) ===
            product.handle
          );
        }
      );

    card.classList.remove(
      "tagalys-card--loading"
    );

    card.removeAttribute(
      "aria-busy"
    );
  };


TagalysCustomisations.initTagalysCardEnhancements =
  function () {
    if (
      !TagalysCustomisations
        .tagalysSwatchClickBound
    ) {
      document.addEventListener(
        "click",
        function (event) {
          var button =
            event.target &&
            event.target.closest
              ? event.target.closest(
                  "[data-tagalys-swatch-handle]"
                )
              : null;

          if (!button) {
            return;
          }

          var card =
            button.closest(
              "[data-tagalys-product-card]"
            );

          if (!card) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          var handle =
            button.getAttribute(
              "data-tagalys-swatch-handle"
            );

          if (
            !handle ||
            handle ===
              card.getAttribute(
                "data-product-handle"
              )
          ) {
            return;
          }

          card.classList.add(
            "tagalys-card--loading"
          );

          card.setAttribute(
            "aria-busy",
            "true"
          );

          TagalysCustomisations
            .fetchStorefrontProduct(
              handle
            )
            .then(function (
              product
            ) {
              if (!product) {
                throw new Error(
                  "Linked product was not returned by Shopify."
                );
              }

              TagalysCustomisations
                .replaceTagalysCardProduct(
                  card,
                  product
                );
            })
            .catch(function (
              error
            ) {
              card.classList.remove(
                "tagalys-card--loading"
              );

              card.removeAttribute(
                "aria-busy"
              );

              console.error(
                "[Tagalys Swatches] Could not switch product:",
                handle,
                error
              );
            });
        },
        true
      );

      TagalysCustomisations
        .tagalysSwatchClickBound =
        true;
    }

    if (
      !TagalysCustomisations
        .tagalysCardObserver
    ) {
      var timeout =
        null;

      TagalysCustomisations
        .tagalysCardObserver =
        new MutationObserver(
          function () {
            window.clearTimeout(
              timeout
            );

            timeout =
              window.setTimeout(
                function () {
                  TagalysCustomisations
                    .loadTagalysCardSwatches();

                  TagalysCustomisations
                    .loadTagalysCardDetails();
                },
                50
              );
          }
        );

      TagalysCustomisations
        .tagalysCardObserver
        .observe(
          document.body,
          {
            childList:
              true,

            subtree:
              true
          }
        );
    }

    TagalysCustomisations
      .loadTagalysCardSwatches();

    TagalysCustomisations
      .loadTagalysCardDetails();
  };


TagalysCustomisations.applySearchResultsThemeLayout =
  function (selector) {
    var resultsContainer =
      document.querySelector(selector);

    if (!resultsContainer) {
      return;
    }

    var cards =
      Array.prototype.slice.call(
        resultsContainer.querySelectorAll(
          ".tagalys-search-product"
        )
      );

    if (!cards.length) {
      return;
    }

    /*
     * Find the Tagalys element that directly contains
     * all rendered product templates.
     *
     * Usually all product templates share the same parent.
     */
    var productGrid =
      cards[0].parentElement;

    var allHaveSameParent =
      cards.every(function (card) {
        return (
          card.parentElement ===
          productGrid
        );
      });

    if (
      !productGrid ||
      !allHaveSameParent
    ) {
      console.warn(
        "[Tagalys] Could not locate common products wrapper."
      );

      return;
    }

    /*
     * Reproduce the exact parent used by:
     * snippets/collection-grid.liquid
     */
    productGrid.classList.add(
      "grid",
      "grid--uniform",
      "collection-product-container"
    );

    /*
     * Remove any inline layout properties Tagalys
     * may have added.
     */
    productGrid.style.display = "";
    productGrid.style.gridTemplateColumns = "";
    productGrid.style.gap = "";
    productGrid.style.width = "";

    cards.forEach(function (card) {
      card.style.width = "";
      card.style.maxWidth = "";
      card.style.flex = "";
      card.style.marginLeft = "";
      card.style.marginRight = "";
    });
  };
TagalysCustomisations.getAppliedFilterCount = function (helpers) {
  var appliedFilters = helpers.getAppliedFilters(true) || [];
  var count = 0;

  appliedFilters.forEach(function (filter) {
    if (filter.type === "range") {
      count += 1;
      return;
    }

    if (Array.isArray(filter.items)) {
      count += filter.items.length;
      return;
    }

    count += 1;
  });

  return count;
};



/* =========================================================
   THREADBARE SEARCH RESULTS FEEDBACK
   ========================================================= */

TagalysCustomisations.getSearchResultsHeading =
  function (helpers) {
    if (!helpers) {
      return "";
    }

    var query =
      typeof helpers.getQuery === "function"
        ? String(helpers.getQuery() || "")
        : "";

    var originalQuery =
      typeof helpers.getOriginalQuery === "function"
        ? String(helpers.getOriginalQuery() || "")
        : "";

    var total =
      typeof helpers.getTotalProductsCount === "function"
        ? Number(helpers.getTotalProductsCount() || 0)
        : 0;

    if (
      typeof helpers.isPartialResults === "function" &&
      helpers.isPartialResults()
    ) {
      return (
        total +
        " partially matching result" +
        (total === 1 ? "" : "s") +
        " found for: " +
        (originalQuery || query)
      );
    }

    if (
      typeof helpers.isSpellingCorrectedQuery === "function" &&
      helpers.isSpellingCorrectedQuery()
    ) {
      return (
        "No results for ‘" +
        (originalQuery || query) +
        "’. Showing " +
        total +
        " result" +
        (total === 1 ? "" : "s") +
        " for ‘" +
        query +
        "’ instead."
      );
    }

    if (
      (
        typeof helpers.isValidQuery === "function" &&
        helpers.isValidQuery() === false
      ) ||
      total === 0
    ) {
      return (
        "No results for ‘" +
        (originalQuery || query) +
        "’."
      );
    }

    return (
      total +
      " result" +
      (total === 1 ? "" : "s") +
      " found for: " +
      (query || originalQuery)
    );
  };


TagalysCustomisations.updateSearchDocumentTitle =
  function (helpers) {
    if (
      !helpers ||
      typeof helpers.getTotalProductsCount !== "function"
    ) {
      return;
    }

    var total =
      Number(
        helpers.getTotalProductsCount() || 0
      );

    var query =
      typeof helpers.getOriginalQuery === "function"
        ? String(helpers.getOriginalQuery() || "")
        : "";

    if (
      !query &&
      typeof helpers.getQuery === "function"
    ) {
      query =
        String(helpers.getQuery() || "");
    }

    if (!query) {
      return;
    }

    var config =
      window.TagalysShopifyConfig || {};

    var shopName =
      config.shopName ||
      "Threadbare";

    document.title =
      "Search: " +
      total +
      " result" +
      (total === 1 ? "" : "s") +
      ' found for "' +
      query +
      '" – ' +
      shopName;
  };


TagalysCustomisations.getSearchGridColumns =
  function () {
    var target =
      document.querySelector(
        ".tagalys-search-product-grid"
      );

    if (!target) {
      return (
        window.matchMedia &&
        window.matchMedia(
          "(max-width: 768px)"
        ).matches
          ? 2
          : 4
      );
    }

    var supported =
      [6, 4, 3, 2, 1];

    for (
      var index = 0;
      index < supported.length;
      index += 1
    ) {
      if (
        target.classList.contains(
          "grid-" +
          supported[index] +
          "-col-per-row"
        )
      ) {
        return supported[index];
      }
    }

    return (
      window.matchMedia &&
      window.matchMedia(
        "(max-width: 768px)"
      ).matches
        ? 2
        : 4
    );
  };


TagalysCustomisations.renderSearchGridExpander =
  function (html) {
    var columns =
      TagalysCustomisations
        .getSearchGridColumns();

    return html`
      <grid-expander
        class="tagalys-search-grid-expander"
        target="tagalys-search-product-grid"
      >
        <div class="grid-expander">

          <button
            type="button"
            data-cols="1"
            class="hide"
            title="Show 1 product per row"
            aria-label="Show 1 product per row"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="36"
              viewBox="0 0 15 36"
              fill="none"
            >
              <rect
                x="0.4"
                y="0.4"
                width="14.2"
                height="35.2"
                stroke="currentColor"
                stroke-width="0.8"
              />
            </svg>
          </button>

          <button
            type="button"
            data-cols="2"
            class=${columns === 2
              ? "medium-up--hide active"
              : "medium-up--hide"}
            title="Show 2 product per row"
            aria-label="Show 2 product per row"
          >
            <svg
              class="medium-up--hide"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              viewBox="0 0 20 36"
              fill="none"
            >
              <rect x="11.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="0.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
            </svg>
          </button>

          <button
            type="button"
            data-cols="3"
            class=${columns === 3
              ? "medium-up--hide active"
              : "medium-up--hide"}
            title="Show 3 product per row"
            aria-label="Show 3 product per row"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
              <rect x="0.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="22.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="11.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
            </svg>
          </button>

          <button
            type="button"
            data-cols="4"
            class=${columns === 4
              ? "small--hide active"
              : "small--hide"}
            title="Show 4 product per row"
            aria-label="Show 4 product per row"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" fill="none">
              <rect x="0.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="22.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="11.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="33.4" y="0.4" width="8.2" height="35.2" stroke="currentColor" stroke-width="0.8" />
            </svg>
          </button>

          <button
            type="button"
            data-cols="6"
            class=${columns === 6
              ? "small--hide column-six-selector active"
              : "small--hide column-six-selector"}
            title="Show 6 product per row"
            aria-label="Show 6 product per row"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" fill="none">
              <rect x="0.4" y="0.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="0.4" y="19.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="11.4" y="0.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="11.4" y="19.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="22.4" y="0.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="22.4" y="19.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="33.4" y="0.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
              <rect x="33.4" y="19.4" width="8.2" height="16.2" stroke="currentColor" stroke-width="0.8" />
            </svg>
          </button>

        </div>
      </grid-expander>
    `;
  };


TagalysCustomisations.getSearchResultsThemeTemplates = function () {
  return {
    /*
     * Query feedback from the Tagalys SearchResults helpers.
     */
    header: {
      render: function (html, args) {
        var heading =
          TagalysCustomisations
            .getSearchResultsHeading(
              args.props.helpers
            );

        if (!heading) {
          return null;
        }

          let query = args.props.helpers.getQuery();
          let queryIndex = heading.indexOf(query);

          return html`
          <div
            class="tagalys-search-results-message"
            role="status"
            aria-live="polite"
          >
            ${heading.substring(0, queryIndex)}
            <strong class="tagalys-search-query">${query}</strong>
            ${heading.substring(queryIndex + query.length)}
          </div>
        `;
      },
    },


    /* =========================================================
       LOADER
       ========================================================= */

    loader: {
      render: function (html) {
        return html`
          <div class="tagalys-search-loader">
            Loading...
          </div>
        `;
      },
    },


    /* =========================================================
       PRODUCT
       Existing custom Threadbare product card
       ========================================================= */

    product: TagalysCustomisations.getProductTemplate(),


    /* =========================================================
       PRODUCTS GRID

       This is important:
       Render the EXACT parent classes expected by Impulse.
       ========================================================= */

    products: {
      render: function (html, args) {
        var helpers = args.props.helpers;

        var products =
          (helpers.getProducts() || [])
            .slice();

        var requestState =
          typeof helpers.getRequestState === "function"
            ? helpers.getRequestState() || {}
            : {};

        var relevanceQuery =
          requestState.query ||
          (
            typeof helpers.getOriginalQuery === "function"
              ? helpers.getOriginalQuery()
              : ""
          ) ||
          new URLSearchParams(
            window.location.search
          ).get("q") ||
          "";

        products =
          TagalysCustomisations
            .rankSearchProductsFast(
              products,
              relevanceQuery,
              TagalysCustomisations
                .getStoredSearchGender()
            );

        return html`
          <div
            class="grid grid--uniform collection-product-container"
          >
            ${products.map(function (product) {
              return html`
                <${args.templates.product}
                  key=${product.id}
                  product=${product}
                />
              `;
            })}
          </div>
        `;
      },
    },


    /* =========================================================
       PRODUCT LIST HEADER

       Same Sort & Filter toolbar as collection-grid.liquid
       ========================================================= */

    productListHeader: {
      render: function (html, args) {
        var helpers = args.props.helpers;

        var activeFilterCount =
          TagalysCustomisations.getAppliedFilterCount(
            helpers
          );

        var totalProducts =
          helpers.getTotalProductsCount();

        var buttonClass =
          "btn btn--tertiary";

        if (activeFilterCount > 0) {
          buttonClass += " btn--tertiary-active";
        }

        return html`
          <div
            class="collection-filter collection-filter--new-layout"
          >
            <div
              class="collection-filter__item collection-filter__item--drawer"
            >
              <button
                type="button"
                class=${buttonClass}
                onClick=${helpers.openFilterDrawer}
              >
                <svg
                  class="icon-custom-filter"
                  aria-hidden="true"
                  focusable="false"
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                >
                  <path
                    d="M0 2.5H10.3M15.5 2.5H18M0 8H2.5M7.7 8H18M0 13.5H10.3M15.5 13.5H18"
                    stroke="currentColor"
                    stroke-width="1"
                  />

                  <circle
                    cx="12.9"
                    cy="2.5"
                    r="1.9"
                    stroke="currentColor"
                  />

                  <circle
                    cx="5.1"
                    cy="8"
                    r="1.9"
                    stroke="currentColor"
                  />

                  <circle
                    cx="12.9"
                    cy="13.5"
                    r="1.9"
                    stroke="currentColor"
                  />
                </svg>

                <span>
                  Sort & Filter
                  ${
                    activeFilterCount > 0
                      ? " (" + activeFilterCount + ")"
                      : ""
                  }
                </span>
              </button>
            </div>

            <div class="collection-filter__right-side">
              <div
                class="collection-filter__item collection-filter__item--count"
              >
                ${totalProducts} products
              </div>

              ${TagalysCustomisations
                .renderSearchGridExpander(
                  html
                )}
            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       FILTERS / DRAWER

       Important:
       Tagalys owns open/close state.
       We only provide Threadbare markup.
       ========================================================= */

    filters: {
      options: {
        collapsible: true,

        /*
         * Threadbare puts sorting at the top of
         * the same filter drawer.
         */
        includeSortOptionsInFilters: "top",

        autoCollapse: false,

        showAppliedFilters: true,

        showClearAllFilters: true,

        /*
         * Threadbare doesn't have a Clear action
         * beside every accordion heading.
         */
        showClearActionForIndividualFilters: false,

        /*
         * Existing Threadbare filters don't display
         * product counts next to each checkbox.
         */
        showMatchingProductsCount: false,

        defaultExpandedFilters: [],

        /*
         * Your theme uses the DRAWER filter style,
         * so use the drawer at all breakpoints.
         */
        showFiltersInDrawer: true,

        /*
         * Keep filters collapsed initially.
         */
        expandTopNFiltersByDefault: false,
      },

      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;
        var labels = args.labels;

        var filters = helpers.getFilters() || [];
        var appliedFilters =
          helpers.getAppliedFilters(true) || [];

        var drawerOpen =
          helpers.isFilterDrawerOpen();

        var drawerClass =
          "drawer drawer--left drawer--mobile-bottom " +
          "tagalys-threadbare-filter-drawer";

        if (drawerOpen) {
          drawerClass += " drawer--is-open";
        }

        /*
         * Match native Threadbare behavior:
         * don't expose Availability.
         *
         * Also hide Gender if Tagalys returns less
         * than two usable values.
         */
        filters = filters.filter(function (filter) {
          var label = String(
            filter.label || ""
          ).toLowerCase();

          if (label === "availability") {
            return false;
          }

          if (
            label === "gender" &&
            (!filter.items || filter.items.length < 2)
          ) {
            return false;
          }

          return true;
        });

        var showClearAll =
          props.showClearAllFilters &&
          appliedFilters.length > 0;

        return html`
          <div class=${drawerClass}>
            <div class="drawer__contents">

              <${args.templates.filtersHeader} />

              <div class="drawer__scrollable">

                ${
                  props.showAppliedFilters
                    ? html`
                        <${args.templates.appliedFilters} />
                      `
                    : null
                }

                ${
                  showClearAll
                    ? html`
                        <div class="tagalys-clear-all-wrapper">
                          <button
                            type="button"
                            class="btn btn--small tagalys-clear-all"
                            onClick=${helpers.clearAllFilters}
                          >
                            ${labels.filters.clearAllFilters}
                          </button>
                        </div>
                      `
                    : null
                }

                <div
                  class="filter-form collapsible loadmore tagalys-filter-form"
                >
                  ${
                    props.includeSortOptionsInFilters === "top"
                      ? html`
                          <${args.templates.sortOptionInFilters} />
                        `
                      : null
                  }

                  ${filters.map(function (filter) {
                    return html`
                      <${args.templates.filter}
                        filter=${filter}
                      />
                    `;
                  })}

                  ${
                    props.includeSortOptionsInFilters === true ||
                    props.includeSortOptionsInFilters === "bottom"
                      ? html`
                          <${args.templates.sortOptionInFilters} />
                        `
                      : null
                  }
                </div>

              </div>
            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       DRAWER HEADER
       ========================================================= */

    filtersHeader: {
      render: function (html, args) {
        var helpers = args.props.helpers;

        return html`
          <div class="drawer__fixed-header">
            <div class="drawer__header">

              <div class="h2 drawer__title">
                Sort & Filter
              </div>

              <div class="drawer__close">
                <button
                  type="button"
                  class="drawer__close-button"
                  onClick=${helpers.closeFilterDrawer}
                  aria-label="Close filters"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    class="icon icon-close"
                    viewBox="0 0 64 64"
                  >
                    <path
                      d="m19 17.61 27.12 27.13m0-27.12L19 44.74"
                    />
                  </svg>

                  <span class="icon__fallback-text">
                    Close
                  </span>
                </button>
              </div>

            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       APPLIED FILTERS

       Same active-tag style as the native filter form.
       ========================================================= */

    appliedFilters: {
      render: function (html, args) {
        var helpers = args.props.helpers;

        var appliedFilters =
          helpers.getAppliedFilters(true) || [];

        if (!appliedFilters.length) {
          return null;
        }

        return html`
          <ul
            class="no-bullets tag-list tag-list--active-tags tagalys-active-filters"
          >
            ${appliedFilters.map(function (appliedFilter) {

              if (appliedFilter.type === "range") {
                var min =
                  helpers.labelFormatter(
                    appliedFilter.display_format,
                    appliedFilter.selected_min,
                    appliedFilter.currency
                  );

                var max =
                  helpers.labelFormatter(
                    appliedFilter.display_format,
                    appliedFilter.selected_max,
                    appliedFilter.currency
                  );

                return html`
                  <li class="tag tag--remove">
                    <button
                      type="button"
                      class="btn btn--small"
                      onClick=${function () {
                        helpers.clearFilter(
                          appliedFilter.id
                        );
                      }}
                    >
                      ${min} - ${max}
                    </button>
                  </li>
                `;
              }

              return (appliedFilter.items || []).map(
                function (filterItem) {
                  return html`
                    <li class="tag tag--remove">
                      <button
                        type="button"
                        class="btn btn--small"
                        onClick=${function () {
                          helpers.clearFilter(
                            appliedFilter.id,
                            filterItem.id
                          );
                        }}
                      >
                        ${filterItem.label}
                      </button>
                    </li>
                  `;
                }
              );
            })}
          </ul>
        `;
      },
    },


    /* =========================================================
       INDIVIDUAL FILTER GROUP
       ========================================================= */

    filter: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        var filter = props.filter;

        if (!filter) {
          return null;
        }

        var filterOptions =
          helpers.getTemplateOptions(
            "filters"
          );

        var expanded =
          !filterOptions.collapsible ||
          helpers.isCollapsibleFilterExpanded(
            filter.id
          );

        return html`
          <div
            class="tagalys-collection-sidebar-group"
            data-filter-id=${filter.id}
          >
            <div class="collection-sidebar__group">

              <${args.templates.filterHeader}
                filterHeading=${filter.label}
                filterId=${filter.id}
              />

              <${args.templates.filterItems}
                filter=${filter}
                expanded=${expanded}
              />

            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       FILTER ACCORDION HEADER
       ========================================================= */

    filterHeader: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        var filterOptions =
          helpers.getTemplateOptions(
            "filters"
          );

        var expanded =
          !filterOptions.collapsible ||
          helpers.isCollapsibleFilterExpanded(
            props.filterId
          );

        var buttonClass =
          "collapsible-trigger " +
          "collapsible-trigger-btn " +
          "collapsible--auto-height " +
          "tag-list__header";

        if (expanded) {
          buttonClass += " is-open";
        }

        var toggleFilter = function (event) {
          event.preventDefault();

          if (filterOptions.collapsible) {
            helpers.toggleCollapsibleFilter(
              props.filterId
            );
          }
        };

        return html`
          <button
            type="button"
            class=${buttonClass}
            onClick=${toggleFilter}
            aria-expanded=${expanded}
          >
            ${props.filterHeading}

            <span
              class="collapsible-trigger__icon collapsible-trigger__icon--open"
              role="presentation"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                class="icon icon--wide icon-chevron-down"
                viewBox="0 0 28 16"
              >
                <path
                  d="m1.57 1.59 12.76 12.77L27.1 1.59"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                />
              </svg>
            </span>
          </button>
        `;
      },
    },


    /* =========================================================
       FILTER CONTENT
       ========================================================= */

    filterItems: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        var filter = props.filter;

        var filterOptions =
          helpers.getTemplateOptions(
            "filters"
          );

        var expanded =
          !filterOptions.collapsible ||
          helpers.isCollapsibleFilterExpanded(
            filter.id
          );

        var contentClass =
          "collapsible-content " +
          "collapsible-content--sidebar";

        if (expanded) {
          contentClass += " is-open";
        }

        var contentStyle =
          expanded
            ? "height:auto;"
            : "height:0px;";

        return html`
          <div
            class=${contentClass}
            style=${contentStyle}
          >
            <div class="collapsible-content__inner">

              ${
                filter.type === "checkbox"
                  ? html`
                      <${args.templates.filterCheckBoxes}
                        filterId=${filter.id}
                        filterItems=${filter.items || []}
                      />
                    `
                  : html`
                      <${args.templates.rangeSliderFilterItem}
                        filter=${filter}
                      />
                    `
              }

            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       CHECKBOX LIST
       ========================================================= */

    filterCheckBoxes: {
      render: function (html, args) {
        var props = args.props;

        return html`
          <ul class="no-bullets tag-list">
            ${(props.filterItems || []).map(
              function (filterItem) {
                return html`
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                  >
                    ${
                      filterItem.selected &&
                      filterItem.items &&
                      filterItem.items.length
                        ? html`
                            <${args.templates.filterCheckBoxes}
                              filterId=${props.filterId}
                              filterItems=${filterItem.items}
                            />
                          `
                        : null
                    }
                  </${args.templates.checkboxFilterItem}>
                `;
              }
            )}
          </ul>
        `;
      },
    },


    /* =========================================================
       CHECKBOX ITEM

       Uses Threadbare:
       .tag
       .tag__checkbox-wrapper
       .tag__input
       .tag__checkbox
       .tag__text
       ========================================================= */

    checkboxFilterItem: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        var item = props.filterItem;

        if (!item) {
          return null;
        }

        var itemClass = "tag";

        if (item.selected) {
          itemClass += " tag--active";
        }

        /*
         * Same idea as native theme:
         * don't display unavailable values unless selected.
         */
        if (
          Number(item.count) === 0 &&
          !item.selected
        ) {
          itemClass += " hide";
        }

        var toggleFilter = function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (item.selected) {
            helpers.clearFilter(
              props.filterId,
              item.id
            );
          } else {
            helpers.applyFilter(
              props.filterId,
              item.id
            );
          }
        };

        return html`
          <li
            class=${itemClass}
            data-filter-item-id=${item.id}
            onClick=${toggleFilter}
          >
            <label
              class="tag__checkbox-wrapper text-label"
            >
              <input
                type="checkbox"
                class="tag__input"
                checked=${item.selected}
                tabindex="-1"
              />

              <span class="tag__checkbox"></span>

              <span>
                <span class="tag__text">
                  ${item.label}
                </span>

                ${
                  props.showMatchingProductsCount
                    ? html`
                        <span class="tagalys-filter-count">
                          (${item.count})
                        </span>
                      `
                    : null
                }
              </span>
            </label>

            ${props.children}
          </li>
        `;
      },
    },


    /* =========================================================
       PRICE / RANGE

       The theme already contains the noUiSlider styling:
       .price-range
       .price-range__slider
       .noUi-*
       ========================================================= */

    rangeSliderFilterItem: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        var filter = props.filter;

        var currentMin =
          props.sliderInputValues[0];

        var currentMax =
          props.sliderInputValues[1];

        var formattedMin =
          helpers.labelFormatter(
            filter.display_format,
            currentMin,
            filter.currency
          );

        var formattedMax =
          helpers.labelFormatter(
            filter.display_format,
            currentMax,
            filter.currency
          );

        return html`
          <div class="price-range">

            <div
              class="price-range__display-wrapper"
            >
              <span class="price-range__display-min">
                ${formattedMin}
              </span>

              <span class="price-range__display-max">
                ${formattedMax}
              </span>
            </div>

            <div
              class="price-range__slider-wrapper"
            >
              <div
                class="price-range__slider"
                ref=${props.sliderRef}
              ></div>
            </div>

            <input
              class="price-range__input price-range__input-min"
              type="number"
              value=${currentMin}
              onBlur=${props.onInputBlur}
              onChange=${props.onMinChange}
            />

            <input
              class="price-range__input price-range__input-max"
              type="number"
              value=${currentMax}
              onBlur=${props.onInputBlur}
              onChange=${props.onMaxChange}
            />

          </div>
        `;
      },
    },


    /* =========================================================
       SORT INSIDE DRAWER

       Same accordion + radio appearance used by Threadbare.
       ========================================================= */

    sortOptionInFilters: {
      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;
        var labels = args.labels;

        var filterOptions =
          helpers.getTemplateOptions(
            "filters"
          );

        var appliedSortOption =
          helpers.getAppliedSortOption();

        var sortOptions =
          helpers.getSortOptions() || [];

        var expanded =
          !filterOptions.collapsible ||
          helpers.isCollapsibleFilterExpanded(
            "sort_options"
          );

        var contentClass =
          "collapsible-content " +
          "collapsible-content--sidebar";

        if (expanded) {
          contentClass += " is-open";
        }

        return html`
          <div
            class="collection-sidebar__group--0"
            data-filter-id="sort_options"
          >
            <div class="collection-sidebar__group">

              <${args.templates.filterHeader}
                filterHeading=${labels.sortOptions.sortBy}
                filterId="sort_options"
              />

              <div
                class=${contentClass}
                style=${expanded
                  ? "height:auto;"
                  : "height:0px;"}
              >
                <div class="collapsible-content__inner">

                  <ul class="no-bullets tag-list">

                    ${sortOptions.map(function (sortOption) {
                      var checked =
                        sortOption.id ===
                        appliedSortOption.id;

                      var labelClass =
                        "tag__checkbox-wrapper text-label";

                      if (checked) {
                        labelClass += " is-active";
                      }

                      var selectSort =
                        function (event) {
                          event.preventDefault();
                          event.stopPropagation();

                          helpers.applySortOption(
                            sortOption.id
                          );
                        };

                      return html`
                        <li
                          class="tag"
                          onClick=${selectSort}
                        >
                          <label class=${labelClass}>

                            <input
                              type="radio"
                              class="tag__input"
                              checked=${checked}
                              tabindex="-1"
                            />

                            <span
                              class="tag__checkbox"
                            ></span>

                            <span class="tag__text">
                              ${
                                sortOption.label ===
                                "Featured"
                                  ? "Recommended"
                                  : sortOption.label
                              }
                            </span>

                          </label>
                        </li>
                      `;
                    })}

                  </ul>
                </div>
              </div>

            </div>
          </div>
        `;
      },
    },


    /* =========================================================
       PAGINATION — Threadbare collection appearance
       ========================================================= */

    paginationLinks: {
      options: {
        showNumberedPageLinks: true,
        numberedPageLinksWindowSize: 3,
        showPreviousPageLink: true,
        showFirstPageLink: false,
        showNextPageLink: true,
        scrollTop: true
      },

      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;
        var labels = args.labels || {};

        var pagesToDisplay =
          helpers.getPagesToDisplay(
            props.numberedPageLinksWindowSize
          ) || [];

        var hasPreviousPage =
          helpers.hasPreviousPage();

        var hasNextPage =
          helpers.hasNextPage();

        if (pagesToDisplay.length <= 1) {
          return null;
        }

        return html`
          <div class="pagination tagalys-search-pagination">

            ${props.showPreviousPageLink && hasPreviousPage
              ? html`
                  <span class="prev">
                    <button
                      type="button"
                      title=${labels.pagination ? labels.pagination.previousPage : "Previous"}
                      aria-label=${labels.pagination ? labels.pagination.previousPage : "Previous"}
                      onClick=${helpers.goToPreviousPage}
                    >
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98">
                        <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z" />
                      </svg>
                    </button>
                  </span>
                `
              : null}

            ${props.showNumberedPageLinks
              ? pagesToDisplay.map(function (pageDetail) {
                  if (pageDetail.jumpAfter) {
                    return html`
                      <span class="page">...</span>
                    `;
                  }

                  if (pageDetail.current) {
                    return html`
                      <span class="page current">
                        ${pageDetail.page}
                      </span>
                    `;
                  }

                  return html`
                    <span class="page">
                      <button
                        type="button"
                        onClick=${function () {
                          helpers.goToPage(
                            pageDetail.page
                          );
                        }}
                      >
                        ${pageDetail.page}
                      </button>
                    </span>
                  `;
                })
              : null}

            ${props.showNextPageLink && hasNextPage
              ? html`
                  <span class="next">
                    <button
                      type="button"
                      title=${labels.pagination ? labels.pagination.nextPage : "Next"}
                      aria-label=${labels.pagination ? labels.pagination.nextPage : "Next"}
                      onClick=${helpers.goToNextPage}
                    >
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98">
                        <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z" />
                      </svg>
                    </button>
                  </span>
                `
              : null}

          </div>
        `;
      },
    },


    pagination: {
      options: {
        infiniteScroll: false
      },

      render: function (html, args) {
        return html`
          <${args.templates.paginationLinks} />
        `;
      },
    },


    /* =========================================================
       NO RESULTS
       ========================================================= */

    noResults: {
      render: function (html, args) {
        var helpers =
          args.props.helpers;

        var query =
          typeof helpers.getOriginalQuery ===
            "function"
            ? String(
                helpers.getOriginalQuery() ||
                ""
              )
            : "";

        if (
          !query &&
          typeof helpers.getQuery ===
            "function"
        ) {
          query =
            String(
              helpers.getQuery() || ""
            );
        }

        return html`
          <div class="tagalys-search-no-results-state">
            <div
              class="tagalys-search-no-results-heading"
              role="status"
              aria-live="polite"
            >
              ${query
                ? html`
                    No results for ‘<strong>${query}</strong>’, Showing our New Arrivals instead
                  `
                : "No products found, Showing our New Arrivals instead"}
            </div>

            <div
              class="tagalys-search-no-results-recommendations"
              data-tagalys-search-no-results-recommendations
            ></div>
          </div>
        `;
      },
    },


    /* =========================================================
       SEARCH SUGGESTIONS ON RESULTS PAGE

       Tagalys SearchResults returns products/filters only.
       The SearchSuggestions Headless connector response is
       merged into SearchResults state and rendered here.
       ========================================================= */

    textSuggestions: {
      render: function (html, args) {
        var helpers =
          args.props.helpers;

        var state =
          helpers &&
          typeof helpers.getState === "function"
            ? helpers.getState()
            : {};

        var response =
          state && state.textSuggestions
            ? state.textSuggestions
            : null;

        var sections =
          response && response.sections
            ? response.sections
            : {};

        var getItems = function (section) {
          if (Array.isArray(section)) {
            return section;
          }

          if (
            section &&
            Array.isArray(section.items)
          ) {
            return section.items;
          }

          return [];
        };

        var collections =
          getItems(
            sections.collections
          );

        var pages =
          getItems(
            sections.pages
          );

        var searches =
          getItems(
            sections.Searches ||
            sections.searches ||
            sections.queries
          );

        if (
          !TagalysCustomisations
            .isSuggestionGroupEnabled(
              "searchResults",
              "collections"
            )
        ) {
          collections = [];
        }

        if (
          !TagalysCustomisations
            .isSuggestionGroupEnabled(
              "searchResults",
              "pages"
            )
        ) {
          pages = [];
        }

        if (
          !TagalysCustomisations
            .isSuggestionGroupEnabled(
              "searchResults",
              "searchSuggestions"
            )
        ) {
          searches = [];
        }

        var recentSearches =
          TagalysCustomisations
            .getRecentSearches()
            .map(function (query) {
              return {
                title: query,
                link:
                  TagalysCustomisations
                    .buildCanonicalSearchUrl(
                      query,
                      TagalysCustomisations
                        .getStoredSearchGender()
                    )
              };
            });

        /*
         * Recent Searches is only a filler column on Search Results.
         * If Search Suggestions + Collections + Pages are all present,
         * keep Recent Searches hidden. If ANY one of those groups is
         * missing, show Recent Searches (when we have recent items) so
         * the layout does not leave an unnecessary empty slot.
         */
        /*
         * Keep Recent Searches visible whenever the customer has saved
         * searches. It is no longer only a filler column.
         */
        var showRecentSearches =
          recentSearches.length > 0 &&
          TagalysCustomisations
            .isSuggestionGroupEnabled(
              "searchResults",
              "recentSearches"
            );

        if (!showRecentSearches) {
          recentSearches = [];
        }

        if (
          !recentSearches.length &&
          !collections.length &&
          !pages.length &&
          !searches.length
        ) {
          return null;
        }

        var renderGroup = function (
          title,
          items,
          type
        ) {
          if (!items.length) {
            return null;
          }

          return html`
            <div
              class="tagalys-search-results-suggestions__group tagalys-search-results-suggestions__group--${type}"
            >
              <div
                class="tagalys-search-results-suggestions__title"
              >
                ${title}
              </div>

              <ul
                class="tagalys-search-results-suggestions__list"
                aria-label=${title}
              >
                ${items.map(function (item) {
                  var itemTitle =
                    String(
                      item &&
                      (
                        item.title ||
                        item.name ||
                        item.query
                      ) ||
                      ""
                    ).trim();

                  if (!itemTitle) {
                    return null;
                  }

                  var itemLink =
                    item && item.link
                      ? String(item.link)
                      : "";

                  /*
                   * Search terms use Threadbare's canonical search URL and
                   * preserve the current Men / Women selection.
                   *
                   * Collections and Pages keep the exact URL returned by
                   * Tagalys; their VISIBILITY is filtered above using the
                   * same gender logic as predictive search.
                   */
                  if (type === "searches") {
                    itemLink =
                      TagalysCustomisations
                        .buildCanonicalSearchUrl(
                          itemTitle,
                          TagalysCustomisations
                            .getStoredSearchGender()
                        );
                  }

                  if (!itemLink) {
                    return null;
                  }

                  return html`
                    <li
                      class="tagalys-search-results-suggestions__item"
                    >
                      <a
                        class="tagalys-search-results-suggestions__link"
                        href=${itemLink}
                      >
                        ${itemTitle}
                      </a>
                    </li>
                  `;
                })}
              </ul>
            </div>
          `;
        };

        return html`
          <nav
            class="tagalys-search-results-suggestions"
            aria-label="Related search suggestions"
          >
            <div
              class="tagalys-search-results-suggestions__groups"
            >
              ${renderGroup(
                "Recent searches",
                recentSearches,
                "recent"
              )}

              ${renderGroup(
                "Search suggestions",
                searches,
                "searches"
              )}

              ${renderGroup(
                "Collections",
                collections,
                "collections"
              )}

              ${renderGroup(
                "Pages",
                pages,
                "pages"
              )}
            </div>
          </nav>
        `;
      },
    },


    /* =========================================================
       WIDGET OPTIONS / LAYOUT

       Keep Threadbare's existing SearchResults structure and
       place text suggestions above the product/filter area.
       ========================================================= */

    widget: {
      options: {
        includeTagalysCSS: false,
        canAppendQueryStringToUrl: true,
        perPage:
          TagalysCustomisations
            .searchResultsPerPage,
      },

      render: function (html, args) {
        var props = args.props;
        var helpers = props.helpers;

        if (helpers.isInitialLoading()) {
          return html`
            <${args.templates.loader} />
          `;
        }

        var classes = [
          "plp",
          "search-results"
        ];

        if (helpers.isFilterDrawerOpen()) {
          classes.push(
            "filter-drawer-opened"
          );
        }

        if (helpers.isLoading()) {
          classes.push("loading");
        }

        if (
          helpers.canShowFiltersInDrawer()
        ) {
          classes.push(
            "show-filters-in-drawer"
          );
        }

        var className =
          classes.join(" " );

        if (
          helpers.hasNoSearchResults() &&
          !helpers.hasAnyFiltersApplied()
        ) {
          return html`
            <div
              class="plp search-results"
            >
              <${args.templates.noResults} />
            </div>
          `;
        }

        return html`
          <div class=${className}>
            <${args.templates.header} />

            <${args.templates.textSuggestions} />

            ${helpers.isFilterDrawerOpen()
              ? html`
                  <div
                    class="filter-overlay"
                    onClick=${helpers.closeFilterDrawer}
                  ></div>
                `
              : null}

            <div
              class="filters-and-products-list"
            >
              <${args.templates.filters} />

              <div class="products-list">
                <${args.templates.productListHeader} />
                <${args.templates.products} />
                <${args.templates.productListFooter} />
              </div>
            </div>

            <${args.templates.footer} />
          </div>
        `;
      },
    },
  };
};
TagalysCustomisations.populateSearchInputs =
  function () {
    var params =
      new URLSearchParams(
        window.location.search
      );

    var query =
      params.get("query") ||
      params.get("q") ||
      "";

    if (!query) {
      return;
    }

    document
      .querySelectorAll(
        "[data-search-input]"
      )
      .forEach(function (input) {
        if (!input.value) {
          input.value = query;
        }
      });
  };

TagalysCustomisations.initSearchNoResultsRecommendations =
  function () {
    var selector =
      "[data-tagalys-search-no-results-recommendations]";

    var requestCount =
      TagalysCustomisations
        .recommendationProductCount;

    var widget =
      document.querySelector(selector);

    if (!widget) {
      return;
    }

    var gender =
      TagalysCustomisations
        .getStoredSearchGender();

    var recommendationId =
      TagalysCustomisations
        .getPredictiveRecommendationId
        ? TagalysCustomisations
            .getPredictiveRecommendationId()
        : "5465089e953ce041119b";

    if (!recommendationId) {
      return;
    }

    var currentId =
      widget.dataset
        .tagalysSearchNoResultsRecommendationId ||
      "";

    var currentGender =
      widget.dataset
        .tagalysSearchNoResultsRecommendationGender ||
      "";

    if (
      widget.dataset
        .tagalysSearchNoResultsInitialized ===
        "true" &&
      currentId === recommendationId &&
      currentGender === gender
    ) {
      return;
    }

    widget.dataset
      .tagalysSearchNoResultsRecommendationId =
      recommendationId;

    widget.dataset
      .tagalysSearchNoResultsRecommendationGender =
      gender;

    widget.dataset
      .tagalysSearchNoResultsRecommendationCount =
      String(requestCount);

    widget.innerHTML = "";

    Tagalys.UIWidgets.Recommendations.init(
      selector,
      {
        recommendationId:
          recommendationId,

        productPageUrl:
          TagalysCustomisations
            .productPageUrl,

        templates: {
          product:
            TagalysCustomisations
              .getProductTemplate(),

          widget: {
            options: {
              count:
                requestCount,
              displayFormat: "grid",
              includeTagalysCSS: false
            },

            render: function (html, args) {
              var props =
                args.props || {};

              var helpers =
                props.helpers;

              var products =
                helpers && helpers.getProducts
                  ? helpers.getProducts()
                  : [];

              if (props.loading) {
                return html`
                  <div class="tagalys-search-loader">
                    Loading...
                  </div>
                `;
              }

              if (!products || !products.length) {
                return null;
              }

              return html`
                <div
                  class="grid grid--uniform collection-product-container"
                >
                  ${products.map(function (product) {
                    return html`
                      <${args.templates.product}
                        key=${product.id}
                        product=${product}
                      />
                    `;
                  })}
                </div>
              `;
            }
          }
        },

        callbacks: {
          beforeAPICall: function (params) {
            return TagalysCustomisations
              .applyRecommendationGenderScope(
                params,
                gender
              );
          },

          afterEveryRender: function () {
            widget.dataset
              .tagalysSearchNoResultsInitialized =
              "true";

            TagalysCustomisations
              .initTagalysCardEnhancements();
          },

          onFailedAPICall: function () {
            widget.dataset
              .tagalysSearchNoResultsInitialized =
              "false";
          }
        }
      }
    );
  };


TagalysCustomisations.filterSearchResultsTextSuggestionsByGender =
  function (response, gender) {
    if (
      !response ||
      !response.sections
    ) {
      return response;
    }

    gender =
      TagalysCustomisations
        .normaliseSearchGender(
          gender
        );

    if (gender === "all") {
      return response;
    }

    var shouldKeep =
      function (item) {
        if (!item) {
          return false;
        }

        var searchableValue =
          [
            item.title || "",
            item.name || "",
            item.query || "",
            item.link || ""
          ]
            .join(" ");

        return TagalysCustomisations
          .shouldShowSuggestionForGender(
            searchableValue,
            gender
          );
      };

    var filterSection =
      function (section) {
        if (Array.isArray(section)) {
          return section.filter(
            shouldKeep
          );
        }

        if (
          section &&
          Array.isArray(section.items)
        ) {
          /*
           * Preserve every Tagalys field on the section object and replace
           * only its items array.
           */
          return Object.assign(
            {},
            section,
            {
              items:
                section.items.filter(
                  shouldKeep
                )
            }
          );
        }

        return section;
      };

    var filteredSections =
      Object.assign(
        {},
        response.sections
      );

    [
      "collections",
      "pages",
      "Searches",
      "searches",
      "queries"
    ].forEach(function (sectionName) {
      if (
        Object.prototype.hasOwnProperty.call(
          filteredSections,
          sectionName
        )
      ) {
        filteredSections[sectionName] =
          filterSection(
            filteredSections[sectionName]
          );
      }
    });

    return Object.assign(
      {},
      response,
      {
        sections:
          filteredSections
      }
    );
  };


TagalysCustomisations.fetchSearchResultsTextSuggestions =
  function (helpers, fallbackQuery) {
    if (
      !helpers ||
      !window.Tagalys ||
      !Tagalys.APIConnector ||
      !Tagalys.APIConnector.SearchSuggestions ||
      typeof Tagalys.APIConnector.SearchSuggestions.call !==
        "function"
    ) {
      return;
    }

    var requestState =
      typeof helpers.getRequestState === "function"
        ? helpers.getRequestState() || {}
        : {};

    var suggestionQuery =
      String(
        requestState.query ||
        fallbackQuery ||
        ""
      )
        .replace(/\*/g, "")
        .trim();

    if (!suggestionQuery) {
      return;
    }

    Tagalys.APIConnector.SearchSuggestions.call({
      params: {
        query: suggestionQuery,
        sections: {
          collections: {
            count: 10
          },
          pages: {
            count: 10
          },
          Searches: {
            count: 10
          }
        }
      },

      onSuccess: function (response) {
        var gender =
          TagalysCustomisations
            .getStoredSearchGender();

        var filteredResponse =
          TagalysCustomisations
            .filterSearchResultsTextSuggestionsByGender(
              response,
              gender
            );

        if (
          typeof helpers.mergeState ===
          "function"
        ) {
          helpers.mergeState({
            textSuggestions:
              filteredResponse
          });
        }
      },

      onFailure: function () {
        /*
         * Auxiliary suggestions must never block the product results page.
         * SearchResults remains fully usable if this connector request fails.
         */
        if (
          typeof helpers.mergeState ===
          "function"
        ) {
          helpers.mergeState({
            textSuggestions: null
          });
        }
      }
    });
  };


/*
 * TEMPORARY SEARCH RELEVANCE PATCH
 * --------------------------------
 * Until Tagalys finishes the relevance/index work, boost products whose
 * category / product-type metadata matches the entered query.
 *
 * Important:
 * - Product title is deliberately NOT used for this boost.
 * - Ties keep Tagalys' original order.
 * - This only reorders products already returned on the current page.
 * - Remove this helper once Tagalys category/type relevance is configured.
 */
TagalysCustomisations.searchCategoryPriorityEnabled = true;

/*
 * TEMPORARY DEBUG:
 * Set to false once predictive relevance debugging is complete.
 */
TagalysCustomisations.predictiveCategoryDebug = true;


TagalysCustomisations.normaliseSearchRelevanceText =
  function (value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&amp;/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };


TagalysCustomisations.getSearchRelevanceTokens =
  function (value) {
    var stopWords = {
      "a": true,
      "an": true,
      "and": true,
      "for": true,
      "of": true,
      "the": true,
      "to": true,
      "with": true
    };

    return TagalysCustomisations
      .normaliseSearchRelevanceText(value)
      .split(" ")
      .filter(function (token) {
        return (
          token.length >= 3 &&
          !stopWords[token]
        );
      });
  };


TagalysCustomisations.collectCategoryPriorityText =
  function (product) {
    if (!product) {
      return "";
    }

    var values = [];

    var addPrimitive =
      function (value) {
        if (
          value === null ||
          typeof value === "undefined"
        ) {
          return;
        }

        if (
          typeof value === "string" ||
          typeof value === "number"
        ) {
          values.push(
            String(value)
          );
        }
      };

    var addSafeValue =
      function (value) {
        if (
          value === null ||
          typeof value === "undefined"
        ) {
          return;
        }

        if (Array.isArray(value)) {
          value.forEach(function (item) {
            if (
              typeof item === "string" ||
              typeof item === "number"
            ) {
              addPrimitive(item);
              return;
            }

            if (
              item &&
              typeof item === "object"
            ) {
              [
                "title",
                "name",
                "handle",
                "label"
              ].forEach(function (key) {
                addPrimitive(item[key]);
              });
            }
          });

          return;
        }

        if (
          typeof value === "object"
        ) {
          [
            "title",
            "name",
            "handle",
            "label"
          ].forEach(function (key) {
            addPrimitive(value[key]);
          });

          return;
        }

        addPrimitive(value);
      };

    [
      "product_type",
      "productType",
      "type",
      "category",
      "categories",
      "product_category",
      "productCategory",
      "taxonomy",
      "google_product_category",
      "googleProductCategory",
      "collections",
      "collection"
    ].forEach(function (key) {
      try {
        if (
          Object.prototype.hasOwnProperty.call(
            product,
            key
          )
        ) {
          addSafeValue(product[key]);
        }
      } catch (error) {
        /* Ignore malformed optional metadata. */
      }
    });

    [
      product.attributes,
      product.metafields,
      product.custom_fields,
      product.customFields
    ].forEach(function (container) {
      if (
        !container ||
        typeof container !== "object" ||
        Array.isArray(container)
      ) {
        return;
      }

      try {
        Object.keys(container).forEach(
          function (key) {
            if (
              /(?:category|collection|product.?type|taxonomy)/i
                .test(key)
            ) {
              addSafeValue(
                container[key]
              );
            }
          }
        );
      } catch (error) {
        /* Ignore malformed optional metadata. */
      }
    });

    return TagalysCustomisations
      .normaliseSearchRelevanceText(
        values.join(" ")
      );
  };

TagalysCustomisations.getCategoryPriorityScore =
  function (product, query) {
    var categoryText =
      TagalysCustomisations
        .collectCategoryPriorityText(
          product
        );

    if (!categoryText) {
      return 0;
    }

    var categoryTokens =
      categoryText
        .split(" ")
        .filter(Boolean);

    var queryTokens =
      TagalysCustomisations
        .getSearchRelevanceTokens(
          query
        );

    if (!queryTokens.length) {
      return 0;
    }

    var score = 0;

    queryTokens.forEach(function (queryToken) {
      var bestTokenScore = 0;

      categoryTokens.forEach(
        function (categoryToken) {
          if (queryToken === categoryToken) {
            bestTokenScore =
              Math.max(
                bestTokenScore,
                30
              );
            return;
          }

          /*
           * Prefix matching handles common shopper shorthand/plurals:
           * cardi -> cardigan/cardigans, coat -> coats, trouser -> trousers.
           */
          if (
            queryToken.length >= 4 &&
            categoryToken.length >= 4 &&
            (
              categoryToken.indexOf(
                queryToken
              ) === 0 ||
              queryToken.indexOf(
                categoryToken
              ) === 0
            )
          ) {
            bestTokenScore =
              Math.max(
                bestTokenScore,
                24
              );
          }
        }
      );

      score += bestTokenScore;
    });

    /*
     * Give an additional boost when multiple query words match category/type
     * metadata. Example: "pink puffer coat" gets a stronger category signal
     * from "puffer" + "coat"; the colour word alone cannot create this boost.
     */
    var matchedTokens =
      queryTokens.filter(function (queryToken) {
        return categoryTokens.some(
          function (categoryToken) {
            return (
              queryToken === categoryToken ||
              (
                queryToken.length >= 4 &&
                categoryToken.length >= 4 &&
                (
                  categoryToken.indexOf(
                    queryToken
                  ) === 0 ||
                  queryToken.indexOf(
                    categoryToken
                  ) === 0
                )
              )
            );
          }
        );
      }).length;

    if (matchedTokens >= 2) {
      score += 40;
    }

    return score;
  };


TagalysCustomisations.rankSearchResultProductsByCategory =
  function (products, query) {
    if (
      !TagalysCustomisations
        .searchCategoryPriorityEnabled ||
      !Array.isArray(products) ||
      products.length < 2 ||
      !String(query || "").trim()
    ) {
      return products;
    }

    try {
      return products
        .map(function (product, index) {
          var score = 0;

          try {
            score =
              TagalysCustomisations
                .getCategoryPriorityScore(
                  product,
                  query
                );
          } catch (error) {
            score = 0;
          }

          return {
            product: product,
            originalIndex: index,
            score: score
          };
        })
        .sort(function (a, b) {
          if (b.score !== a.score) {
            return b.score - a.score;
          }

          return (
            a.originalIndex -
            b.originalIndex
          );
        })
        .map(function (entry) {
          return entry.product;
        });
    } catch (error) {
      /*
       * Ranking must NEVER break SearchResults rendering.
       * On any unexpected payload shape, use Tagalys' original order.
       */
      console.warn(
        "[Tagalys] Temporary category ranking skipped:",
        error
      );

      return products;
    }
  };



/*
 * TEMPORARY FAST SEARCH CATEGORY PRIORITY
 * ---------------------------------------
 * No extra network requests.
 * Only uses category/type metadata already included in Tagalys' product
 * payload. If Tagalys does not provide a usable category signal, the
 * original Tagalys order is preserved.
 */
TagalysCustomisations.searchCategoryPriorityEnabled = true;


TagalysCustomisations.getFastCategoryPriorityTokens =
  function (query) {
    var ignored = {
      "a": true,
      "an": true,
      "and": true,
      "for": true,
      "of": true,
      "the": true,
      "to": true,
      "with": true,

      /* Do not let colour terms drive the category boost. */
      "black": true,
      "blue": true,
      "navy": true,
      "white": true,
      "cream": true,
      "pink": true,
      "red": true,
      "green": true,
      "grey": true,
      "gray": true,
      "brown": true,
      "beige": true,
      "stone": true,
      "khaki": true,
      "orange": true,
      "yellow": true,
      "purple": true,
      "lilac": true,
      "burgundy": true,
      "wine": true,
      "mink": true,
      "camel": true,
      "charcoal": true,
      "teal": true
    };

    return String(query || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .split(/\s+/)
      .filter(function (token) {
        return (
          token.length >= 3 &&
          !ignored[token]
        );
      });
  };


TagalysCustomisations.getFastCategoryPriorityText =
  function (product) {
    if (!product) {
      return "";
    }

    var values = [];

    var add = function (value) {
      if (
        value === null ||
        typeof value === "undefined"
      ) {
        return;
      }

      if (
        typeof value === "string" ||
        typeof value === "number"
      ) {
        values.push(
          String(value)
        );
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(add);
        return;
      }

      if (typeof value === "object") {
        [
          "name",
          "title",
          "label",
          "value",
          "handle"
        ].forEach(function (key) {
          if (
            typeof value[key] === "string" ||
            typeof value[key] === "number"
          ) {
            values.push(
              String(value[key])
            );
          }
        });
      }
    };

    [
      "product_type",
      "productType",
      "type",
      "category",
      "categories",
      "product_category",
      "productCategory",
      "taxonomy",
      "google_product_category",
      "googleProductCategory",
      "collections",
      "collection"
    ].forEach(function (key) {
      try {
        add(product[key]);
      } catch (error) {
        /* Ignore optional malformed fields. */
      }
    });

    [
      product.attributes,
      product.metafields,
      product.custom_fields,
      product.customFields
    ].forEach(function (container) {
      if (
        !container ||
        typeof container !== "object" ||
        Array.isArray(container)
      ) {
        return;
      }

      try {
        Object.keys(container).forEach(
          function (key) {
            if (
              /(?:category|collection|product.?type|taxonomy)/i
                .test(key)
            ) {
              add(container[key]);
            }
          }
        );
      } catch (error) {
        /* Ignore optional malformed fields. */
      }
    });

    return values
      .join(" ")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };


TagalysCustomisations.getFastCategoryPriorityScore =
  function (product, query) {
    var queryTokens =
      TagalysCustomisations
        .getFastCategoryPriorityTokens(
          query
        );

    if (!queryTokens.length) {
      return 0;
    }

    /*
     * Conservative singular/plural normalisation only.
     * No prefix matching:
     *   dress -> dresses (yes)
     *   dress -> dressing (no)
     */
    var normalisePlural =
      function (token) {
        token = String(token || "");

        if (
          token.length > 4 &&
          token.slice(-3) === "ies"
        ) {
          return token.slice(0, -3) + "y";
        }

        if (
          token.length > 4 &&
          token.slice(-2) === "es"
        ) {
          var stem =
            token.slice(0, -2);

          if (
            /(?:s|x|z|ch|sh)$/.test(stem)
          ) {
            return stem;
          }
        }

        if (
          token.length > 3 &&
          token.slice(-1) === "s" &&
          token.slice(-2) !== "ss"
        ) {
          return token.slice(0, -1);
        }

        return token;
      };

    var tokenMatches =
      function (
        queryToken,
        candidateToken
      ) {
        if (
          queryToken === candidateToken
        ) {
          return true;
        }

        return (
          normalisePlural(queryToken) ===
          normalisePlural(candidateToken)
        );
      };

    /*
     * FIRST: use genuine category / product-type metadata when Tagalys
     * includes it in the predictive product payload.
     */
    var categoryText =
      TagalysCustomisations
        .getFastCategoryPriorityText(
          product
        );

    var categoryTokens =
      String(categoryText || "")
        .split(" ")
        .filter(Boolean);

    var categoryScore = 0;
    var categoryMatches = 0;

    queryTokens.forEach(function (queryToken) {
      var matched =
        categoryTokens.some(
          function (categoryToken) {
            return tokenMatches(
              queryToken,
              categoryToken
            );
          }
        );

      if (matched) {
        categoryMatches += 1;
        categoryScore += 120;
      }
    });

    if (categoryMatches >= 2) {
      categoryScore += 120;
    }

    if (categoryScore > 0) {
      return categoryScore;
    }

    /*
     * FALLBACK FOR PREDICTIVE SEARCH:
     * Tagalys' SearchSuggestions product payload does not consistently
     * include category/type metadata. In that case, use ONLY exact
     * whole-word product-type terms from title + handle.
     *
     * This is intentionally NOT normal title relevance:
     * colour words were already removed from queryTokens, and there is
     * no prefix matching. Therefore:
     *   "red skirt" -> "skirt" products (yes)
     *   "pink dress" -> "dress"/"dresses" products (yes)
     *   "pink dress" -> "dressing gown" (no)
     */
    var fallbackText =
      [
        product.title || "",
        product.name || "",
        product.handle || "",
        product.product_handle || ""
      ]
        .join(" ")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    var fallbackTokens =
      fallbackText
        .split(" ")
        .filter(Boolean);

    var fallbackScore = 0;
    var fallbackMatches = 0;

    queryTokens.forEach(function (queryToken) {
      var matched =
        fallbackTokens.some(
          function (candidateToken) {
            return tokenMatches(
              queryToken,
              candidateToken
            );
          }
        );

      if (matched) {
        fallbackMatches += 1;
        fallbackScore += 80;
      }
    });

    if (fallbackMatches >= 2) {
      fallbackScore += 80;
    }

    return fallbackScore;
  };


/* =========================================================
   MIX MEN / WOMEN FOR "ALL" SEARCH RESULTS

   Applied only to:
   - full SearchResults product grid
   - typed predictive SearchSuggestions product results

   Men-only / Women-only scopes are left untouched.
   ========================================================= */

TagalysCustomisations.searchGenderMixEnabled = true;

TagalysCustomisations.getProductGenderForMix =
  function (product) {
    if (!product) {
      return "";
    }

    var tokens = [];

    var addTokens = function (value) {
      if (
        value === null ||
        typeof value === "undefined"
      ) {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(addTokens);
        return;
      }

      if (
        typeof value === "string" ||
        typeof value === "number"
      ) {
        String(value)
          .toLowerCase()
          .replace(/['’]/g, "")
          .replace(/[^a-z0-9]+/g, " ")
          .split(/\s+/)
          .filter(Boolean)
          .forEach(function (token) {
            tokens.push(token);
          });
      }
    };

    /*
     * Threadbare predictive/SearchResults payloads expose at least tags,
     * product_type and handle. Use exact tokens so "women" cannot be
     * accidentally classified as "men".
     */
    addTokens(product.gender);
    addTokens(product.product_gender);
    addTokens(product.productGender);
    addTokens(product.tags);
    addTokens(product.product_type);
    addTokens(product.productType);
    addTokens(product.type);
    addTokens(product.handle);
    addTokens(product.product_handle);

    if (
      tokens.some(function (token) {
        return (
          token === "women" ||
          token === "womens" ||
          token === "female"
        );
      })
    ) {
      return "women";
    }

    if (
      tokens.some(function (token) {
        return (
          token === "men" ||
          token === "mens" ||
          token === "male"
        );
      })
    ) {
      return "men";
    }

    return "";
  };


TagalysCustomisations.mixMenWomenProducts =
  function (products, selectedGender) {
    if (
      !TagalysCustomisations
        .searchGenderMixEnabled ||
      !Array.isArray(products) ||
      products.length < 2
    ) {
      return products;
    }

    selectedGender =
      TagalysCustomisations
        .normaliseSearchGender(
          selectedGender ||
          TagalysCustomisations
            .getStoredSearchGender()
        );

    if (selectedGender !== "all") {
      return products;
    }

    var men = [];
    var women = [];
    var classifiedPositions = [];
    var firstGender = "";

    products.forEach(function (product, index) {
      var gender =
        TagalysCustomisations
          .getProductGenderForMix(
            product
          );

      if (
        gender !== "men" &&
        gender !== "women"
      ) {
        return;
      }

      if (!firstGender) {
        firstGender = gender;
      }

      classifiedPositions.push(index);

      if (gender === "men") {
        men.push(product);
      } else {
        women.push(product);
      }
    });

    /*
     * Need both audiences before alternating.
     */
    if (!men.length || !women.length) {
      return products;
    }

    var mixed = [];
    var menIndex = 0;
    var womenIndex = 0;
    var nextGender =
      firstGender === "women"
        ? "women"
        : "men";

    while (
      menIndex < men.length ||
      womenIndex < women.length
    ) {
      if (
        nextGender === "men" &&
        menIndex < men.length
      ) {
        mixed.push(
          men[menIndex]
        );
        menIndex += 1;
        nextGender = "women";
        continue;
      }

      if (
        nextGender === "women" &&
        womenIndex < women.length
      ) {
        mixed.push(
          women[womenIndex]
        );
        womenIndex += 1;
        nextGender = "men";
        continue;
      }

      if (menIndex < men.length) {
        mixed.push(
          men[menIndex]
        );
        menIndex += 1;
        nextGender = "women";
        continue;
      }

      if (womenIndex < women.length) {
        mixed.push(
          women[womenIndex]
        );
        womenIndex += 1;
        nextGender = "men";
      }
    }

    /*
     * Keep unknown/unisex products in their original slots.
     */
    var result =
      products.slice();

    classifiedPositions.forEach(
      function (position, index) {
        result[position] =
          mixed[index];
      }
    );

    return result;
  };


TagalysCustomisations.rankSearchProductsFast =
  function (products, query, selectedGender) {
    if (
      !Array.isArray(products) ||
      products.length < 2
    ) {
      return products;
    }

    try {
      var orderedProducts =
        products.slice();

      /*
       * First keep the existing category-priority logic.
       */
      if (
        TagalysCustomisations
          .searchCategoryPriorityEnabled
      ) {
        var ranked =
          orderedProducts.map(
            function (product, index) {
              return {
                product: product,
                index: index,
                score:
                  TagalysCustomisations
                    .getFastCategoryPriorityScore(
                      product,
                      query
                    )
              };
            }
          );

        /*
         * Sort only when at least one result has a category/type match.
         * If there is no score, preserve Tagalys' original relevance order.
         */
        if (
          ranked.some(function (entry) {
            return entry.score > 0;
          })
        ) {
          orderedProducts =
            ranked
              .sort(function (a, b) {
                if (b.score !== a.score) {
                  return (
                    b.score -
                    a.score
                  );
                }

                return (
                  a.index -
                  b.index
                );
              })
              .map(function (entry) {
                return entry.product;
              });
        }
      }

      /*
       * CATEGORY RELEVANCE MUST WIN OVER GENDER MIXING.
       *
       * Keep every category/type match ahead of every non-match, then
       * alternate Men/Women separately inside those two groups.
       *
       * Example for "red skirt":
       *   Women's skirt  -> score > 0
       *   Men's skirt    -> score > 0
       *   Men's shirt    -> score 0
       *
       * The shirt can never be promoted above an available skirt just to
       * satisfy the Men/Women alternation.
       */
      var categoryMatched = [];
      var nonCategoryMatched = [];

      orderedProducts.forEach(
        function (product) {
          var categoryScore =
            TagalysCustomisations
              .getFastCategoryPriorityScore(
                product,
                query
              );

          if (categoryScore > 0) {
            categoryMatched.push(
              product
            );
          } else {
            nonCategoryMatched.push(
              product
            );
          }
        }
      );

      var finalProducts = [];

      if (categoryMatched.length) {
        finalProducts =
          finalProducts.concat(
            TagalysCustomisations
              .mixMenWomenProducts(
                categoryMatched,
                selectedGender
              )
          );
      }

      if (nonCategoryMatched.length) {
        finalProducts =
          finalProducts.concat(
            TagalysCustomisations
              .mixMenWomenProducts(
                nonCategoryMatched,
                selectedGender
              )
          );
      }

      return finalProducts;
    } catch (error) {
      console.warn(
        "[Tagalys] Search ordering skipped:",
        error
      );

      return products;
    }
  };

TagalysCustomisations.initSearchResults = function (
  selector,
  query
) {
  selector =
    selector ||
    "[data-search-results]";

  var resultsContainer =
    document.querySelector(selector);

  if (!resultsContainer) {
    console.warn(
      "[Tagalys] Results container not found:",
      selector
    );

    return;
  }

  if (
    resultsContainer.dataset
      .tagalysResultsInitialized === "true"
  ) {
    return;
  }

  var searchParameters =
    new URLSearchParams(
      window.location.search
    );

  if (!query) {
    query =
      searchParameters.get("q") ||
      searchParameters.get("query") ||
      "";
  }

  query = String(query)
    .replace(/\*/g, "")
    .trim();

  if (!query) {
    console.warn(
      "[Tagalys] Search query is empty."
    );

    return;
  }

  /*
   * When the search form submits normally, selectGender is part of the URL.
   * Treat that submitted value as authoritative, then keep sessionStorage in
   * sync so Tagalys suggestion clicks (which may only carry the query) retain
   * the same audience selection on the results page.
   */
  var submittedGender =
    searchParameters.get("selectGender");

  var selectedGender = submittedGender
    ? TagalysCustomisations
        .setStoredSearchGender(
          submittedGender
        )
    : TagalysCustomisations
        .getStoredSearchGender();

  TagalysCustomisations
    .syncSearchGenderInputs(
      selectedGender
    );

  /*
   * Use the theme's native <grid-expander> custom element against the
   * SearchResults root. This is the same mechanism used by collection pages.
   */
  resultsContainer.classList.add(
    "tagalys-search-product-grid"
  );

  if (
    !resultsContainer.classList.contains(
      "grid-1-col-per-row"
    ) &&
    !resultsContainer.classList.contains(
      "grid-2-col-per-row"
    ) &&
    !resultsContainer.classList.contains(
      "grid-3-col-per-row"
    ) &&
    !resultsContainer.classList.contains(
      "grid-4-col-per-row"
    ) &&
    !resultsContainer.classList.contains(
      "grid-6-col-per-row"
    )
  ) {
    resultsContainer.classList.add(
      "grid-4-col-per-row"
    );
  }

  console.log(
    "[Tagalys] Initialising search:",
    query,
    "gender:",
    selectedGender
  );

  /*
   * SearchResults and ShopifySearchResults use the same theme templates.
   * The Shopify widget is NOT initialised here during normal operation; it is
   * passed to Tagalys as the SDK-native failover callback and is invoked only
   * when the primary Tagalys request fails.
   */
  var commonTemplates =
    TagalysCustomisations
      .getSearchResultsThemeTemplates();

  var afterEveryRender = function (helpers) {
    TagalysCustomisations
      .initTagalysCardEnhancements();

    TagalysCustomisations
      .updateSearchDocumentTitle(
        helpers
      );


    resultsContainer.setAttribute(
      "aria-busy",
      "false"
    );

    if (
      helpers &&
      typeof helpers.hasNoSearchResults ===
        "function" &&
      helpers.hasNoSearchResults()
    ) {
      window.setTimeout(
        function () {
          TagalysCustomisations
            .initSearchNoResultsRecommendations();
        },
        0
      );
    }
  };

  var initializeShopifySearchResults =
    function () {
      if (
        !Tagalys.UIWidgets
          .ShopifySearchResults ||
        typeof Tagalys.UIWidgets
          .ShopifySearchResults.init !==
          "function"
      ) {
        console.error(
          "[Tagalys] ShopifySearchResults failover widget is unavailable in this SDK."
        );
        return null;
      }

      console.warn(
        "[Tagalys] SearchResults failed over to Shopify."
      );

      /*
       * ShopifySearchResults uses its own request state for filters, sorting,
       * drawer behaviour and load-next pagination. Keep the Threadbare pieces
       * that are data-format compatible (heading, loader, product card, grid,
       * no-results), but let the Shopify widget render its own controls.
       *
       * This is intentionally failover-only. The primary Tagalys SearchResults
       * continues using all of Threadbare's custom filter/drawer/pagination
       * templates unchanged.
       */
      var shopifyTemplates =
        Object.assign({}, commonTemplates);

      /*
       * ShopifySearchResults supports the same filter/drawer helpers used by
       * Threadbare's custom templates (applyFilter, clearFilter,
       * getAppliedFilters, openFilterDrawer, range slider state, sorting,
       * etc.). Keep those templates so failover preserves the normal
       * Threadbare search layout.
       *
       * Pagination is the exception documented by Tagalys: Shopify failover
       * uses canLoadNextResults()/loadNextPage instead of the numbered-page
       * helpers used by the primary SearchResults widget. Let Shopify use its
       * native pagination/load-more templates only.
       */
      [
        "pagination",
        "paginationLinks"
      ].forEach(function (templateName) {
        delete shopifyTemplates[templateName];
      });

      /*
       * The normal Tagalys widget scopes gender in beforeAPICall via
       * params.scope. ShopifySearchResults does not use Tagalys scope; it
       * reads Shopify's native storefront filter state from the URL.
       * Translate the same All / Men / Women selection only at failover time.
       */
      /*
       * Keep the actual entered search term in Shopify's URL-driven request
       * state as well. Without this, ShopifySearchResults can initialise with
       * only the storefront filters and return the same generic product set
       * regardless of whether the customer searched for shirt, dress, etc.
       */
      TagalysCustomisations
        .syncShopifyGenderFilterInURL(
          TagalysCustomisations
            .getStoredSearchGender()
        );

      return Tagalys.UIWidgets
        .ShopifySearchResults.init(
          selector,
          {
            canAppendQueryStringToUrl: true,

            productPageUrl:
              TagalysCustomisations
                .productPageUrl,

            templates:
              shopifyTemplates,

            callbacks: {
              afterEveryRender:
                afterEveryRender
            }
          }
        );
    };

  Tagalys.UIWidgets.SearchResults.init(
    selector,
    {
      params: {
        query: query,
        perPage:
          TagalysCustomisations
            .searchResultsPerPage
      },

      productPageUrl:
        TagalysCustomisations
          .productPageUrl,

      templates:
        commonTemplates,

      failover:
        initializeShopifySearchResults,

      callbacks: {
        afterInitialRender: function (helpers) {
          TagalysCustomisations
            .fetchSearchResultsTextSuggestions(
              helpers,
              query
            );
        },

        beforeAPICall: function (params) {
          /* Keep the API request aligned with the grid/page-size setting. */
          params.perPage =
            TagalysCustomisations
              .searchResultsPerPage;

          var gender =
            TagalysCustomisations
              .getStoredSearchGender();

          /*
           * Tagalys SearchResults uses params.scope.
           * Do NOT use params.filters for this pre-filter.
           */
          var genderScope =
            TagalysCustomisations
              .getGenderScopeValues(
                gender
              );

          if (genderScope.length) {
            params.scope = {
              "p.m.custom.gender":
                genderScope
            };
          } else if (params.scope) {
            delete params.scope;
          }

          console.log(
            "[Tagalys] SearchResults gender:",
            gender,
            "scope:",
            params.scope || "all"
          );

          return params;
        },

        afterEveryRender:
          afterEveryRender
      }
    }
  );

  resultsContainer.dataset
    .tagalysResultsInitialized =
    "true";

  TagalysCustomisations
    .initTagalysCardEnhancements();
};


/* Search query / URL state is managed by Tagalys UIWidgets. */


TagalysCustomisations.initProductBasedWidget = function (
  selector,
  recommendationId,
  productIds
) {
  selector =
    selector ||
    "[data-product-based-widget]";

  recommendationId =
    String(recommendationId || "").trim();

  productIds = Array.isArray(productIds)
    ? productIds
        .filter(Boolean)
        .map(function (id) {
          return String(id);
        })
    : [];

  if (
    !recommendationId ||
    !productIds.length
  ) {
    console.warn(
      "[Tagalys PDP] Missing recommendationId/productIds",
      {
        recommendationId:
          recommendationId,
        productIds:
          productIds
      }
    );

    return;
  }

  var widget =
    document.querySelector(selector);

  if (!widget) {
    return;
  }

  if (
    widget.dataset
      .tagalysRecommendationInitialized ===
    "true"
  ) {
    return;
  }

  function disableTagalysPDPStyles() {
    if (!widget) {
      return;
    }

    if (
      widget.id ===
      "tagalys-namespace"
    ) {
      widget.removeAttribute(
        "id"
      );
    }

    widget.classList.remove(
      "tagalys-namespace"
    );

    widget.classList.add(
      "threadbare-tagalys-pdp-widget"
    );

    widget.dataset
      .threadbareTagalysStylesDisabled =
      "true";
  }

  function enhanceRenderedCards() {
    window.requestAnimationFrame(
      function () {
        disableTagalysPDPStyles();

        if (
          typeof TagalysCustomisations
            .initTagalysCardEnhancements ===
          "function"
        ) {
          TagalysCustomisations
            .initTagalysCardEnhancements();
        }
      }
    );
  }

  Tagalys.UIWidgets.Recommendations.init(
    selector,
    {
      recommendationId:
        recommendationId,

      productIds:
        productIds,

      productPageUrl:
        TagalysCustomisations
          .productPageUrl,

      templates: {
        product:
          TagalysCustomisations
            .getProductTemplate()
      },

      callbacks: {
        afterEveryRender:
          enhanceRenderedCards
      }
    }
  );

  widget.dataset
    .tagalysRecommendationInitialized =
    "true";

  window.setTimeout(
    enhanceRenderedCards,
    0
  );
};


/* =========================================================
   THREADBARE SEARCH TYPOGRAPHY
   Keep helper/suggestion copy consistent between predictive
   search and the full search-results page on every device.
   ========================================================= */
TagalysCustomisations.ensureSearchTypographyStyles = function () {
  if (document.getElementById("tagalys-threadbare-search-typography")) {
    return;
  }

  var style = document.createElement("style");
  style.id = "tagalys-threadbare-search-typography";
  style.textContent = `
    predictive-search[data-context="header"] .section-title,
    predictive-search[data-context="header"] .tagalys-search-section-title,
    predictive-search[data-context="header"] .text-suggestion-section a,
    predictive-search[data-context="header"] .search-results-link,
    predictive-search[data-context="header"] .tagalys-search-suggestions-body,
    .tagalys-main-search .tagalys-search-results-message,
    .tagalys-main-search .tagalys-search-results-suggestions__title,
    .tagalys-main-search .tagalys-search-results-suggestions__link {
      font-size: 12px !important;
      line-height: 1.4 !important;
      text-transform: none !important;
    }
  `;

  document.head.appendChild(style);
};

TagalysCustomisations.ensureSearchTypographyStyles();


/* =========================================================
   COUTURE-STYLE TAGALYS PREDICTIVE SEARCH LAYOUT
   ---------------------------------------------------------
   This override intentionally keeps the working Threadbare
   gender scope implementation:
     SearchSuggestions -> params.sections.products.scope
     SearchResults     -> params.scope
   It only changes the predictive-search presentation and
   empty-state recommendation rendering.
   ========================================================= */

TagalysCustomisations.predictiveRecommendationId =
  TagalysCustomisations.predictiveRecommendationId ||
  "5465089e953ce041119b";

/*
 * Empty-search recommendations use one Tagalys smart widget.
 *
 * The selected audience is applied in beforeAPICall via params.scope:
 *   all   -> ["men", "women"]
 *   men   -> ["men"]
 *   women -> ["women"]
 *
 * This avoids maintaining separate recommendation widget IDs.
 */
TagalysCustomisations.getPredictiveRecommendationId =
  function () {
    var config =
      window.TagalysShopifyConfig || {};

    var predictiveConfig =
      config.predictiveSearch || {};

    /*
     * Primary config: a single smart recommendation widget.
     *
     * recommendationIds.mixed is retained only as a backwards-compatible
     * fallback in case an older theme config is temporarily deployed.
     */
    var configuredId =
      String(
        predictiveConfig.recommendationId ||
        ""
      ).trim();

    return (
      configuredId ||
      (
        predictiveConfig.recommendationIds &&
        predictiveConfig.recommendationIds.mixed
      ) ||
      TagalysCustomisations.predictiveRecommendationId
    );
  };


TagalysCustomisations.getRecommendationGenderScopeValues =
  function (gender) {
    gender =
      TagalysCustomisations
        .normaliseSearchGender(
          gender
        );

    if (gender === "men") {
      return ["men"];
    }

    if (gender === "women") {
      return ["women"];
    }

    /*
     * "all" is the combined adult audience for this recommendation widget.
     * This mirrors the scope example supplied by Tagalys.
     */
    return ["men", "women"];
  };


TagalysCustomisations.recommendationProductCount = 30;


TagalysCustomisations.applyRecommendationGenderScope =
  function (params, gender) {
    params = params || {};

    var values =
      TagalysCustomisations
        .getRecommendationGenderScopeValues(
          gender
        );

    params.scope = {
      "p.m.custom.gender":
        values
    };

    return params;
  };

TagalysCustomisations.initPredictiveRecommendations =
  function (selector, gender, force) {
    var widget = document.querySelector(selector);

    if (!widget) {
      return;
    }

    gender = TagalysCustomisations
      .normaliseSearchGender(
        gender ||
        TagalysCustomisations
          .getStoredSearchGender()
      );

    var requestCount =
      TagalysCustomisations
        .recommendationProductCount;

    var recommendationId =
      TagalysCustomisations
        .getPredictiveRecommendationId();

    if (!recommendationId) {
      widget.innerHTML = "";
      widget.dataset.tagalysPredictiveRecommendationState = "empty";
      return;
    }

    var currentId =
      widget.dataset
        .tagalysPredictiveRecommendationId ||
      "";

    var state =
      widget.dataset
        .tagalysPredictiveRecommendationState ||
      "";

    var currentGender =
      widget.dataset
        .tagalysPredictiveRecommendationGender ||
      "";

    if (
      !force &&
      currentId === recommendationId &&
      currentGender === gender &&
      state === "ready"
    ) {
      return;
    }

    widget.dataset
      .tagalysPredictiveRecommendationId =
      recommendationId;

    widget.dataset
      .tagalysPredictiveRecommendationGender =
      gender;

    widget.dataset
      .tagalysPredictiveRecommendationCount =
      String(requestCount);

    widget.dataset
      .tagalysPredictiveRecommendationState =
      "loading";

    widget.classList.add(
      "tagalys-recommendations--crossfade"
    );

    Tagalys.UIWidgets.Recommendations.init(
      selector,
      {
        recommendationId:
          recommendationId,

        productPageUrl:
          TagalysCustomisations
            .productPageUrl,

        templates: {
          product:
            TagalysCustomisations
              .getPredictiveProductTemplate(),

          widget: {
            options: {
              count:
                requestCount,
              displayFormat: "grid",
              includeTagalysCSS: false
            },

            render: function (html, args) {
              var props = args.props;
              var helpers = props.helpers;
              var products =
                helpers.getProducts
                  ? helpers.getProducts()
                  : [];

              if (
                props.loading === false &&
                (!products || !products.length)
              ) {
                return html`
                  <div class="tagalys-search-no-results">
                    No products found
                  </div>
                `;
              }

              if (props.loading) {
                return html`
                  <div class="tagalys-search-recommendations-loading">
                    Loading...
                  </div>
                `;
              }

              return html`
                <div class="recommendations-widget">
                  <div class="recommendations-widget-body">
                    <${args.templates.productList} />
                  </div>
                </div>
              `;
            }
          }
        },

        callbacks: {
          beforeAPICall: function (params) {
            return TagalysCustomisations
              .applyRecommendationGenderScope(
                params,
                gender
              );
          },

          afterEveryRender: function () {
            widget.dataset
              .tagalysPredictiveRecommendationState =
              "ready";

            widget.classList.remove(
              "tagalys-recommendations--crossfade"
            );

            TagalysCustomisations
              .initTagalysCardEnhancements();
          },

          onFailedAPICall: function () {
            widget.dataset
              .tagalysPredictiveRecommendationState =
              "failed";

            widget.classList.remove(
              "tagalys-recommendations--crossfade"
            );
          }
        }
      }
    );
  };


/* =========================================================
   Predictive auxiliary suggestion filtering

   Tagalys scopes products, but Collections / Pages / Popular Searches are
   not gender-scoped. Filter those client-side using the words already
   present in the rendered suggestion text / URL.

   Rules:
   - all: show everything
   - men: hide explicitly women's suggestions, keep men's + neutral
   - women: hide explicitly men's suggestions, keep women's + neutral
   ========================================================= */
TagalysCustomisations.normaliseSuggestionText = function (value) {
  var text = String(value || "");

  try {
    text = decodeURIComponent(text);
  } catch (error) {
    // Keep the original value when it is not URL encoded.
  }

  return text
    .replace(/&apos;|&#39;|’/gi, "'")
    .replace(/[_+\-\/]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
};


TagalysCustomisations.getSuggestionGenderFlags = function (value) {
  var text = TagalysCustomisations
    .normaliseSuggestionText(value);

  /*
   * Tagalys does not provide an audience scope for Collections / Pages /
   * Searches. In addition to explicit Men's/Women's wording, recognise a
   * small set of strongly WW-specific category terms so a Menswear search
   * does not inherit suggestions such as Dresses / Petite / Skirts simply
   * because those suggestions do not literally contain the word "women".
   */
  var explicitMen =
    /\b(?:men|men's|mens|menswear|male)\b/i.test(text);

  var explicitWomen =
    /\b(?:women|women's|womens|womenswear|ladies|female)\b/i.test(text);

  var womenCategory =
    /\b(?:dress|dresses|skirt|skirts|blouse|blouses|bodysuit|bodysuits|petite|maternity|heel|heels)\b/i.test(text);

  return {
    men: explicitMen,
    women: explicitWomen || womenCategory
  };
};


TagalysCustomisations.shouldShowSuggestionForGender = function (value, gender) {
  gender = TagalysCustomisations
    .normaliseSearchGender(gender);

  if (gender === "all") {
    return true;
  }

  var flags = TagalysCustomisations
    .getSuggestionGenderFlags(value);

  /*
   * Neutral suggestions stay available. Explicit / strongly inferred
   * opposite-audience suggestions are removed, while an item that contains
   * both audiences remains visible.
   */
  if (gender === "men") {
    return !flags.women || flags.men;
  }

  if (gender === "women") {
    return !flags.men || flags.women;
  }

  return true;
};


TagalysCustomisations.isSuggestionGroupEnabled =
  function (context, type) {
    var isMobile =
      window.matchMedia &&
      window.matchMedia(
        "(max-width: 768px)"
      ).matches;

    var device =
      isMobile
        ? "mobile"
        : "desktop";

    var key =
      type === "searches" ||
      type === "queries" ||
      type === "searchSuggestions"
        ? "searchSuggestions"
        : type === "recent" ||
          type === "recentSearches"
          ? "recentSearches"
          : String(type || "")
              .toLowerCase();

    var visibility =
      window.TagalysShopifyConfig &&
      window.TagalysShopifyConfig
        .suggestionVisibility
        ? window.TagalysShopifyConfig
            .suggestionVisibility
        : {};

    var contextSettings =
      visibility[context] &&
      visibility[context][device]
        ? visibility[context][device]
        : null;

    if (
      contextSettings &&
      typeof contextSettings[key] ===
        "boolean"
    ) {
      return contextSettings[key];
    }

    /*
     * Backward-compatible defaults if cached JS runs before the new Theme
     * settings config is available. Preserve the theme's previous behavior:
     * predictive Pages are hidden on mobile; everything else is shown.
     */
    if (
      context === "predictive" &&
      device === "mobile" &&
      key === "pages"
    ) {
      return false;
    }

    return true;
  };


TagalysCustomisations.getSuggestionSectionName = function (section) {
  if (!section) {
    return "";
  }

  var explicitId = String(
    section.getAttribute("data-section-id") || ""
  ).trim();

  if (explicitId) {
    return explicitId.toLowerCase();
  }

  var title = section.querySelector(".section-title");

  return TagalysCustomisations
    .normaliseSuggestionText(
      title ? title.textContent : ""
    );
};


TagalysCustomisations.getSuggestionQuery = function (container) {
  if (!container) {
    return "";
  }

  var wrapper = container.closest("predictive-search");
  var input = wrapper
    ? wrapper.querySelector("[data-search-input]")
    : null;

  return input
    ? String(input.value || "").trim()
    : "";
};


TagalysCustomisations.suggestionMatchesQuery = function (value, query) {
  var haystack = TagalysCustomisations
    .normaliseSuggestionText(value);

  var tokens = TagalysCustomisations
    .normaliseSuggestionText(query)
    .split(/\s+/)
    .filter(function (token) {
      return token.length >= 2 &&
        ["the", "and", "for", "with"].indexOf(token) === -1;
    });

  if (!tokens.length) {
    return true;
  }

  return tokens.some(function (token) {
    return haystack.indexOf(token) !== -1;
  });
};


TagalysCustomisations.filterSuggestionListForGender = function (container, gender) {
  if (!container) {
    return;
  }

  gender = TagalysCustomisations
    .normaliseSearchGender(gender);

  var query = TagalysCustomisations
    .getSuggestionQuery(container);

  var displayLimit =
    Number(
      TagalysCustomisations
        .predictiveAuxiliaryDisplayLimit || 5
    );

  container
    .querySelectorAll(".text-suggestion-section")
    .forEach(function (section) {
      var sectionName = TagalysCustomisations
        .getSuggestionSectionName(section);

      var list = section.querySelector("ul");

      var items = Array.prototype.slice.call(
        section.querySelectorAll("li")
      );

      if (!items.length) {
        /*
         * Do not leave an orphan Collections / Pages heading when Tagalys
         * renders the section wrapper without any usable items.
         */
        section.hidden = true;
        return;
      }

      var rankedItems = items.map(function (item, index) {
        var link = item.querySelector("a");

        if (!link) {
          item.hidden = true;
          return {
            item: item,
            index: index,
            score: 99
          };
        }

        var value = [
          link.textContent || "",
          link.getAttribute("href") || "",
          link.getAttribute("title") || ""
        ].join(" ");

        var visible = TagalysCustomisations
          .shouldShowSuggestionForGender(
            value,
            gender
          );

        /*
         * Pages were producing unrelated links for short searches such as
         * "Top". Require page suggestions to contain the typed term, but do
         * not apply this literal test to Collections because Tagalys can
         * return semantically relevant collection names (for example T-Shirts
         * & Polos for "Top") that do not repeat the exact query text.
         */
        if (
          visible &&
          query &&
          sectionName === "pages"
        ) {
          visible = TagalysCustomisations
            .suggestionMatchesQuery(
              value,
              query
            );
        }

        item.hidden = !visible;

        var flags = TagalysCustomisations
          .getSuggestionGenderFlags(value);

        var score = 1;

        if (gender === "men" && flags.men) {
          score = 0;
        } else if (
          gender === "women" &&
          flags.women
        ) {
          score = 0;
        }

        return {
          item: item,
          index: index,
          score: score
        };
      });

      /* Put audience-specific matches ahead of neutral matches. */
      if (gender !== "all" && list) {
        rankedItems
          .sort(function (a, b) {
            if (a.score !== b.score) {
              return a.score - b.score;
            }

            return a.index - b.index;
          })
          .forEach(function (entry) {
            list.appendChild(entry.item);
          });
      }

      var visibleCount = 0;

      Array.prototype.forEach.call(
        section.querySelectorAll("li"),
        function (item) {
          if (item.hidden) {
            return;
          }

          visibleCount += 1;

          if (
            displayLimit > 0 &&
            visibleCount > displayLimit
          ) {
            item.hidden = true;
          }
        }
      );

      var hasVisibleItem = Array.prototype.some.call(
        section.querySelectorAll("li"),
        function (item) {
          return !item.hidden;
        }
      );

      section.hidden = !hasVisibleItem;
    });
};


TagalysCustomisations.filterPredictiveAuxiliarySuggestions = function (wrapper) {
  if (!wrapper) {
    return;
  }

  var gender = TagalysCustomisations
    .getSelectedGenderValue(wrapper);

  var context = wrapper.dataset.context || "header";

  var textSuggestions = wrapper.querySelector(
    '[data-tagalys-text-suggestions="' + context + '"]'
  );

  TagalysCustomisations
    .filterSuggestionListForGender(
      textSuggestions,
      gender
    );

  /*
   * Apply the independent Theme Editor visibility settings for predictive
   * Collections / Pages. Search Suggestions are rendered in their dedicated
   * top container and are handled by syncTagalysSearchTermSuggestions().
   */
  if (textSuggestions) {
    textSuggestions
      .querySelectorAll(
        ".text-suggestion-section"
      )
      .forEach(function (section) {
        var sectionName =
          TagalysCustomisations
            .getSuggestionSectionName(
              section
            );

        if (
          sectionName !== "collections" &&
          sectionName !== "pages"
        ) {
          return;
        }

        var enabled =
          TagalysCustomisations
            .isSuggestionGroupEnabled(
              "predictive",
              sectionName
            );

        if (!enabled) {
          section.dataset
            .tagalysSettingHidden =
            "true";

          section.hidden = true;
          section.style.setProperty(
            "display",
            "none",
            "important"
          );
          return;
        }

        if (
          section.dataset
            .tagalysSettingHidden ===
          "true"
        ) {
          delete section.dataset
            .tagalysSettingHidden;

          section.style.removeProperty(
            "display"
          );
        }
      });
  }
};

/* =========================================================
   Couture-style drawer geometry

   The search remains below the complete visible header group (header + USP /
   announcement bars), but fills every remaining pixel to the bottom of the
   viewport.
   ========================================================= */
TagalysCustomisations.ensurePredictiveSearchBodyPortal = function (wrapper) {
  if (
    !wrapper ||
    (wrapper.dataset.context || "header") !== "header"
  ) {
    return null;
  }

  var container = wrapper.closest(
    ".site-header__search-container"
  );

  if (!container) {
    return null;
  }

  /*
   * Impulse's sticky .site-header can be transformed. A position:fixed child
   * of a transformed ancestor uses that ancestor as its containing block,
   * which is why the mobile drawer could collapse and the product grid became
   * invisible. Move the existing drawer to body once; all theme.js selectors
   * are document-based, so open/close behaviour continues to work.
   */
  if (
    container.dataset.tagalysBodyPortal !== "true"
  ) {
    document.body.appendChild(container);
    container.dataset.tagalysBodyPortal = "true";
  }

  return container;
};

TagalysCustomisations.getPredictiveSearchHeaderBottom = function () {
  var viewportHeight =
    window.visualViewport &&
    window.visualViewport.height
      ? window.visualViewport.height
      : (
          window.innerHeight ||
          document.documentElement.clientHeight ||
          0
        );

  var bottom = 0;

  /*
   * Measure the elements that are actually visible, including the same
   * elements after Impulse turns them into sticky/fixed header pieces.
   * Do not use Shopify section wrappers because their document-flow
   * rectangles can be stale after scrolling.
   */
  document
    .querySelectorAll(
      ".announcement-bar, .promo-banner, .site-header"
    )
    .forEach(function (element) {
      var style =
        window.getComputedStyle(element);

      if (
        style.display === "none" ||
        style.visibility === "hidden"
      ) {
        return;
      }

      var rect =
        element.getBoundingClientRect();

      if (
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.top < viewportHeight
      ) {
        bottom =
          Math.max(
            bottom,
            rect.bottom
          );
      }
    });

  return Math.max(
    0,
    Math.min(
      Math.round(bottom),
      Math.max(
        0,
        Math.round(viewportHeight - 160)
      )
    )
  );
};

TagalysCustomisations.setSearchOpenFromScrollState = function () {
  if (document.body) {
    document.body.classList.remove(
      "tagalys-search-open-from-scroll"
    );
  }
};


TagalysCustomisations.ensurePredictiveSearchDrawerEdgeStyles =
  function () {
    if (
      document.getElementById(
        "tagalys-predictive-search-edge-styles"
      )
    ) {
      return;
    }

    var style =
      document.createElement(
        "style"
      );

    style.id =
      "tagalys-predictive-search-edge-styles";

    style.textContent = `
      /*
       * The header search container is moved to <body>.
       * Make the active drawer cover the viewport from edge to edge so the
       * underlying page can never show through around the sides or bottom.
       */
      .site-header__search-container[data-tagalys-body-portal="true"].is-active {
        position: fixed !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        min-width: 100vw !important;
        margin: 0 !important;
        box-sizing: border-box !important;
        background: #f6f6f4 !important;
        overflow-x: hidden !important;
        z-index: 3 !important;
      }

      .site-header__search-container[data-tagalys-body-portal="true"].is-active
        .site-header__search {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        background: #f6f6f4 !important;
        box-sizing: border-box !important;
      }
    `;

    document.head.appendChild(
      style
    );
  };


TagalysCustomisations.updatePredictiveSearchDrawerGeometry = function (wrapper) {
  if (
    !wrapper ||
    (wrapper.dataset.context || "header") !== "header"
  ) {
    return;
  }

  var searchContainer =
    TagalysCustomisations
      .ensurePredictiveSearchBodyPortal(wrapper);

  if (!searchContainer) {
    return;
  }

  TagalysCustomisations
    .ensurePredictiveSearchDrawerEdgeStyles();

  var visualViewport =
    window.visualViewport || null;

  var viewportTop =
    visualViewport
      ? Math.max(
          0,
          Math.round(
            visualViewport.offsetTop || 0
          )
        )
      : 0;

  var viewportHeight =
    visualViewport &&
    visualViewport.height
      ? Math.round(
          visualViewport.height
        )
      : (
          window.innerHeight ||
          document.documentElement.clientHeight ||
          0
        );

  /*
   * Always start directly below the currently visible sticky/header stack.
   */
  var headerBottom =
    TagalysCustomisations
      .getPredictiveSearchHeaderBottom();

  var top =
    Math.max(
      viewportTop,
      Math.round(headerBottom)
    );

  /*
   * Desktop visual alignment:
   * getBoundingClientRect().bottom is landing about 3px lower than the
   * visible header edge on this theme, which exposes a narrow strip of the
   * page behind the predictive drawer. Pull the drawer up by 3px on desktop.
   * Mobile geometry remains unchanged.
   */
  if (
    window.matchMedia &&
    window.matchMedia(
      "(min-width: 769px)"
    ).matches
  ) {
    top =
      Math.max(
        0,
        top - 4
      );
  }


  var height =
    Math.max(
      160,
      Math.round(
        viewportTop +
        viewportHeight -
        top
      )
    );

  searchContainer.style.setProperty(
    "--tagalys-search-top",
    top + "px"
  );

  searchContainer.style.setProperty(
    "--tagalys-search-height",
    height + "px"
  );

  /*
   * Use TOP + BOTTOM anchoring instead of relying only on a calculated pixel
   * height. Browser zoom, visualViewport rounding and fractional header
   * heights can otherwise leave a 1–3px strip of the underlying page visible
   * below the predictive drawer.
   */
  searchContainer.style.setProperty(
    "top",
    top + "px",
    "important"
  );

  searchContainer.style.setProperty(
    "bottom",
    "0px",
    "important"
  );

  searchContainer.style.setProperty(
    "left",
    "0px",
    "important"
  );

  searchContainer.style.setProperty(
    "right",
    "0px",
    "important"
  );

  searchContainer.style.setProperty(
    "width",
    "100vw",
    "important"
  );

  searchContainer.style.setProperty(
    "height",
    "auto",
    "important"
  );

  searchContainer.style.setProperty(
    "max-height",
    "none",
    "important"
  );

  searchContainer.style.setProperty(
    "margin",
    "0",
    "important"
  );

  searchContainer.style.setProperty(
    "background",
    "#f6f6f4",
    "important"
  );

  if (typeof searchContainer.scrollLeft === "number") {
    searchContainer.scrollLeft = 0;
  }

  var searchLayout = wrapper.querySelector(
    "[data-tagalys-search-layout]"
  );

  if (
    searchLayout &&
    typeof searchLayout.scrollLeft === "number"
  ) {
    searchLayout.scrollLeft = 0;
  }
};


/* =========================================================
   Mobile predictive-search page lock + single-scroll drawer
   ========================================================= */
TagalysCustomisations.mobilePredictiveSearchLockState =
  TagalysCustomisations.mobilePredictiveSearchLockState || {
    locked: false,
    scrollY: 0,
    previousBodyTop: ""
  };

TagalysCustomisations.ensureMobilePredictiveSearchStyles = function () {
  if (document.getElementById("tagalys-mobile-search-single-scroll-styles")) {
    return;
  }

  var style = document.createElement("style");
  style.id = "tagalys-mobile-search-single-scroll-styles";
  style.textContent = `
    @media only screen and (max-width: 768px) {
      html.tagalys-mobile-search-open,
      body.tagalys-mobile-search-open {
        overflow: hidden !important;
        overscroll-behavior: none !important;
      }

      body.tagalys-mobile-search-open {
        position: fixed !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
      }

      .tagalys-mobile-search-backdrop {
        position: fixed !important;
        inset: 0 !important;
        z-index: 99990 !important;
        background: rgba(0, 0, 0, 0.14) !important;
        pointer-events: auto !important;
      }

      /* The drawer itself owns the only vertical scrollbar. */
      body.tagalys-mobile-search-open .site-header__search-container.is-active {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100dvh !important;
        max-height: 100dvh !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
        overscroll-behavior-y: contain !important;
        -webkit-overflow-scrolling: touch !important;
        background: #f6f6f4 !important;
        z-index: 100000 !important;
      }

      /* Remove all nested height/overflow constraints beneath the drawer. */
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .site-header__search {
        position: relative !important;
        inset: auto !important;
        width: 100% !important;
        height: auto !important;
        min-height: 100% !important;
        max-height: none !important;
        overflow: visible !important;
        background: #f6f6f4 !important;
      }

      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .site-header__search .page-width {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        min-height: 100% !important;
        max-height: none !important;
        overflow: visible !important;
        background: #f6f6f4 !important;
      }

      body.tagalys-mobile-search-open
        .site-header__search-container.is-active predictive-search[data-context="header"],
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active predictive-search[data-context="header"] form {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow: visible !important;
      }

      body.tagalys-mobile-search-open
        .site-header__search-container.is-active #predictive-search-pre.tagalys-search-layout,
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active predictive-search[data-context="header"] .tagalys-search-layout {
        flex: 0 0 auto !important;
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow-x: visible !important;
        overflow-y: visible !important;
        overscroll-behavior: auto !important;
        -webkit-overflow-scrolling: auto !important;
        scrollbar-width: auto !important;
      }

      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .tagalys-search-main,
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .tagalys-search-products,
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .tagalys-search-recommendations,
      body.tagalys-mobile-search-open
        .site-header__search-container.is-active .tagalys-search-suggestions-body {
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
      }

      /* Keep View More from becoming the browser's scroll anchor while rows
         are revealed above it. */
      body.tagalys-mobile-search-open
        .tagalys-predictive-view-more-wrap {
        overflow-anchor: none !important;
      }

      body.tagalys-mobile-search-open
        [data-tagalys-product-card] {
        scroll-margin-top: 84px;
      }

      /* Must come after the theme's mobile .grid-product { display:block !important }
         rule. That later theme rule otherwise makes every View More card visible. */
      body.tagalys-mobile-search-open
        predictive-search[data-context="header"]
        [data-tagalys-suggestions-results]
        [data-tagalys-product-card].tagalys-predictive-product-hidden {
        display: none !important;
        visibility: hidden !important;
      }

      body.tagalys-mobile-search-open
        .tagalys-predictive-view-more.is-loading {
        position: relative;
        pointer-events: none;
        opacity: 0.72;
        padding-left: 42px;
      }

      body.tagalys-mobile-search-open
        .tagalys-predictive-view-more.is-loading::before {
        content: "";
        position: absolute;
        left: 18px;
        top: 50%;
        width: 14px;
        height: 14px;
        margin-top: -7px;
        border: 2px solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        animation: tagalysPredictiveViewMoreSpin 0.7s linear infinite;
      }
    }

    @keyframes tagalysPredictiveViewMoreSpin {
      to { transform: rotate(360deg); }
    }
  `;

  document.head.appendChild(style);
};

TagalysCustomisations.lockMobilePredictiveSearchPage = function (wrapper) {
  if (
    !wrapper ||
    (wrapper.dataset.context || "header") !== "header" ||
    !window.matchMedia("(max-width: 768px)").matches
  ) {
    return;
  }

  TagalysCustomisations.ensureMobilePredictiveSearchStyles();

  var state = TagalysCustomisations.mobilePredictiveSearchLockState;
  var searchContainer =
    TagalysCustomisations.ensurePredictiveSearchBodyPortal(wrapper);

  if (!searchContainer) {
    return;
  }

  if (!state.locked) {
    state.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    state.previousBodyTop = document.body.style.top || "";
    state.locked = true;

    document.documentElement.classList.add("tagalys-mobile-search-open");
    document.body.classList.add("tagalys-mobile-search-open");
    document.body.style.setProperty("top", (-state.scrollY) + "px", "important");

    var backdrop = document.createElement("div");
    backdrop.className = "tagalys-mobile-search-backdrop";
    backdrop.setAttribute("aria-hidden", "true");
    document.body.insertBefore(backdrop, searchContainer);
  }

  /* Always start the single drawer scroller at the top when the drawer opens. */
  searchContainer.scrollTop = 0;
  searchContainer.scrollLeft = 0;
};

TagalysCustomisations.unlockMobilePredictiveSearchPage = function () {
  var state = TagalysCustomisations.mobilePredictiveSearchLockState;

  document
    .querySelectorAll(".tagalys-mobile-search-backdrop")
    .forEach(function (backdrop) {
      backdrop.remove();
    });

  document.documentElement.classList.remove("tagalys-mobile-search-open");
  document.body.classList.remove("tagalys-mobile-search-open");

  if (!state || !state.locked) {
    return;
  }

  if (state.previousBodyTop) {
    document.body.style.top = state.previousBodyTop;
  } else {
    document.body.style.removeProperty("top");
  }

  state.locked = false;

  window.scrollTo(0, state.scrollY || 0);
};

if (!window.__tagalysMobilePredictiveSearchCloseBound) {
  window.__tagalysMobilePredictiveSearchCloseBound = true;

  document.addEventListener(
    "predictive-search:close-all",
    function () {
      TagalysCustomisations
        .setSearchOpenFromScrollState(
          false
        );

      TagalysCustomisations
        .unlockMobilePredictiveSearchPage();
    }
  );
}


/* =========================================================
   Recent searches
   ========================================================= */

TagalysCustomisations.recentSearchStorageKey =
  "threadbare_recent_searches_v1";

TagalysCustomisations.getRecentSearches = function () {
  var searches = [];

  try {
    var raw = window.localStorage
      ? localStorage.getItem(
          TagalysCustomisations
            .recentSearchStorageKey
        )
      : "";

    searches = raw
      ? JSON.parse(raw)
      : [];
  } catch (error) {
    searches = [];
  }

  if (!Array.isArray(searches)) {
    return [];
  }

  return searches
    .map(function (item) {
      return String(item || "").trim();
    })
    .filter(Boolean)
    .slice(0, 3);
};


TagalysCustomisations.saveRecentSearch = function (query) {
  query = String(query || "").trim();

  if (!query) {
    return;
  }

  var searches =
    TagalysCustomisations
      .getRecentSearches();

  var normalisedQuery =
    query.toLowerCase();

  searches = searches.filter(
    function (item) {
      return String(item)
        .toLowerCase() !==
        normalisedQuery;
    }
  );

  searches.unshift(query);
  searches = searches.slice(0, 3);

  try {
    if (window.localStorage) {
      localStorage.setItem(
        TagalysCustomisations
          .recentSearchStorageKey,
        JSON.stringify(searches)
      );
    }
  } catch (error) {
    // Ignore storage errors.
  }
};


TagalysCustomisations.shouldLoadSuggestedSearchProductsInline = function () {
  var config =
    window.TagalysShopifyConfig || {};

  return Boolean(
    config.predictiveSearch &&
    config.predictiveSearch
      .loadSuggestedSearchesInline === true
  );
};


TagalysCustomisations.setPredictiveClearState = function (
  wrapper,
  active
) {
  if (!wrapper) {
    return;
  }

  var clearButton =
    wrapper.querySelector(
      "[data-tagalys-predictive-clear]"
    );

  active = Boolean(
    clearButton &&
    TagalysCustomisations
      .shouldLoadSuggestedSearchProductsInline() &&
    active
  );

  if (clearButton) {
    clearButton.hidden = !active;
  }

  wrapper.classList.toggle(
    "tagalys-inline-query-active",
    active
  );
};


TagalysCustomisations.predictiveProductInitialVisible = 24;
TagalysCustomisations.predictiveProductRevealStep = 24;


TagalysCustomisations.resetPredictiveViewMore = function (wrapper) {
  if (!wrapper) {
    return;
  }

  var button =
    wrapper.querySelector(
      "[data-tagalys-predictive-view-more]"
    );

  var buttonWrap =
    wrapper.querySelector(
      "[data-tagalys-predictive-view-more-wrap]"
    );

  if (button) {
    button.hidden = true;
  }

  if (buttonWrap) {
    buttonWrap.hidden = true;
  }

  wrapper
    .querySelectorAll(
      "[data-tagalys-product-card].tagalys-predictive-product-hidden"
    )
    .forEach(function (card) {
      card.classList.remove(
        "tagalys-predictive-product-hidden"
      );
      card.hidden = false;
      card.removeAttribute("aria-hidden");
    });

  delete wrapper.dataset
    .tagalysPredictiveViewMoreKey;
  delete wrapper.dataset
    .tagalysPredictiveVisibleCount;
};


TagalysCustomisations.updatePredictiveViewMore = function (
  wrapper,
  options
) {
  options = options || {};

  if (!wrapper) {
    return;
  }

  var button =
    wrapper.querySelector(
      "[data-tagalys-predictive-view-more]"
    );

  var buttonWrap =
    wrapper.querySelector(
      "[data-tagalys-predictive-view-more-wrap]"
    );

  var resultsContainer =
    wrapper.querySelector(
      "[data-tagalys-suggestions-results]"
    );

  var searchInput =
    wrapper.querySelector(
      "[data-search-input]"
    );

  if (
    !button ||
    !resultsContainer ||
    !searchInput ||
    !TagalysCustomisations
      .shouldLoadSuggestedSearchProductsInline()
  ) {
    TagalysCustomisations
      .resetPredictiveViewMore(
        wrapper
      );
    return;
  }

  var query =
    String(searchInput.value || "")
      .replace(/\*/g, "")
      .trim();

  var cards =
    Array.prototype.slice.call(
      resultsContainer.querySelectorAll(
        "[data-tagalys-product-card]"
      )
    );

  if (!query || !cards.length) {
    button.hidden = true;
    if (buttonWrap) {
      buttonWrap.hidden = true;
    }
    return;
  }

  var gender =
    TagalysCustomisations
      .getSelectedGenderValue(
        wrapper
      );

  var key =
    query.toLowerCase() +
    "|" +
    String(gender || "all")
      .toLowerCase();

  var storedKey =
    wrapper.dataset
      .tagalysPredictiveViewMoreKey ||
    "";

  var initialVisible =
    Number(
      TagalysCustomisations
        .predictiveProductInitialVisible
    ) || 10;

  var visibleCount =
    parseInt(
      wrapper.dataset
        .tagalysPredictiveVisibleCount ||
      "",
      10
    );

  if (
    options.reset === true ||
    key !== storedKey ||
    !Number.isFinite(visibleCount) ||
    visibleCount < 1
  ) {
    visibleCount = initialVisible;
  }

  visibleCount = Math.min(
    visibleCount,
    cards.length
  );

  wrapper.dataset
    .tagalysPredictiveViewMoreKey =
    key;

  wrapper.dataset
    .tagalysPredictiveVisibleCount =
    String(visibleCount);

  cards.forEach(function (card, index) {
    var shouldHide = index >= visibleCount;

    card.classList.toggle(
      "tagalys-predictive-product-hidden",
      shouldHide
    );

    /* Keep a native DOM hidden state as a second source of truth.
       This protects View More from theme CSS that forces grid cards to display:block. */
    card.hidden = shouldHide;

    if (shouldHide) {
      card.setAttribute("aria-hidden", "true");
    } else {
      card.removeAttribute("aria-hidden");
    }
  });

  /* Every product we actually fetched is shown. View More represents
     products still available on the API, not cards already hidden in DOM. */
  cards.forEach(function (card) {
    card.classList.remove("tagalys-predictive-product-hidden");
    card.hidden = false;
    card.removeAttribute("aria-hidden");
  });

  var totalCount = parseInt(
    wrapper.dataset.tagalysPredictiveTotalCount || "0",
    10
  );

  var requestedCount = parseInt(
    wrapper.dataset.tagalysPredictiveRequestedCount ||
    String(TagalysCustomisations.predictiveProductInitialVisible),
    10
  );

  var hasMore = Number.isFinite(totalCount) &&
    totalCount > cards.length &&
    cards.length >= Math.min(requestedCount, totalCount);

  button.hidden = !hasMore;
  TagalysCustomisations.setPredictiveViewMoreLoading(button, false);

  if (buttonWrap) {
    buttonWrap.hidden = button.hidden;
  }
};


TagalysCustomisations.setPredictiveViewMoreLoading = function (
  button,
  isLoading
) {
  if (!button) {
    return;
  }

  if (!button.dataset.tagalysViewMoreLabel) {
    button.dataset.tagalysViewMoreLabel =
      String(button.textContent || "View More").trim() ||
      "View More";
  }

  button.dataset.tagalysViewMoreLoading =
    isLoading ? "true" : "false";

  button.classList.toggle(
    "is-loading",
    Boolean(isLoading)
  );

  button.disabled = Boolean(isLoading);
  button.setAttribute(
    "aria-busy",
    isLoading ? "true" : "false"
  );

  button.textContent = isLoading
    ? "Loading..."
    : button.dataset.tagalysViewMoreLabel;
};


TagalysCustomisations.scrollToFirstRevealedPredictiveProduct = function (
  wrapper,
  card
) {
  if (!wrapper || !card) {
    return;
  }

  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      try {
        card.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      } catch (error) {
        card.scrollIntoView(true);
      }
    });
  });
};


TagalysCustomisations.loadSuggestedSearchProductsInline = function (
  query,
  wrapper
) {
  if (
    !TagalysCustomisations
      .shouldLoadSuggestedSearchProductsInline()
  ) {
    return false;
  }

  query = String(query || "")
    .replace(/\*/g, "")
    .trim();

  if (!query || !wrapper) {
    return false;
  }

  var searchInput =
    wrapper.querySelector(
      "[data-search-input]"
    );

  if (!searchInput) {
    return false;
  }

  TagalysCustomisations
    .setStoredSearchGender(
      TagalysCustomisations
        .getSelectedGenderValue(wrapper)
    );

  TagalysCustomisations
    .saveRecentSearch(query);

  /*
   * Keep the predictive drawer open and make the selected suggestion the
   * active query. Tagalys SearchSuggestions already listens to this input,
   * so dispatching input/change makes it fetch and render the matching
   * product cards right here instead of navigating to /search.
   */
  searchInput.value = query;
  wrapper.dataset
    .tagalysRecentInputClicked = "false";

  TagalysCustomisations
    .setPredictiveClearState(
      wrapper,
      true
    );

  searchInput.dispatchEvent(
    new Event("input", { bubbles: true })
  );

  searchInput.dispatchEvent(
    new Event("change", { bubbles: true })
  );

  try {
    searchInput.focus({ preventScroll: true });
  } catch (error) {
    searchInput.focus();
  }

  return true;
};


TagalysCustomisations.buildCanonicalSearchUrl = function (
  query,
  gender
) {
  query = String(query || "")
    .replace(/\*/g, "")
    .trim();

  if (!query) {
    return "";
  }

  var searchResultsURL =
    (
      window.TagalysShopifyConfig &&
      window.TagalysShopifyConfig
        .searchResultsURL
    ) ||
    "/search";

  gender = String(
    gender ||
    TagalysCustomisations
      .getStoredSearchGender() ||
    "all"
  ).toLowerCase();

  try {
    var url = new URL(
      searchResultsURL,
      window.location.origin
    );

    /*
     * Tagalys' native Search Suggestions links use `query=...`. Threadbare's
     * canonical search URL uses Shopify's `q=...` parameter, so build that
     * URL before navigation instead of landing on `?query=` and redirecting.
     */
    url.search = "";
    url.searchParams.set("q", query);

    if (gender !== "all") {
      url.searchParams.set(
        "selectGender",
        gender
      );
    }

    return url.toString();
  } catch (error) {
    var fallback =
      String(searchResultsURL)
        .split("?")[0] +
      "?q=" +
      encodeURIComponent(query);

    if (gender !== "all") {
      fallback +=
        "&selectGender=" +
        encodeURIComponent(gender);
    }

    return fallback;
  }
};


TagalysCustomisations.captureCurrentSearchAsRecent = function () {
  var searchResultsURL =
    (
      window.TagalysShopifyConfig &&
      window.TagalysShopifyConfig
        .searchResultsURL
    ) ||
    "/search";

  var currentPath =
    window.location.pathname || "";

  if (
    currentPath.indexOf(
      String(searchResultsURL)
        .split("?")[0]
    ) === -1
  ) {
    return;
  }

  var params =
    new URLSearchParams(
      window.location.search
    );

  var query =
    params.get("q") ||
    params.get("query") ||
    "";

  TagalysCustomisations
    .saveRecentSearch(query);
};


TagalysCustomisations.renderRecentSearches = function (wrapper) {
  if (!wrapper) {
    return;
  }

  var context =
    wrapper.dataset.context ||
    "header";

  var container =
    wrapper.querySelector(
      '[data-tagalys-recent-searches="' +
      context +
      '"]'
    );

  var input =
    wrapper.querySelector(
      "[data-search-input]"
    );

  if (!container || !input) {
    return;
  }

  if (
    !TagalysCustomisations
      .isSuggestionGroupEnabled(
        "predictive",
        "recentSearches"
      )
  ) {
    container.hidden = true;
    container.innerHTML = "";
    return;
  }

  var hasQuery =
    input.value.trim().length > 0;

  if (hasQuery) {
    container.hidden = true;
    return;
  }

  var searches =
    TagalysCustomisations
      .getRecentSearches();

  if (
    window.matchMedia &&
    window.matchMedia(
      "(max-width: 768px)"
    ).matches
  ) {
    searches = searches.slice(0, 3);
  }

  container.innerHTML = "";

  if (!searches.length) {
    container.hidden = true;
    return;
  }

  var heading =
    document.createElement("div");

  heading.className =
    "tagalys-search-section-title";

  heading.textContent =
    "Recent searches";

  var list =
    document.createElement("ul");

  searches.forEach(function (query) {
    var item =
      document.createElement("li");

    item.className =
      "recent-search-item";

    var link =
      document.createElement("a");

    link.href =
      TagalysCustomisations
        .buildCanonicalSearchUrl(
          query,
          TagalysCustomisations
            .getSelectedGenderValue(
              wrapper
            )
        );

    link.className =
      "search-results-link";

    link.dataset.recentSearch =
      query;

    link.textContent = query;

    item.appendChild(link);
    list.appendChild(item);
  });

  container.appendChild(heading);
  container.appendChild(list);
  container.hidden = false;
};



/* =========================================================
   SEARCH-TERM SUGGESTIONS — TAGALYS "Searches"

   Keep the existing Threadbare predictive-search layout exactly as-is.
   The only change here is the source: suggestions now come from the
   Tagalys text-suggestion section whose section_id is "Searches".
   ========================================================= */

/*
 * SearchResults used this value only in the template options previously.
 * It is now also sent on every Tagalys /search request so the result API does
 * not silently fall back to its smaller default page size. Numbered
 * pagination remains available for searches with more than 60 results.
 */
TagalysCustomisations.searchResultsPerPage = 60;

/*
 * Predictive product suggestions were hard-capped at 10 products. On desktop
 * that is exactly two rows of the five-column product grid. Request a much
 * fuller product set for every typed query while keeping the normal search
 * page paginated.
 */
TagalysCustomisations.predictiveProductCandidateLimit = 24;

/*
 * Ask Tagalys for a wider auxiliary candidate set, then locally filter/reorder
 * it for the selected Menswear / Womenswear audience. This prevents the first
 * five WW-heavy candidates from crowding MW collections/searches out before
 * our audience filter gets a chance to run.
 */
TagalysCustomisations.predictiveCollectionCandidateLimit = 12;
TagalysCustomisations.predictivePageCandidateLimit = 10;
TagalysCustomisations.predictiveSearchCandidateLimit = 12;
TagalysCustomisations.predictiveAuxiliaryDisplayLimit = 5;
TagalysCustomisations.searchTermSuggestionLimit = 5;


TagalysCustomisations.syncTagalysSearchTermSuggestions =
  function (wrapper) {
    if (!wrapper) {
      return [];
    }

    var context =
      wrapper.dataset.context ||
      "header";

    var input =
      wrapper.querySelector(
        "[data-search-input]"
      );

    var destination =
      wrapper.querySelector(
        '[data-search-term-suggestions="' +
        context +
        '"]'
      );

    var sourceContainer =
      wrapper.querySelector(
        '[data-tagalys-text-suggestions="' +
        context +
        '"]'
      );

    var query =
      input
        ? input.value.trim()
        : "";

    if (
      !query ||
      !destination ||
      !sourceContainer
    ) {
      if (destination) {
        destination.innerHTML = "";
        destination.hidden = true;
        destination.style.removeProperty(
          "display"
        );
      }

      return [];
    }

    /*
     * Tagalys' actual rendered text-suggestion sections do not currently
     * include data-section-id. Detect each section from its visible
     * .section-title text, while still accepting data-section-id if Tagalys
     * adds it in a future response.
     */
    var sections =
      Array.prototype.slice.call(
        sourceContainer.querySelectorAll(
          ".text-suggestion-section"
        )
      );

    function getSectionName(section) {
      if (!section) {
        return "";
      }

      var explicitId =
        String(
          section.getAttribute(
            "data-section-id"
          ) ||
          ""
        ).trim();

      if (explicitId) {
        return explicitId;
      }

      var sectionTitle =
        section.querySelector(
          ".section-title"
        );

      return String(
        sectionTitle
          ? sectionTitle.textContent
          : ""
      ).trim();
    }

    var searchesSection =
      sections.find(function (section) {
        var sectionName =
          getSectionName(section)
            .toLowerCase();

        return (
          sectionName === "searches" ||
          sectionName === "queries"
        );
      });

    /*
     * Search Suggestions belong in Threadbare's existing top destination.
     * Collections and Pages stay in their current lower text section.
     */
    sections.forEach(function (section) {
      var sectionName =
        getSectionName(section)
          .toLowerCase();

      var isSearches =
        sectionName === "searches" ||
        sectionName === "queries";

      if (isSearches) {
        section.hidden = true;
        section.style.setProperty(
          "display",
          "none",
          "important"
        );
      }

      /*
       * Do not force Collections / Pages visible here. Their visibility is
       * controlled by filterSuggestionListForGender(), which hides the whole
       * section when every item has been filtered out. Forcing them visible
       * here caused empty section headings to remain on screen.
       */
    });

    if (!searchesSection) {
      destination.innerHTML = "";
      destination.hidden = true;
      destination.style.removeProperty(
        "display"
      );

      return [];
    }

    var clone =
      searchesSection.cloneNode(
        true
      );

    clone.hidden = false;
    clone.removeAttribute(
      "hidden"
    );
    clone.style.removeProperty(
      "display"
    );
    clone.classList.add(
      "tagalys-searches-section"
    );

    var title =
      clone.querySelector(
        ".section-title"
      );

    if (title) {
      title.textContent =
        "Search suggestions";

      title.classList.add(
        "tagalys-search-section-title"
      );
    }

    var resultItems = [];

    clone
      .querySelectorAll("li")
      .forEach(function (item) {
        item.hidden = false;
        item.style.removeProperty(
          "display"
        );

        item.classList.add(
          "search-term-suggestion-item"
        );

        var link =
          item.querySelector("a");

        if (!link) {
          return;
        }

        var text =
          String(
            link.textContent ||
            ""
          )
            .replace(/\s+/g, " ")
            .trim();

        if (!text) {
          return;
        }

        resultItems.push(text);

        link.classList.add(
          "search-results-link"
        );

        link.setAttribute(
          "data-search-term-suggestion",
          text
        );

        /*
         * Keep the query URL generated by Tagalys. The SDK owns the configured
         * `q` parameter. Only append Threadbare's additional audience state.
         */
        try {
          var suggestionUrl =
            new URL(
              link.href,
              window.location.origin
            );

          var selectedGender =
            TagalysCustomisations
              .getSelectedGenderValue(
                wrapper
              );

          if (selectedGender !== "all") {
            suggestionUrl.searchParams.set(
              "selectGender",
              selectedGender
            );
          } else {
            suggestionUrl.searchParams.delete(
              "selectGender"
            );
          }

          link.href =
            suggestionUrl.toString();
        } catch (error) {
          /* Leave the SDK-generated link untouched if URL parsing fails. */
        }
      });

    destination.innerHTML = "";
    destination.appendChild(
      clone
    );

    TagalysCustomisations
      .filterSuggestionListForGender(
        destination,
        TagalysCustomisations
          .getSelectedGenderValue(
            wrapper
          )
      );

    var visibleItems =
      Array.prototype.some.call(
        destination.querySelectorAll(
          "li"
        ),
        function (item) {
          return (
            !item.hidden &&
            window.getComputedStyle(item)
              .display !== "none"
          );
        }
      );

    var searchSuggestionsEnabled =
      TagalysCustomisations
        .isSuggestionGroupEnabled(
          "predictive",
          "searchSuggestions"
        );

    destination.hidden =
      !visibleItems ||
      !searchSuggestionsEnabled;

    if (
      visibleItems &&
      searchSuggestionsEnabled
    ) {
      destination.style.setProperty(
        "display",
        "block",
        "important"
      );
    } else {
      destination.style.removeProperty(
        "display"
      );
    }

    return resultItems;
  };


TagalysCustomisations.fetchSearchTermSuggestions =
  function (wrapper) {
    return Promise.resolve(
      TagalysCustomisations
        .syncTagalysSearchTermSuggestions(
          wrapper
        )
    );
  };



TagalysCustomisations.initSearchSuggestions = function () {
  var wrappers =
    document.querySelectorAll(
      "predictive-search[data-context]"
    );

  if (!wrappers.length) {
    console.warn(
      "[Tagalys] Predictive search wrappers not found."
    );
    return;
  }

  TagalysCustomisations
    .captureCurrentSearchAsRecent();

  var storedGender =
    TagalysCustomisations
      .getStoredSearchGender();

  var shouldResetAfterSubmit =
    TagalysCustomisations
      .consumeSearchResetAfterSubmit();

  if (shouldResetAfterSubmit) {
    /*
     * Browsers can restore form values after DOMContentLoaded/pageshow.
     * Clear the header predictive input across the first paint as well so a
     * submitted query never reappears when search is opened on the results
     * page. The results query itself still comes from the URL/Tagalys state.
     */
    TagalysCustomisations.clearSearchInputs();

    window.requestAnimationFrame(function () {
      TagalysCustomisations.clearSearchInputs();

      window.requestAnimationFrame(function () {
        TagalysCustomisations.clearSearchInputs();
      });
    });

    window.setTimeout(function () {
      TagalysCustomisations.clearSearchInputs();
    }, 120);
  }

  TagalysCustomisations
    .syncSearchGenderInputs(
      storedGender
    );

  wrappers.forEach(function (wrapper) {
    var searchInput =
      wrapper.querySelector(
        "[data-search-input]"
      );

    if (!searchInput) {
      return;
    }

    if (
      searchInput.dataset
        .tagalysSuggestionsInitialized ===
      "true"
    ) {
      return;
    }

    var context =
      wrapper.dataset.context ||
      "header";

    if (context === "header") {
      TagalysCustomisations
        .ensurePredictiveSearchBodyPortal(
          wrapper
        );

      TagalysCustomisations
        .updatePredictiveSearchDrawerGeometry(
          wrapper
        );
    }

    var resultsContainer =
      wrapper.querySelector(
        '[data-tagalys-suggestions-results="' +
        context +
        '"]'
      );

    var searchLayout =
      wrapper.querySelector(
        '[data-tagalys-search-layout="' +
        context +
        '"]'
      );

    var recommendationsContainer =
      wrapper.querySelector(
        '[data-tagalys-empty-recommendations="' +
        context +
        '"]'
      );

    if (!resultsContainer) {
      console.warn(
        "[Tagalys] Predictive results container not found:",
        context
      );
      return;
    }

    var inputSelector =
      "#" + searchInput.id;

    var resultsSelector =
      '[data-tagalys-suggestions-results="' +
      context +
      '"]';


    var querySuggestionsSelector =
      '[data-search-term-suggestions="' +
      context +
      '"]';

    var recentSelector =
      '[data-tagalys-recent-searches="' +
      context +
      '"]';

    var textSuggestionsSelector =
      '[data-tagalys-text-suggestions="' +
      context +
      '"]';

    var recommendationsSelector =
      '[data-tagalys-empty-recommendations="' +
      context +
      '"]';

    var refreshTimer = null;
    var querySuggestionTimer = null;

    var refreshSearchTermSuggestions =
      function (delay) {
        var query =
          searchInput.value
            .trim();

        var container =
          wrapper.querySelector(
            querySuggestionsSelector
          );

        if (!query) {
          if (querySuggestionTimer) {
            window.clearTimeout(
              querySuggestionTimer
            );
          }

          if (container) {
            container.innerHTML = "";
            container.hidden = true;
          }

          return;
        }

        if (querySuggestionTimer) {
          window.clearTimeout(
            querySuggestionTimer
          );
        }

        querySuggestionTimer =
          window.setTimeout(
            function () {
              TagalysCustomisations
                .fetchSearchTermSuggestions(
                  wrapper
                );
            },
            typeof delay === "number"
              ? delay
              : 0
          );
      };

    /* -----------------------------------------------------
       Empty / typed visibility
       ----------------------------------------------------- */
    var updateVisibility = function () {
      var hasSearch =
        searchInput.value
          .trim()
          .length > 0;

      TagalysCustomisations
        .setPredictiveClearState(
          wrapper,
          hasSearch
        );

      TagalysCustomisations
        .updateTrendingCollectionsForGender(
          wrapper,
          TagalysCustomisations
            .getSelectedGenderValue(
              wrapper
            )
        );

      if (searchLayout) {
        searchLayout.classList.toggle(
          "tagalys-search-layout--has-query",
          hasSearch
        );
      }

      /*
       * hidden is the single source of truth. Also remove any stale inline
       * display value left by older theme/search code.
       */
      resultsContainer.style.removeProperty(
        "display"
      );
      resultsContainer.hidden =
        !hasSearch;

      if (recommendationsContainer) {
        recommendationsContainer
          .style
          .removeProperty("display");
        recommendationsContainer.hidden =
          hasSearch;
      }


      var querySuggestionsContainer =
        wrapper.querySelector(
          querySuggestionsSelector
        );

      if (
        querySuggestionsContainer &&
        !hasSearch
      ) {
        querySuggestionsContainer.innerHTML =
          "";
        querySuggestionsContainer.hidden =
          true;
      }

      var recentContainer =
        wrapper.querySelector(
          recentSelector
        );

      if (recentContainer) {
        var searchIsOpen =
          wrapper.dataset
            .tagalysSearchIsOpen ===
          "true";

        var inputWasClicked =
          wrapper.dataset
            .tagalysRecentInputClicked ===
          "true";

        if (
          hasSearch ||
          !searchIsOpen ||
          !inputWasClicked
        ) {
          recentContainer.hidden = true;
        } else {
          TagalysCustomisations
            .renderRecentSearches(
              wrapper
            );
        }
      }

      var textContainer =
        wrapper.querySelector(
          textSuggestionsSelector
        );

      if (
        textContainer &&
        !hasSearch
      ) {
        textContainer.innerHTML = "";
      }

      if (hasSearch) {
        refreshSearchTermSuggestions(
          120
        );

        window.requestAnimationFrame(
          function () {
            TagalysCustomisations
              .filterPredictiveAuxiliarySuggestions(
                wrapper
              );
          }
        );
      }

      return hasSearch;
    };

    /* -----------------------------------------------------
       Force a fresh request for the current query.

       Couture's working implementation dispatches both input and change.
       This is needed when gender changes while the text itself does not,
       and when the drawer is reopened with an existing query.
       ----------------------------------------------------- */
    var refreshSuggestions = function (options) {
      options = options || {};

      var hasSearch =
        updateVisibility();

      var gender =
        TagalysCustomisations
          .getSelectedGenderValue(
            wrapper
          );

      gender =
        TagalysCustomisations
          .setStoredSearchGender(
            gender
          );

      if (!hasSearch) {
        if (recommendationsContainer) {
          TagalysCustomisations
            .initPredictiveRecommendations(
              recommendationsSelector,
              gender,
              options.forceRecommendation === true
            );
        }
        return;
      }

      resultsContainer.hidden = false;

      if (recommendationsContainer) {
        recommendationsContainer.hidden = true;
      }

      if (refreshTimer) {
        window.clearTimeout(
          refreshTimer
        );
      }

      refreshTimer =
        window.setTimeout(
          function () {
            /*
             * SearchSuggestions listens to the field. Dispatch both events,
             * matching the pattern used by Couture's implementation.
             */
            searchInput.dispatchEvent(
              new Event(
                "input",
                { bubbles: true }
              )
            );

            searchInput.dispatchEvent(
              new Event(
                "change",
                { bubbles: true }
              )
            );
          },
          typeof options.delay === "number"
            ? options.delay
            : 20
        );
    };

    /* -----------------------------------------------------
       Gender controls
       ----------------------------------------------------- */
    wrapper
      .querySelectorAll(
        'input[name="selectGender"]'
      )
      .forEach(function (input) {
        input.addEventListener(
          "change",
          function () {
            if (!input.checked) {
              return;
            }

            var gender =
              TagalysCustomisations
                .setStoredSearchGender(
                  input.value
                );

            TagalysCustomisations
              .syncSearchGenderInputs(
                gender
              );

            TagalysCustomisations
              .updateTrendingCollectionsForGender(
                wrapper,
                gender
              );

            TagalysCustomisations
              .filterPredictiveAuxiliarySuggestions(
                wrapper
              );

            refreshSearchTermSuggestions(
              0
            );

            refreshSuggestions({
              delay: 0,
              forceRecommendation: true
            });
          }
        );
      });

    var searchForm =
      searchInput.closest("form");

    if (searchForm) {
      searchForm.addEventListener(
        "submit",
        function () {
          TagalysCustomisations
            .setStoredSearchGender(
              TagalysCustomisations
                .getSelectedGenderValue(
                  wrapper
                )
            );

          TagalysCustomisations
            .saveRecentSearch(
              searchInput.value
            );

          /*
           * Do not prevent/rebuild the search navigation here.
           * Tagalys UIWidgets owns the configured q / f / page / sort state.
           */
          TagalysCustomisations
            .markSearchResetAfterSubmit();
        }
      );
    }

    /* -----------------------------------------------------
       Inline suggested-search click interception

       Tagalys can replace/re-render its suggestion anchors after the first
       inline query. Listen on the stable predictive-search wrapper in the
       capture phase so every current and future Search Suggestions link is
       intercepted before Tagalys' native navigation handler can send the
       customer to /search.
       ----------------------------------------------------- */
    if (
      wrapper.dataset
        .tagalysInlineSuggestionCapture !==
      "true"
    ) {
      wrapper.addEventListener(
        "click",
        function (event) {
          if (
            !TagalysCustomisations
              .shouldLoadSuggestedSearchProductsInline()
          ) {
            return;
          }

          var link =
            event.target.closest
              ? event.target.closest("a")
              : null;

          if (
            !link ||
            !wrapper.contains(link)
          ) {
            return;
          }

          var section =
            link.closest
              ? link.closest(
                  ".text-suggestion-section"
                )
              : null;

          var sectionId =
            section
              ? String(
                  section.getAttribute(
                    "data-section-id"
                  ) || ""
                ).toLowerCase()
              : "";

          var isSearchSuggestion =
            link.hasAttribute(
              "data-search-term-suggestion"
            ) ||
            sectionId === "searches";

          if (!isSearchSuggestion) {
            return;
          }

          var suggestedQuery =
            link.getAttribute(
              "data-search-term-suggestion"
            ) ||
            link.textContent ||
            "";

          suggestedQuery =
            String(suggestedQuery)
              .replace(/\s+/g, " ")
              .trim();

          if (
            TagalysCustomisations
              .loadSuggestedSearchProductsInline(
                suggestedQuery,
                wrapper
              )
          ) {
            event.preventDefault();
            event.stopPropagation();

            if (
              typeof event
                .stopImmediatePropagation ===
              "function"
            ) {
              event
                .stopImmediatePropagation();
            }
          }
        },
        true
      );

      wrapper.dataset
        .tagalysInlineSuggestionCapture =
        "true";
    }


    var querySuggestionsContainer =
      wrapper.querySelector(
        querySuggestionsSelector
      );

    if (querySuggestionsContainer) {
      querySuggestionsContainer
        .addEventListener(
          "click",
          function (event) {
            var link =
              event.target.closest
                ? event.target.closest(
                    "a[data-search-term-suggestion]"
                  )
                : null;

            if (!link) {
              return;
            }

            TagalysCustomisations
              .setStoredSearchGender(
                TagalysCustomisations
                  .getSelectedGenderValue(
                    wrapper
                  )
              );

            var suggestedQuery =
              link.dataset
                .searchTermSuggestion;

            /*
             * Optional Theme Editor behavior: preview the suggested query's
             * products inside this predictive-search panel and stay here.
             */
            if (
              TagalysCustomisations
                .loadSuggestedSearchProductsInline(
                  suggestedQuery,
                  wrapper
                )
            ) {
              event.preventDefault();
              event.stopPropagation();
              return;
            }

            TagalysCustomisations
              .saveRecentSearch(
                suggestedQuery
              );

            TagalysCustomisations
              .markSearchResetAfterSubmit();

            /*
             * Do not rebuild or manually assign the query URL here.
             * The clicked link already contains the URL generated by the
             * Tagalys SDK, with only Threadbare's selectGender appended.
             */
          }
        );
    }

    var recentContainer =
      wrapper.querySelector(
        recentSelector
      );

    if (recentContainer) {
      recentContainer.addEventListener(
        "click",
        function (event) {
          var link =
            event.target.closest
              ? event.target.closest(
                  "a[data-recent-search]"
                )
              : null;

          if (!link) {
            return;
          }

          TagalysCustomisations
            .setStoredSearchGender(
              TagalysCustomisations
                .getSelectedGenderValue(
                  wrapper
                )
            );

          var recentQuery =
            link.dataset.recentSearch;

          TagalysCustomisations
            .saveRecentSearch(
              recentQuery
            );

          TagalysCustomisations
            .markSearchResetAfterSubmit();
        }
      );
    }

    /* -----------------------------------------------------
       Predictive clear

       This is intentionally separate from the close (X) button. Clear keeps
       the drawer open, removes the current predictive query/results and
       restores the original empty predictive-search content.
       ----------------------------------------------------- */
    var predictiveClearButton =
      wrapper.querySelector(
        "[data-tagalys-predictive-clear]"
      );

    if (predictiveClearButton) {
      predictiveClearButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          searchInput.value = "";
          wrapper.dataset
            .tagalysRecentInputClicked =
            "false";

          TagalysCustomisations
            .setPredictiveClearState(
              wrapper,
              false
            );

          TagalysCustomisations
            .resetPredictiveViewMore(
              wrapper
            );

          refreshSearchTermSuggestions(0);
          refreshSuggestions({
            delay: 0,
            forceRecommendation: true
          });

          try {
            searchInput.focus({
              preventScroll: true
            });
          } catch (error) {
            searchInput.focus();
          }
        }
      );
    }

    /* -----------------------------------------------------
       Predictive product View More

       SearchSuggestions already fetches a wider candidate set. Keep the
       first group compact, then progressively reveal more cards in-place.
       ----------------------------------------------------- */
    var predictiveViewMoreButton =
      wrapper.querySelector(
        "[data-tagalys-predictive-view-more]"
      );

    if (predictiveViewMoreButton) {
      predictiveViewMoreButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (
            predictiveViewMoreButton.dataset
              .tagalysViewMoreLoading === "true"
          ) {
            return;
          }

          var searchInput = wrapper.querySelector("[data-search-input]");
          var query = searchInput
            ? String(searchInput.value || "").replace(/\*/g, "").trim()
            : "";

          if (!searchInput || !query) {
            return;
          }

          var currentRequested = parseInt(
            wrapper.dataset.tagalysPredictiveRequestedCount ||
            String(TagalysCustomisations.predictiveProductInitialVisible),
            10
          );

          if (!Number.isFinite(currentRequested) || currentRequested < 1) {
            currentRequested = TagalysCustomisations.predictiveProductInitialVisible;
          }

          var step = Number(
            TagalysCustomisations.predictiveProductRevealStep
          ) || 20;

          var totalCount = parseInt(
            wrapper.dataset.tagalysPredictiveTotalCount || "0",
            10
          );

          var nextRequested = currentRequested + step;
          if (Number.isFinite(totalCount) && totalCount > 0) {
            nextRequested = Math.min(nextRequested, totalCount);
          }

          wrapper.dataset.tagalysPredictiveRequestedCount =
            String(nextRequested);

          TagalysCustomisations.setPredictiveViewMoreLoading(
            predictiveViewMoreButton,
            true
          );

          /* Re-run SearchSuggestions with the larger product count. This is
             intentionally done only on View More, never on normal typing. */
          searchInput.dispatchEvent(
            new Event("input", { bubbles: true })
          );
        }
      );
    }


    /* -----------------------------------------------------
       X / overlay / Escape close
       ----------------------------------------------------- */
    var closeButton =
      wrapper.querySelector(
        ".btn--close-search"
      );

    if (closeButton) {
      closeButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          TagalysCustomisations
            .closePredictiveSearch(
              wrapper
            );
        }
      );
    }

    var screen =
      wrapper.querySelector(
        "[data-screen]"
      );

    if (screen) {
      screen.addEventListener(
        "click",
        function () {
          TagalysCustomisations
            .closePredictiveSearch(
              wrapper
            );
        }
      );
    }

    document.addEventListener(
      "keydown",
      function (event) {
        if (
          event.key === "Escape" &&
          wrapper.classList.contains(
            "is-active"
          )
        ) {
          TagalysCustomisations
            .closePredictiveSearch(
              wrapper
            );
        }
      }
    );

    /* -----------------------------------------------------
       Tagalys SearchSuggestions
       ----------------------------------------------------- */
    /*
     * Keep one options object for the primary Tagalys widget. The SDK-native
     * failover callback below reuses the same templates and presentation
     * options, so Shopify only renders if Tagalys itself invokes failover.
     */
    var searchSuggestionsOptions = {
        searchResultsURL:
          (
            window.TagalysShopifyConfig &&
            window.TagalysShopifyConfig
              .searchResultsURL
          ) ||
          "/search",

        productPageUrl:
          TagalysCustomisations
            .productPageUrl,

        templates: {
          product:
            TagalysCustomisations
              .getPredictiveProductTemplate(),

          textSuggestionSection: {
            options: {
              selector:
                textSuggestionsSelector
            },

            render: function (html, args) {
              var section =
                args.props
                  .textSuggestionSection;

              if (
                !section ||
                !Array.isArray(section.items) ||
                !section.items.length
              ) {
                return null;
              }

              return html`
                <div
                  class="text-suggestion-section"
                  data-section-id=${section.section_id}
                >
                  <span class="section-title">
                    ${section.title}
                  </span>

                  <ul>
                    ${section.items.map(
                      function (item) {
                        return html`
                          <${args.templates.textSuggestionSectionItem}
                            textSuggestionSectionId=${section.section_id}
                            textSuggestionSectionItem=${item}
                          />
                        `;
                      }
                    )}
                  </ul>
                </div>
              `;
            }
          },

                    productList: {
            render: function (html, args) {
              var helpers =
                args.props &&
                args.props.helpers;

              var products =
                helpers &&
                typeof helpers.getProducts === "function"
                  ? (helpers.getProducts() || []).slice()
                  : [];

              var requestState =
                helpers &&
                typeof helpers.getRequestState === "function"
                  ? helpers.getRequestState() || {}
                  : {};

              var predictiveQuery =
                wrapper.dataset
                  .tagalysPredictiveQuery ||
                requestState.query ||
                (
                  helpers &&
                  typeof helpers.getQuery === "function"
                    ? helpers.getQuery()
                    : ""
                ) ||
                "";

              var originalProducts =
                products.slice();

              var debugRows =
                originalProducts.map(
                  function (product, index) {
                    var categoryText = "";
                    var score = 0;

                    try {
                      categoryText =
                        TagalysCustomisations
                          .getFastCategoryPriorityText(
                            product
                          );

                      score =
                        TagalysCustomisations
                          .getFastCategoryPriorityScore(
                            product,
                            predictiveQuery
                          );
                    } catch (error) {
                      categoryText =
                        "[extract error]";

                      score = 0;
                    }

                    return {
                      originalIndex:
                        index + 1,
                      title:
                        product.title ||
                        product.name ||
                        "",
                      handle:
                        product.handle ||
                        product.product_handle ||
                        "",
                      productType:
                        product.product_type ||
                        product.productType ||
                        product.type ||
                        "",
                      category:
                        product.category ||
                        product.product_category ||
                        product.productCategory ||
                        "",
                      categoryText:
                        categoryText,
                      fallbackText:
                        [
                          product.title || "",
                          product.name || "",
                          product.handle || "",
                          product.product_handle || ""
                        ]
                          .join(" "),
                      score:
                        score
                    };
                  }
                );

              products =
                TagalysCustomisations
                  .rankSearchProductsFast(
                    products,
                    predictiveQuery,
                    wrapper.dataset
                      .tagalysPredictiveGender ||
                    TagalysCustomisations
                      .getSelectedGenderValue(
                        wrapper
                      )
                  );

              if (
                TagalysCustomisations
                  .predictiveCategoryDebug
              ) {
                console.group(
                  "[Tagalys Predictive Debug] Ranking:",
                  predictiveQuery ||
                  "(empty query)"
                );

                console.log(
                  "query used for ranking:",
                  predictiveQuery
                );

                console.log(
                  "wrapper stored query:",
                  wrapper.dataset
                    .tagalysPredictiveQuery
                );

                console.log(
                  "requestState:",
                  requestState
                );

                console.log(
                  "helpers keys:",
                  helpers
                    ? Object.keys(helpers)
                    : []
                );

                console.log(
                  "product count:",
                  originalProducts.length
                );

                console.table(
                  debugRows
                );

                console.log(
                  "original order:",
                  originalProducts.map(
                    function (product, index) {
                      return {
                        position:
                          index + 1,
                        title:
                          product.title ||
                          product.name ||
                          "",
                        handle:
                          product.handle ||
                          product.product_handle ||
                          ""
                      };
                    }
                  )
                );

                console.log(
                  "ranked order:",
                  products.map(
                    function (product, index) {
                      return {
                        position:
                          index + 1,
                        title:
                          product.title ||
                          product.name ||
                          "",
                        handle:
                          product.handle ||
                          product.product_handle ||
                          "",
                        score:
                          TagalysCustomisations
                            .getFastCategoryPriorityScore(
                              product,
                              predictiveQuery
                            )
                      };
                    }
                  )
                );

                if (originalProducts[0]) {
                  console.log(
                    "FIRST product payload (expand this):",
                    originalProducts[0]
                  );

                  console.log(
                    "FIRST product keys:",
                    Object.keys(
                      originalProducts[0]
                    )
                  );
                }

                console.groupEnd();
              }

              if (!products.length) {
                return null;
              }

              return html`
                <div class="products">
                  ${products.map(function (product) {
                    return html`
                      <${args.templates.product}
                        key=${product.id}
                        product=${product}
                      />
                    `;
                  })}
                </div>
              `;
            }
          },

widget: {
            options: {
              selector:
                resultsSelector,

              position: false,
              includeTagalysCSS: false,

              minimumCharactersToShowSuggestions:
                1,

              sections: {
                products: {
                  include: [
                    "total_count",
                    "items"
                  ],
                  count:
                    TagalysCustomisations
                      .predictiveProductCandidateLimit
                },

                collections: {
                  count:
                    TagalysCustomisations
                      .predictiveCollectionCandidateLimit
                },

                pages: {
                  count:
                    TagalysCustomisations
                      .predictivePageCandidateLimit
                },

                "Searches": {
                  count:
                    TagalysCustomisations
                      .predictiveSearchCandidateLimit
                }
              }
            },

            render: function (html, args) {
              var props =
                args.props || {};

              var helpers =
                props.helpers;

              var showTypeSuggestions =
                helpers
                  .exceedsMinimumCharactersToShowSuggestions();

              var TypeSuggestionsTemplate =
                args.templates &&
                args.templates.typeSuggestions;

              var products =
                helpers.getProducts
                  ? helpers.getProducts()
                  : [];

              var isLoading =
                props.loading === true;

              var showNoProducts =
                showTypeSuggestions &&
                !isLoading &&
                (!products || !products.length);

              var content = null;

              /*
               * Keep TypeSuggestions mounted even when there are no products,
               * because Collections / Pages are rendered into their separate
               * selector by Tagalys.
               */
              if (
                showTypeSuggestions &&
                TypeSuggestionsTemplate
              ) {
                content = html`
                  <${TypeSuggestionsTemplate} />
                `;
              }

              return html`
                <div class="tagalys-search-suggestions-body">
                  ${showNoProducts
                    ? html`
                        <div
                          class="tagalys-search-no-results"
                          role="status"
                          aria-live="polite"
                        >
                          No products found
                        </div>
                      `
                    : null}

                  ${content}
                </div>
              `;
            }
          }
        },

        callbacks: {
          beforeAPICall: function (params) {
            /*
             * Tagalys can invoke this callback without request params during
             * an internal render/state transition. Do not dereference
             * params.sections unless params actually exists.
             *
             * The "Searches" section is already declared in the widget
             * options above, so the SDK is responsible for adding it to
             * /search_suggestions requests. Do not mutate params.sections
             * manually here.
             */
            if (!params) {
              return params;
            }

            /*
             * SearchSuggestions does not reliably expose SearchResults-style
             * helpers such as getRequestState()/getQuery() to productList.
             * Keep the exact query used for THIS API request on the wrapper,
             * so predictive product ranking uses the real typed value.
             */
            if (
              typeof params.query === "string"
            ) {
              var incomingQuery = String(params.query || "").replace(/\*/g, "").trim().toLowerCase();
              var previousQuery = String(wrapper.dataset.tagalysPredictiveQuery || "").replace(/\*/g, "").trim().toLowerCase();

              if (incomingQuery !== previousQuery) {
                wrapper.dataset.tagalysPredictiveRequestedCount =
                  String(TagalysCustomisations.predictiveProductInitialVisible);
                delete wrapper.dataset.tagalysPredictiveTotalCount;
              }

              wrapper.dataset
                .tagalysPredictiveQuery =
                params.query;
            }

            if (
              TagalysCustomisations
                .predictiveCategoryDebug
            ) {
              console.groupCollapsed(
                "[Tagalys Predictive Debug] API request:",
                params.query || "(empty query)"
              );

              console.log(
                "params.query:",
                params.query
              );

              console.log(
                "stored wrapper query:",
                wrapper.dataset
                  .tagalysPredictiveQuery
              );

              console.log(
                "full SearchSuggestions params:",
                params
              );

              console.groupEnd();
            }

            var gender =
              TagalysCustomisations
                .getSelectedGenderValue(
                  wrapper
                );

            gender =
              TagalysCustomisations
                .setStoredSearchGender(
                  gender
                );

            /*
             * Keep the exact audience used for this predictive request.
             * This avoids a later sessionStorage/UI timing mismatch.
             */
            wrapper.dataset
              .tagalysPredictiveGender =
              gender;

            if (
              params.sections &&
              params.sections.products
            ) {
              /*
               * Keep normal typing fast: request only the first 20 products.
               * View More raises this limit by another 20 and re-runs the
               * same predictive query only when the customer asks for more.
               */
              var requestedProductCount = parseInt(
                wrapper.dataset.tagalysPredictiveRequestedCount ||
                String(TagalysCustomisations.predictiveProductInitialVisible),
                10
              );

              if (!Number.isFinite(requestedProductCount) || requestedProductCount < 1) {
                requestedProductCount = TagalysCustomisations.predictiveProductInitialVisible;
              }

              params.sections.products.count = requestedProductCount;

              var genderScope =
                TagalysCustomisations
                  .getGenderScopeValues(
                    gender
                  );

              if (genderScope.length) {
                params.sections.products.scope = {
                  "p.m.custom.gender":
                    genderScope
                };
              } else if (
                params.sections.products.scope
              ) {
                delete params.sections.products.scope;
              }
            }

            return params;
          },

          onSuccessfulAPICall: function (response) {
            /*
             * Rank + gender-mix the ACTUAL typed predictive response BEFORE
             * Tagalys renders it. This is independent of debug logging.
             */
            var predictiveProducts =
              response &&
              response.sections &&
              response.sections.products &&
              Array.isArray(
                response.sections.products.items
              )
                ? response.sections.products.items
                : [];

            var productSection =
              response && response.sections
                ? response.sections.products
                : null;

            var totalPredictiveProducts = Number(
              productSection &&
              (productSection.total_count != null
                ? productSection.total_count
                : productSection.totalCount)
            );

            if (Number.isFinite(totalPredictiveProducts)) {
              wrapper.dataset.tagalysPredictiveTotalCount =
                String(totalPredictiveProducts);
            }

            var predictiveQuery =
              wrapper.dataset
                .tagalysPredictiveQuery ||
              (
                response &&
                response.query
                  ? response.query
                  : ""
              ) ||
              "";

            var predictiveGender =
              TagalysCustomisations
                .normaliseSearchGender(
                  wrapper.dataset
                    .tagalysPredictiveGender ||
                  TagalysCustomisations
                    .getSelectedGenderValue(
                      wrapper
                    )
                );

            /*
             * Only typed predictive results are changed here.
             * Empty/base recommendation content is not touched.
             */
            if (
              predictiveProducts.length &&
              predictiveQuery.trim()
            ) {
              predictiveProducts =
                TagalysCustomisations
                  .rankSearchProductsFast(
                    predictiveProducts.slice(),
                    predictiveQuery,
                    predictiveGender
                  );

              response.sections.products.items =
                predictiveProducts;
            }

            if (
              TagalysCustomisations
                .predictiveCategoryDebug
            ) {
              window.__tagalysPredictiveDebugProducts =
                predictiveProducts;

              window.__tagalysPredictiveDebugResponse =
                response;

              console.group(
                "[Tagalys Predictive RAW] Products before render"
              );

              console.log(
                "Query:",
                predictiveQuery,
                "gender:",
                predictiveGender
              );

              console.table(
                predictiveProducts
                  .slice(0, 30)
                  .map(function (product, index) {
                    return {
                      position:
                        index + 1,

                      gender:
                        TagalysCustomisations
                          .getProductGenderForMix(
                            product
                          ),

                      title:
                        product.title ||
                        product.name ||
                        "",

                      product_type:
                        product.product_type ||
                        product.productType ||
                        product.type ||
                        "",

                      score:
                        TagalysCustomisations
                          .getFastCategoryPriorityScore(
                            product,
                            predictiveQuery
                          )
                    };
                  })
              );

              console.groupEnd();
            }

            /*
             * The request may complete after a gender switch/open transition.
             * Re-assert visibility and locally filter Collections / Pages
             * for the selected audience.
             */
            window.requestAnimationFrame(
              function () {
                updateVisibility();

                TagalysCustomisations
                  .filterPredictiveAuxiliarySuggestions(
                    wrapper
                  );

                refreshSearchTermSuggestions(
                  0
                );
              }
            );

            return response;
          },

          afterEveryRender: function () {
            updateVisibility();

            resultsContainer.style.removeProperty(
              "display"
            );

            TagalysCustomisations
              .filterPredictiveAuxiliarySuggestions(
                wrapper
              );

            /*
             * Tagalys has now rendered textSuggestionSection nodes.
             * Copy only section_id="Searches" into Threadbare's existing
             * top Search Suggestions container.
             */
            refreshSearchTermSuggestions(
              0
            );

            TagalysCustomisations
              .updatePredictiveSearchDrawerGeometry(
                wrapper
              );

            TagalysCustomisations
              .initTagalysCardEnhancements();

            window.requestAnimationFrame(
              function () {
                TagalysCustomisations
                  .updatePredictiveViewMore(
                    wrapper
                  );
              }
            );
          }
        }
    };

    searchSuggestionsOptions.failover =
      function () {
        if (
          !Tagalys.UIWidgets
            .ShopifySearchSuggestions ||
          typeof Tagalys.UIWidgets
            .ShopifySearchSuggestions.init !==
            "function"
        ) {
          console.error(
            "[Tagalys] ShopifySearchSuggestions failover widget is unavailable in this SDK."
          );
          return null;
        }

        console.warn(
          "[Tagalys] SearchSuggestions failed over to Shopify."
        );

        /*
         * beforeAPICall below is Tagalys-specific because it applies the
         * p.m.custom.gender scope to Tagalys sections. Do not pass that
         * callback to Shopify's GraphQL widget. The render callbacks are safe
         * to share and keep Threadbare's existing visibility/card behaviour.
         */
        /*
         * ShopifySearchSuggestions only accepts these section types:
         * queries, collections, products, pages, articles. The primary
         * Tagalys widget uses the custom section id "Searches", so create a
         * failover-only template/options copy and map that section to
         * Shopify's native "queries" type.
         */
        var shopifyTemplates =
          Object.assign(
            {},
            searchSuggestionsOptions.templates
          );

        var primaryWidgetTemplate =
          searchSuggestionsOptions.templates.widget ||
          {};

        var primaryWidgetOptions =
          primaryWidgetTemplate.options || {};

        var primarySections =
          primaryWidgetOptions.sections || {};

        var shopifySections = {
          products: Object.assign(
            {},
            primarySections.products || {},
            { count: 100 }
          ),
          collections: Object.assign(
            {},
            primarySections.collections || { count: 5 }
          ),
          pages: Object.assign(
            {},
            primarySections.pages || { count: 5 }
          ),
          queries: Object.assign(
            {},
            primarySections.Searches || { count: 5 }
          )
        };

        shopifyTemplates.widget =
          Object.assign(
            {},
            primaryWidgetTemplate,
            {
              options: Object.assign(
                {},
                primaryWidgetOptions,
                { sections: shopifySections }
              )
            }
          );

        /*
         * Shopify Predictive Search does not expose a documented metafield
         * filter/scope option equivalent to Tagalys'
         * sections.products.scope. Preserve the Threadbare All / Men / Women
         * experience in failover by filtering the returned product cards
         * locally when the product handle clearly identifies its audience.
         *
         * Threadbare product handles use `-mens-` / `-womens-`. Products that
         * do not have either marker are left visible (e.g. unisex/unknown) so
         * failover does not accidentally hide valid products. This logic runs
         * ONLY in ShopifySearchSuggestions failover; primary Tagalys still
         * uses the API scope.
         */
        if (shopifyTemplates.product &&
            typeof shopifyTemplates.product.render === "function") {
          var primaryProductRender =
            shopifyTemplates.product.render;

          shopifyTemplates.product =
            Object.assign(
              {},
              shopifyTemplates.product,
              {
                render: function (html, args) {
                  var product =
                    args && args.props
                      ? args.props.product
                      : null;

                  var gender =
                    TagalysCustomisations
                      .getSelectedGenderValue(
                        wrapper
                      );

                  var handle = String(
                    product && product.handle
                      ? product.handle
                      : ""
                  ).toLowerCase();

                  if (gender === "men" &&
                      handle.indexOf("-womens-") !== -1) {
                    return null;
                  }

                  if (gender === "women" &&
                      handle.indexOf("-mens-") !== -1) {
                    return null;
                  }

                  return primaryProductRender(
                    html,
                    args
                  );
                }
              }
            );
        }

        var failoverOptions = {
          searchResultsURL:
            searchSuggestionsOptions
              .searchResultsURL,

          productPageUrl:
            searchSuggestionsOptions
              .productPageUrl,

          templates:
            shopifyTemplates,

          callbacks: {
            afterEveryRender:
              searchSuggestionsOptions
                .callbacks
                .afterEveryRender
          }
        };

        return Tagalys.UIWidgets
          .ShopifySearchSuggestions.init(
            inputSelector,
            failoverOptions
          );
      };

    Tagalys.UIWidgets.SearchSuggestions.init(
      inputSelector,
      searchSuggestionsOptions
    );

    /* Initial empty-query recommendation widget. */
    TagalysCustomisations
      .initPredictiveRecommendations(
        recommendationsSelector,
        storedGender
      );

    /* -----------------------------------------------------
       Input / open / reset state
       ----------------------------------------------------- */
    searchInput.addEventListener(
      "input",
      function () {
        if (
          searchInput.value
            .trim()
            .length > 0
        ) {
          wrapper.dataset
            .tagalysRecentInputClicked =
            "false";
        }

        updateVisibility();
      }
    );

    searchInput.addEventListener(
      "search",
      function () {
        window.setTimeout(
          function () {
            refreshSearchTermSuggestions(
              0
            );

            refreshSuggestions({
              delay: 0,
              forceRecommendation: true
            });
          },
          0
        );
      }
    );

    if (
      searchInput.dataset
        .tagalysRecentInputClickListener !==
      "true"
    ) {
      searchInput.addEventListener(
        "click",
        function (event) {
          /*
           * Only a real customer click/tap should reveal Recent Searches.
           * Impulse's automatic focus when the drawer opens does not count.
           */
          if (
            event.isTrusted &&
            wrapper.dataset
              .tagalysSearchIsOpen ===
              "true" &&
            searchInput.value
              .trim()
              .length === 0
          ) {
            wrapper.dataset
              .tagalysRecentInputClicked =
              "true";

            TagalysCustomisations
              .renderRecentSearches(
                wrapper
              );
          }
        }
      );

      searchInput.dataset
        .tagalysRecentInputClickListener =
        "true";
    }

    searchInput.addEventListener(
      "focus",
      function () {
        /*
         * Focus fires when Impulse opens the drawer. If text was preserved
         * from the last close, force Tagalys to request it again.
         */
        if (
          searchInput.value
            .trim()
            .length > 0
        ) {
          refreshSuggestions({
            delay: 35
          });
        } else {
          updateVisibility();
          TagalysCustomisations
            .initPredictiveRecommendations(
              recommendationsSelector,
              TagalysCustomisations
                .getSelectedGenderValue(
                  wrapper
                )
            );
        }
      }
    );

    var resetButton =
      wrapper.querySelector(
        ".search__reset"
      );

    if (resetButton) {
      resetButton.addEventListener(
        "click",
        function () {
          window.setTimeout(
            function () {
              refreshSuggestions({
                delay: 0,
                forceRecommendation: true
              });
            },
            0
          );
        }
      );
    }

    /*
     * Impulse dispatches this every time the header search is opened.
     * This is more reliable than relying on a new input event, especially
     * when the field still contains the previous query.
     */
    document.addEventListener(
      "predictive-search:open",
      function (event) {
        if (
          event.detail &&
          event.detail.context &&
          event.detail.context !== context
        ) {
          return;
        }

        wrapper.dataset
          .tagalysSearchIsOpen =
          "true";

        wrapper.dataset
          .tagalysRecentInputClicked =
          "false";

        var recentContainer =
          wrapper.querySelector(
            recentSelector
          );

        if (recentContainer) {
          recentContainer.hidden =
            true;
        }

        TagalysCustomisations
          .setSearchOpenFromScrollState(
            true
          );

        TagalysCustomisations
          .lockMobilePredictiveSearchPage(
            wrapper
          );

        /*
         * Impulse adds .is-active immediately AFTER dispatching this event.
         * Recalculate on the next paint so the CSS variables reflect the
         * final active/sticky-header geometry rather than the pre-open state.
         */
        window.requestAnimationFrame(
          function () {
            TagalysCustomisations
              .updatePredictiveSearchDrawerGeometry(
                wrapper
              );
          }
        );

        window.setTimeout(
          function () {
            TagalysCustomisations
              .updatePredictiveSearchDrawerGeometry(
                wrapper
              );
          },
          60
        );

        window.setTimeout(
          function () {
            TagalysCustomisations
              .updatePredictiveSearchDrawerGeometry(
                wrapper
              );

            TagalysCustomisations
              .syncSearchGenderInputs(
                TagalysCustomisations
                  .getStoredSearchGender()
              );

            refreshSuggestions({
              delay: 0
            });
          },
          180
        );
      }
    );

    if (context === "header") {
      var updateDrawerGeometry = function () {
        var searchContainer =
          wrapper.closest(
            ".site-header__search-container"
          );

        if (
          searchContainer &&
          searchContainer.classList.contains(
            "is-active"
          )
        ) {
          TagalysCustomisations
            .updatePredictiveSearchDrawerGeometry(
              wrapper
            );
        }
      };

      var updateSuggestionVisibility =
        function () {
          TagalysCustomisations
            .filterPredictiveAuxiliarySuggestions(
              wrapper
            );

          TagalysCustomisations
            .syncTagalysSearchTermSuggestions(
              wrapper
            );
        };

      window.addEventListener(
        "resize",
        function () {
          updateDrawerGeometry();
          updateSuggestionVisibility();
        },
        { passive: true }
      );

      window.addEventListener(
        "scroll",
        updateDrawerGeometry,
        { passive: true }
      );

      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          "resize",
          function () {
            updateDrawerGeometry();
            updateSuggestionVisibility();
          },
          { passive: true }
        );

        window.visualViewport.addEventListener(
          "scroll",
          updateDrawerGeometry,
          { passive: true }
        );
      }

      window.addEventListener(
        "orientationchange",
        function () {
          window.setTimeout(
            function () {
              updateDrawerGeometry();
              updateSuggestionVisibility();
            },
            50
          );
        },
        { passive: true }
      );

      if (
        window.visualViewport &&
        window.visualViewport.addEventListener
      ) {
        window.visualViewport.addEventListener(
          "resize",
          updateDrawerGeometry,
          { passive: true }
        );
      }

      if (window.ResizeObserver) {
        var headerResizeObserver =
          new ResizeObserver(
            function () {
              updateDrawerGeometry();
            }
          );

        document
          .querySelectorAll(
            ".shopify-section-group-header-group"
          )
          .forEach(function (section) {
            headerResizeObserver.observe(
              section
            );
          });
      }
    }

    if (
      wrapper.dataset
        .tagalysRecentCloseListener !==
      "true"
    ) {
      document.addEventListener(
        "predictive-search:close-all",
        function () {
          var recentContainer =
            wrapper.querySelector(
              recentSelector
            );

          wrapper.dataset
            .tagalysSearchIsOpen =
            "false";

          wrapper.dataset
            .tagalysRecentInputClicked =
            "false";

          if (recentContainer) {
            recentContainer.hidden =
              true;
          }
        }
      );

      wrapper.dataset
        .tagalysRecentCloseListener =
        "true";
    }

    wrapper.dataset
      .tagalysSearchIsOpen =
      "false";

    wrapper.dataset
      .tagalysRecentInputClicked =
      "false";

    var initialRecentContainer =
      wrapper.querySelector(
        recentSelector
      );

    if (initialRecentContainer) {
      initialRecentContainer.hidden =
        true;
    }

    updateVisibility();

    searchInput.dataset
      .tagalysSuggestionsInitialized =
      "true";
  });

  TagalysCustomisations
    .initTagalysCardEnhancements();
};